<template>
  <div @click="goToRiskInsiderPage" class="home-button">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="home-button__icon">
          <svg
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              height="256px"
              viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve">
          <g>
	<g>
		<g>
			<g>
				<defs>
					<path id="SVGID_1_" d="M773.5,679.5v-0.4v-0.4c0-0.4,0-0.4,0-0.8v-4.6c0,0.4,0,0.4,0,0.8v0.4l-0.4,0.4l0,0
						c0,0.4-0.4,0.4-0.4,0.8l0,0c-0.4,0.4-0.4,0.4-0.8,0.8v4.6l0,0h0.4h0.4l0.4-0.4l0,0l0,0h0.4L773.5,679.5L773.5,679.5
						L773.5,679.5L773.5,679.5"/>
				</defs>
        <clipPath id="SVGID_00000008831009199987834200000016790338902931565227_">
					<use xlink:href="#SVGID_1_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000008831009199987834200000016790338902931565227_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000085953200139172309500000016715796082009274293_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000139270231186510776150000008514002419429441689_">
								<use xlink:href="#SVGID_00000085953200139172309500000016715796082009274293_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000139270231186510776150000008514002419429441689_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>
												<rect id="SVGID_00000052096889704519278240000010699172508044742826_" x="770.6" y="672.5"
                              width="4.6" height="8.7"/>
											</defs>
                      <clipPath id="SVGID_00000085231437114445702100000009317776110518689169_">
												<use xlink:href="#SVGID_00000052096889704519278240000010699172508044742826_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000085231437114445702100000009317776110518689169_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000005246118613025276730000002295817718676671406_" d="M773.5,679.5v-0.4v-0.4c0-0.4,0-0.4,0-0.8
																v-4.6c0,0.4,0,0.4,0,0.8v0.4l-0.4,0.4l0,0c0,0.4-0.4,0.4-0.4,0.8l0,0c-0.4,0.4-0.4,0.4-0.8,0.8v4.6l0,0h0.4h0.4
																l0.4-0.4l0,0l0,0h0.4L773.5,679.5L773.5,679.5L773.5,679.5L773.5,679.5"/>
														</defs>
                            <clipPath id="SVGID_00000147915811609365715900000013813790123659334815_">
															<use xlink:href="#SVGID_00000005246118613025276730000002295817718676671406_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000147915811609365715900000013813790123659334815_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000093158212135054322660000002665938928251432339_" x="770.6"
                                            y="672.5" width="4.6" height="8.7"/>
																	</defs>
                                  <clipPath id="SVGID_00000023272013189288363730000010612512305320061614_">
																		<use xlink:href="#SVGID_00000093158212135054322660000002665938928251432339_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="opacity:0;clip-path:url(#SVGID_00000023272013189288363730000010612512305320061614_);">
																		<g class="st5">
																			<g>
																				<g>
																					<g>
																						<defs>

																								<rect id="SVGID_00000119109732430591240890000014800388858828983212_"
                                                      x="770.6" y="672.5" width="4.6" height="8.7"/>
																						</defs>
                                            <clipPath id="SVGID_00000114075818638978624480000017883799044221790626_">
																							<use
                                                  xlink:href="#SVGID_00000119109732430591240890000014800388858828983212_"
                                                  style="overflow:visible;"/>
																						</clipPath>
																					</g>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
                              <g>
																<g>
																	<defs>

																			<rect id="SVGID_00000124884401232240126790000004616671700490147494_" x="770.6"
                                            y="672.5" width="4.6" height="8.7"/>
																	</defs>
                                  <clipPath id="SVGID_00000012458763024495405140000001798640959360255410_">
																		<use xlink:href="#SVGID_00000124884401232240126790000004616671700490147494_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="clip-path:url(#SVGID_00000012458763024495405140000001798640959360255410_);">
																		<g>
																			<g>
																				<g>
																					<defs>

																							<rect id="SVGID_00000085217329460749272980000015605206167769739668_"
                                                    x="770.6" y="672.5" width="4.6" height="8.7"/>
																					</defs>
                                          <clipPath id="SVGID_00000144311476243058984750000017892726667086467751_">
																						<use xlink:href="#SVGID_00000085217329460749272980000015605206167769739668_"
                                                 style="overflow:visible;"/>
																					</clipPath>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000174604051840770862560000017678128594639715238_" d="M773.5,671.6c-0.4-0.4-0.4-0.4-0.8-0.8
						c1.2,1.2,0.4,3.3-1.2,4.6l0.4,1.2C773.9,675,774.8,673.3,773.5,671.6"/>
				</defs>
        <clipPath id="SVGID_00000039833179167593070070000000934475122472990362_">
					<use xlink:href="#SVGID_00000174604051840770862560000017678128594639715238_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000039833179167593070070000000934475122472990362_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000092416570177083763660000010052010960051480990_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000148642449088705808230000004303037737001680527_">
								<use xlink:href="#SVGID_00000092416570177083763660000010052010960051480990_" style="overflow:visible;"/>
							</clipPath>

              <rect x="769" y="668.3"
                    style="clip-path:url(#SVGID_00000148642449088705808230000004303037737001680527_);fill:#3FB994;"
                    width="7.9" height="10.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000093886539328810792350000015664978547048725423_" d="M773.5,671.6c-0.4-0.4-0.4-0.4-0.8-0.8
						c1.2,1.2,0.4,3.3-1.2,4.6l0.4,1.2C773.9,675,774.8,673.3,773.5,671.6"/>
				</defs>
        <clipPath id="SVGID_00000064330295431733651990000003956461716696750779_">
					<use xlink:href="#SVGID_00000093886539328810792350000015664978547048725423_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000064330295431733651990000003956461716696750779_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000031890166939544845110000017281155053508313780_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000011011576749183672800000004928920258766622080_">
								<use xlink:href="#SVGID_00000031890166939544845110000017281155053508313780_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000011011576749183672800000004928920258766622080_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>
												<rect id="SVGID_00000028311056558291525260000005789053362446922392_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000057144395919597909730000002162134518240886400_">
												<use xlink:href="#SVGID_00000028311056558291525260000005789053362446922392_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000057144395919597909730000002162134518240886400_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000047060708576244301270000007015396914196451212_" points="771.4,675 771.9,676.6
																771.9,676.2 771.4,675 771.4,675 															"/>
														</defs>
                            <clipPath id="SVGID_00000022551465311570555760000018183511303804798604_">
															<use xlink:href="#SVGID_00000047060708576244301270000007015396914196451212_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000022551465311570555760000018183511303804798604_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000075882099087140306480000014989446102903267213_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000016786955958402288560000014030575586872711302_">
																		<use xlink:href="#SVGID_00000075882099087140306480000014989446102903267213_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="769" y="672.9"
                                        style="clip-path:url(#SVGID_00000016786955958402288560000014030575586872711302_);fill:#3FB994;"
                                        width="5" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000163058433534278155100000006007067853663322755_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000158006799455615509980000007491586384497835694_">
												<use xlink:href="#SVGID_00000163058433534278155100000006007067853663322755_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000158006799455615509980000007491586384497835694_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000083089211194674136850000012233352689566491794_" points="771.4,675 771.9,676.2
																772.3,676.2 771.9,675 771.4,675 															"/>
														</defs>
                            <clipPath id="SVGID_00000178203030224641028930000010671694416607998120_">
															<use xlink:href="#SVGID_00000083089211194674136850000012233352689566491794_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000178203030224641028930000010671694416607998120_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000076597879816311855430000010935388158274897026_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000155852981105800057550000008294238049106913924_">
																		<use xlink:href="#SVGID_00000076597879816311855430000010935388158274897026_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="769.4" y="672.9"
                                        style="clip-path:url(#SVGID_00000155852981105800057550000008294238049106913924_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000042731460396828665720000001388263284596093842_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000059292955705705015430000011596069745396320176_">
												<use xlink:href="#SVGID_00000042731460396828665720000001388263284596093842_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000059292955705705015430000011596069745396320176_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000114039139490628468570000008780552933486937015_" points="771.9,675 772.3,676.2
																772.7,676.2 771.9,675 771.9,675 															"/>
														</defs>
                            <clipPath id="SVGID_00000008858334146161230260000005325398917668349076_">
															<use xlink:href="#SVGID_00000114039139490628468570000008780552933486937015_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000008858334146161230260000005325398917668349076_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000160877592613308399900000002101154845586294944_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000035530088690642964570000009549858813439905685_">
																		<use xlink:href="#SVGID_00000160877592613308399900000002101154845586294944_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="769.4" y="672.5"
                                        style="clip-path:url(#SVGID_00000035530088690642964570000009549858813439905685_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000075877969636882610730000000899822967620786583_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000073714120856361499050000008007598511093093537_">
												<use xlink:href="#SVGID_00000075877969636882610730000000899822967620786583_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000073714120856361499050000008007598511093093537_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000011716883469640947530000012456758665438725799_" points="771.9,675 772.7,676.2
																772.7,675.8 772.3,674.5 771.9,675 															"/>
														</defs>
                            <clipPath id="SVGID_00000148661017716904516250000004475104816982795410_">
															<use xlink:href="#SVGID_00000011716883469640947530000012456758665438725799_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000148661017716904516250000004475104816982795410_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000031911444307364738060000012580721399251077556_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000018209474082977270490000018225341218597851529_">
																		<use xlink:href="#SVGID_00000031911444307364738060000012580721399251077556_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="769.8" y="672.5"
                                        style="clip-path:url(#SVGID_00000018209474082977270490000018225341218597851529_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000104673386757454447430000014925073597468373691_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000052067018194240210620000006492149084663824575_">
												<use xlink:href="#SVGID_00000104673386757454447430000014925073597468373691_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000052067018194240210620000006492149084663824575_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000081623788529388170920000002499356413506516919_" points="772.3,674.5 772.7,675.8
																773.1,675.8 772.3,674.5 772.3,674.5 															"/>
														</defs>
                            <clipPath id="SVGID_00000168102182693142274730000002717930282910609317_">
															<use xlink:href="#SVGID_00000081623788529388170920000002499356413506516919_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000168102182693142274730000002717930282910609317_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000012447414184288898640000002647185310644267137_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000090987003549053335690000000982146849534682293_">
																		<use xlink:href="#SVGID_00000012447414184288898640000002647185310644267137_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="769.8" y="672.1"
                                        style="clip-path:url(#SVGID_00000090987003549053335690000000982146849534682293_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000042698918624834000590000009787173387052902820_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000148628708746165440710000002513640298811457207_">
												<use xlink:href="#SVGID_00000042698918624834000590000009787173387052902820_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000148628708746165440710000002513640298811457207_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000134955337813439069250000017640627299980025274_" points="772.3,674.5 773.1,675.8
																773.1,675.4 772.7,674.1 772.3,674.5 															"/>
														</defs>
                            <clipPath id="SVGID_00000017500309622981459610000007285245319113570714_">
															<use xlink:href="#SVGID_00000134955337813439069250000017640627299980025274_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000017500309622981459610000007285245319113570714_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000005964622140603377080000012438538371841647787_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000066490636964024474730000007518501475746856870_">
																		<use xlink:href="#SVGID_00000005964622140603377080000012438538371841647787_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="770.2" y="672.1"
                                        style="clip-path:url(#SVGID_00000066490636964024474730000007518501475746856870_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000019657326856413269130000007632286808593048738_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000132808980457298907390000008105611094223573125_">
												<use xlink:href="#SVGID_00000019657326856413269130000007632286808593048738_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000132808980457298907390000008105611094223573125_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000058557737071579418960000008345166146873617317_" points="772.7,674.1 773.1,675.4
																773.5,675.4 772.7,674.1 772.7,674.1 															"/>
														</defs>
                            <clipPath id="SVGID_00000041265280767158194950000001048379306797983904_">
															<use xlink:href="#SVGID_00000058557737071579418960000008345166146873617317_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000041265280767158194950000001048379306797983904_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000021087719694104189400000008133542448309726606_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000068655088666208744720000010899934250123425421_">
																		<use xlink:href="#SVGID_00000021087719694104189400000008133542448309726606_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="770.2" y="671.6"
                                        style="clip-path:url(#SVGID_00000068655088666208744720000010899934250123425421_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000024689793580249488000000010067872182651927231_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000064325100929049905170000007661349482502295478_">
												<use xlink:href="#SVGID_00000024689793580249488000000010067872182651927231_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000064325100929049905170000007661349482502295478_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000129896264947270708940000004021529756391660440_" points="772.7,674.1 773.5,675.4
																773.5,675 772.7,673.7 772.7,674.1 															"/>
														</defs>
                            <clipPath id="SVGID_00000121264682811050808500000012619273249134095248_">
															<use xlink:href="#SVGID_00000129896264947270708940000004021529756391660440_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000121264682811050808500000012619273249134095248_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000175309343147132834990000013774544840625601173_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000134946273672420761260000004050186764398610857_">
																		<use xlink:href="#SVGID_00000175309343147132834990000013774544840625601173_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="770.6" y="671.6"
                                        style="clip-path:url(#SVGID_00000134946273672420761260000004050186764398610857_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000078755723922779147390000014931583719095776915_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000166655175874861731860000002803271121335456415_">
												<use xlink:href="#SVGID_00000078755723922779147390000014931583719095776915_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000166655175874861731860000002803271121335456415_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000043454190417790641480000000694305369722445462_" points="772.7,673.7 773.5,675 773.5,675
																773.1,673.7 772.7,673.7 															"/>
														</defs>
                            <clipPath id="SVGID_00000096754834446086953890000011399143550365345203_">
															<use xlink:href="#SVGID_00000043454190417790641480000000694305369722445462_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000096754834446086953890000011399143550365345203_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000044158125924956276180000013174892698665217926_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000172401269718359605670000013069172853020203420_">
																		<use xlink:href="#SVGID_00000044158125924956276180000013174892698665217926_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="770.6" y="671.2"
                                        style="clip-path:url(#SVGID_00000172401269718359605670000013069172853020203420_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000041984474325509803350000015838274284509254572_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000023984081603383205080000004429505959515193763_">
												<use xlink:href="#SVGID_00000041984474325509803350000015838274284509254572_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000023984081603383205080000004429505959515193763_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000060722462374270187220000010898554158552383647_" points="773.1,673.7 773.5,675
																773.9,674.5 773.1,673.3 773.1,673.7 															"/>
														</defs>
                            <clipPath id="SVGID_00000151508250732642524340000000452698337762519979_">
															<use xlink:href="#SVGID_00000060722462374270187220000010898554158552383647_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000151508250732642524340000000452698337762519979_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000148654602035501279300000015777044693523748769_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000104678147340258497240000005904602583352814002_">
																		<use xlink:href="#SVGID_00000148654602035501279300000015777044693523748769_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="770.6" y="671.2"
                                        style="clip-path:url(#SVGID_00000104678147340258497240000005904602583352814002_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000095301700326426089110000002645562726669723010_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000160903261395813374710000011968612728172934586_">
												<use xlink:href="#SVGID_00000095301700326426089110000002645562726669723010_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000160903261395813374710000011968612728172934586_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000062182798008354230010000001033991028648862848_" points="773.1,673.3 773.9,674.5
																773.9,674.1 773.1,672.9 773.1,673.3 															"/>
														</defs>
                            <clipPath id="SVGID_00000016772375644138380130000002282030205815866277_">
															<use xlink:href="#SVGID_00000062182798008354230010000001033991028648862848_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000016772375644138380130000002282030205815866277_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000035501796843659732180000010192058454289485453_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000006678963903168674820000009052192719350905728_">
																		<use xlink:href="#SVGID_00000035501796843659732180000010192058454289485453_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="771" y="670.8"
                                        style="clip-path:url(#SVGID_00000006678963903168674820000009052192719350905728_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000029033907986689582760000007674264769911204253_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000022550229782718643120000013444563203113534632_">
												<use xlink:href="#SVGID_00000029033907986689582760000007674264769911204253_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000022550229782718643120000013444563203113534632_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000139999231406161441230000006319248221078358703_" points="773.1,672.9 773.9,674.1
																773.9,673.7 773.5,672.5 773.1,672.9 															"/>
														</defs>
                            <clipPath id="SVGID_00000127727898510359359490000003974832537885852607_">
															<use xlink:href="#SVGID_00000139999231406161441230000006319248221078358703_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000127727898510359359490000003974832537885852607_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000156583114398286670610000009621192055779902342_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000018940665538126565570000012943458113000897701_">
																		<use xlink:href="#SVGID_00000156583114398286670610000009621192055779902342_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="771" y="670.4"
                                        style="clip-path:url(#SVGID_00000018940665538126565570000012943458113000897701_);fill:#3FB994;"
                                        width="5.4" height="6.2"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000145764189689760052090000004401973104023929534_" x="770.6" y="670.4"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000144332282420768055020000000106738208249243008_">
												<use xlink:href="#SVGID_00000145764189689760052090000004401973104023929534_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000144332282420768055020000000106738208249243008_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000066507563607334550510000006453220020982326460_" d="M773.5,672.5l0.8,1.2c0-0.8,0-1.2-0.4-2.1
																l-0.8-0.8C773.1,671.2,773.5,672.1,773.5,672.5"/>
														</defs>
                            <clipPath id="SVGID_00000114055460990733823300000001349052779523779983_">
															<use xlink:href="#SVGID_00000066507563607334550510000006453220020982326460_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000114055460990733823300000001349052779523779983_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000097472914413389028440000001758665863491609513_" x="770.6"
                                            y="670.4" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000102530886263955877690000004075128010810283649_">
																		<use xlink:href="#SVGID_00000097472914413389028440000001758665863491609513_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="770.6" y="668.3"
                                        style="clip-path:url(#SVGID_00000102530886263955877690000004075128010810283649_);fill:#3FB994;"
                                        width="5.8" height="7.5"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000167369760183813628220000005226869105770753196_" d="M562.1,722.6c0.4,0.4,0.4,0.4,0.8,0.8
						s0.8,0.8,1.7,1.2l-0.4-0.8C562.9,723.5,562.5,723,562.1,722.6"/>
				</defs>
        <clipPath id="SVGID_00000047055599672281928870000016983381555911351697_">
					<use xlink:href="#SVGID_00000167369760183813628220000005226869105770753196_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000047055599672281928870000016983381555911351697_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000054234205293244120500000012949898755827148698_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000141435496426347736530000007840009771607807882_">
								<use xlink:href="#SVGID_00000054234205293244120500000012949898755827148698_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000141435496426347736530000007840009771607807882_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>
												<rect id="SVGID_00000000189670993848506730000009351948170196161925_" x="561.3" y="721.8"
                              width="4.6" height="4.6"/>
											</defs>
                      <clipPath id="SVGID_00000089533866547502188380000004397438178146833333_">
												<use xlink:href="#SVGID_00000000189670993848506730000009351948170196161925_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000089533866547502188380000004397438178146833333_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000152985768032683780340000012629442775946168454_" points="562.1,722.6 562.5,723.5
																562.9,723.9 562.1,722.6 562.1,722.6 															"/>
														</defs>
                            <clipPath id="SVGID_00000096025406712296106890000012266829289611344551_">
															<use xlink:href="#SVGID_00000152985768032683780340000012629442775946168454_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000096025406712296106890000012266829289611344551_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000013893351542882745740000006514635999176032697_" x="561.3"
                                            y="721.8" width="4.6" height="4.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000070090516453586780780000016332992082213520013_">
																		<use xlink:href="#SVGID_00000013893351542882745740000006514635999176032697_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.6" y="720.1"
                                        style="clip-path:url(#SVGID_00000070090516453586780780000016332992082213520013_);fill:#306175;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000174574922830630715980000000140209454923299492_" x="561.3" y="721.8"
                              width="4.6" height="4.6"/>
											</defs>
                      <clipPath id="SVGID_00000142860462479834930560000001422047276646592914_">
												<use xlink:href="#SVGID_00000174574922830630715980000000140209454923299492_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000142860462479834930560000001422047276646592914_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000015343341093388757090000017609052135715071932_" d="M562.1,722.6l0.8,0.8l0.4,0.4l-0.4-0.8
																C562.5,723,562.5,723,562.1,722.6"/>
														</defs>
                            <clipPath id="SVGID_00000072976070709172184080000008185856230149071754_">
															<use xlink:href="#SVGID_00000015343341093388757090000017609052135715071932_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000072976070709172184080000008185856230149071754_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000086691839354603912240000007857834554584231575_" x="561.3"
                                            y="721.8" width="4.6" height="4.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000046335617054311313410000016873243960821132713_">
																		<use xlink:href="#SVGID_00000086691839354603912240000007857834554584231575_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="560" y="720.6"
                                        style="clip-path:url(#SVGID_00000046335617054311313410000016873243960821132713_);fill:#32657A;"
                                        width="5.8" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000100354002119237862060000013504292443493951659_" x="561.3" y="721.8"
                              width="4.6" height="4.6"/>
											</defs>
                      <clipPath id="SVGID_00000055698585096933707710000017366325880579404176_">
												<use xlink:href="#SVGID_00000100354002119237862060000013504292443493951659_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000055698585096933707710000017366325880579404176_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000023993773935686534490000013416786826856944788_" d="M562.9,723.5l0.4,0.8l0.4,0.4l-0.4-0.8
																C563.3,723.5,562.9,723.5,562.9,723.5"/>
														</defs>
                            <clipPath id="SVGID_00000031170715761036299110000018146207969156235431_">
															<use xlink:href="#SVGID_00000023993773935686534490000013416786826856944788_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000031170715761036299110000018146207969156235431_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000085936290065231897170000018220835796897671324_" x="561.3"
                                            y="721.8" width="4.6" height="4.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000026136864274910767890000008080918596371197079_">
																		<use xlink:href="#SVGID_00000085936290065231897170000018220835796897671324_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="560.4" y="721"
                                        style="clip-path:url(#SVGID_00000026136864274910767890000008080918596371197079_);fill:#34697F;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000133492973939094898720000000376493918521355936_" x="561.3" y="721.8"
                              width="4.6" height="4.6"/>
											</defs>
                      <clipPath id="SVGID_00000155827234824935260700000001083608233394559388_">
												<use xlink:href="#SVGID_00000133492973939094898720000000376493918521355936_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000155827234824935260700000001083608233394559388_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000150796526643277350740000000027065672738625680_" points="563.3,723.9 564.2,724.7
																564.2,724.7 563.7,723.9 563.3,723.9 															"/>
														</defs>
                            <clipPath id="SVGID_00000029045462629085784540000010903774782073615251_">
															<use xlink:href="#SVGID_00000150796526643277350740000000027065672738625680_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000029045462629085784540000010903774782073615251_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000183245485977479523760000008613855685687535777_" x="561.3"
                                            y="721.8" width="4.6" height="4.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000156585308337232315510000014291360011509858484_">
																		<use xlink:href="#SVGID_00000183245485977479523760000008613855685687535777_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="561.3" y="721.4"
                                        style="clip-path:url(#SVGID_00000156585308337232315510000014291360011509858484_);fill:#366C82;"
                                        width="5" height="5.4"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000033360352853794828220000009565325232857152181_" d="M563.7,719.3c-0.4-0.4-0.8-0.4-0.8-0.8l0,0
						c-0.4-0.4-0.4-0.4-0.8-0.8l0,0c0-0.4-0.4-0.4-0.4-0.8l0,0c0-0.4,0-0.4,0-0.8v4.6v0.4v0.4l0,0l0,0v0.4v0.4l0,0l0,0l0,0v0.4
						l0.4,0.4l0,0l0,0l0,0h0.4h0.4h0.4l0,0L563.7,719.3"/>
				</defs>
        <clipPath id="SVGID_00000044857227977421947360000009960973289168277695_">
					<use xlink:href="#SVGID_00000033360352853794828220000009565325232857152181_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000044857227977421947360000009960973289168277695_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000091731939437376263850000009796443562923084161_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000027595261643961813390000012092478977023534772_">
								<use xlink:href="#SVGID_00000091731939437376263850000009796443562923084161_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000027595261643961813390000012092478977023534772_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>
												<rect id="SVGID_00000145751102148415842430000015688110498800547716_" x="561.3" y="715.2"
                              width="4.6" height="8.7"/>
											</defs>
                      <clipPath id="SVGID_00000097499090950500060470000009707565521267856802_">
												<use xlink:href="#SVGID_00000145751102148415842430000015688110498800547716_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000097499090950500060470000009707565521267856802_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000090996194548284927620000006803312798860436362_" d="M563.7,719.3c-0.4-0.4-0.8-0.4-0.8-0.8l0,0
																c-0.4-0.4-0.4-0.4-0.8-0.8l0,0c0-0.4-0.4-0.4-0.4-0.8l0,0c0-0.4,0-0.4,0-0.8v4.6v0.4v0.4l0,0l0,0v0.4v0.4l0,0l0,0
																l0,0v0.4l0.4,0.4l0,0l0,0l0,0h0.4h0.4h0.4l0,0L563.7,719.3"/>
														</defs>
                            <clipPath id="SVGID_00000037679597611288219930000008391137535429533609_">
															<use xlink:href="#SVGID_00000090996194548284927620000006803312798860436362_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000037679597611288219930000008391137535429533609_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000040538253633981747260000014834662837807524019_" x="561.3"
                                            y="715.2" width="4.6" height="8.7"/>
																	</defs>
                                  <clipPath id="SVGID_00000026157867848305765420000017166686072893535126_">
																		<use xlink:href="#SVGID_00000040538253633981747260000014834662837807524019_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="opacity:0;clip-path:url(#SVGID_00000026157867848305765420000017166686072893535126_);">
																		<g class="st5">
																			<g>
																				<g>
																					<g>
																						<defs>

																								<rect id="SVGID_00000111162039309142735270000005314663435041017741_"
                                                      x="561.3" y="715.2" width="4.6" height="8.7"/>
																						</defs>
                                            <clipPath id="SVGID_00000064324996304065107010000013000555839888066474_">
																							<use
                                                  xlink:href="#SVGID_00000111162039309142735270000005314663435041017741_"
                                                  style="overflow:visible;"/>
																						</clipPath>
																					</g>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
                              <g>
																<g>
																	<defs>

																			<rect id="SVGID_00000114787915617630807840000002686238622595525562_" x="561.3"
                                            y="715.2" width="4.6" height="8.7"/>
																	</defs>
                                  <clipPath id="SVGID_00000012465696016577079210000016859726483350042281_">
																		<use xlink:href="#SVGID_00000114787915617630807840000002686238622595525562_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="clip-path:url(#SVGID_00000012465696016577079210000016859726483350042281_);">
																		<g>
																			<g>
																				<g>
																					<defs>

																							<rect id="SVGID_00000120521186396933356000000000465326605849958294_"
                                                    x="561.3" y="715.2" width="4.6" height="8.7"/>
																					</defs>
                                          <clipPath id="SVGID_00000107550333791781825610000000830217919923093175_">
																						<use xlink:href="#SVGID_00000120521186396933356000000000465326605849958294_"
                                                 style="overflow:visible;"/>
																					</clipPath>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000173143331712574826920000007086686026122953401_" d="M562.5,713.5L562.5,713.5L562.5,713.5L562.5,713.5
						L562.5,713.5L562.5,713.5L562.5,713.5l-0.4,0.4l0,0l0,0l0,0l0,0l0,0l0,0c-1.2,1.7-0.4,3.7,1.7,5l0.4-1.2
						C562.1,716.8,561.7,714.8,562.5,713.5"/>
				</defs>
        <clipPath id="SVGID_00000152259013135920248080000014926695382100325788_">
					<use xlink:href="#SVGID_00000173143331712574826920000007086686026122953401_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000152259013135920248080000014926695382100325788_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000027594573794994705710000010449591021317857467_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000140707893163316247000000007652746448603474842_">
								<use xlink:href="#SVGID_00000027594573794994705710000010449591021317857467_" style="overflow:visible;"/>
							</clipPath>

              <rect x="558.4" y="711"
                    style="clip-path:url(#SVGID_00000140707893163316247000000007652746448603474842_);fill:#3FB994;"
                    width="7.9" height="10.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000070808245625417199910000011773339644230455473_" d="M562.5,713.5L562.5,713.5L562.5,713.5L562.5,713.5
						L562.5,713.5L562.5,713.5L562.5,713.5l-0.4,0.4l0,0l0,0l0,0l0,0l0,0l0,0c-1.2,1.7-0.4,3.7,1.7,5l0.4-1.2
						C562.1,716.8,561.7,714.8,562.5,713.5"/>
				</defs>
        <clipPath id="SVGID_00000160875413253772186660000002047278561605945772_">
					<use xlink:href="#SVGID_00000070808245625417199910000011773339644230455473_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000160875413253772186660000002047278561605945772_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000000209589860078390140000014213324815551295410_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000132058848528248698180000006947966797370832547_">
								<use xlink:href="#SVGID_00000000209589860078390140000014213324815551295410_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000132058848528248698180000006947966797370832547_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>
												<rect id="SVGID_00000157291469479340941230000006496562622720693180_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000034772081490418627860000010972317807413074354_">
												<use xlink:href="#SVGID_00000157291469479340941230000006496562622720693180_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000034772081490418627860000010972317807413074354_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000106143678802167525770000001619245226108489112_" d="M562.5,713.5l-0.8,0.8
																c-0.4,0.4-0.4,0.8-0.4,0.8l0.8-0.8C562.1,713.9,562.5,713.9,562.5,713.5"/>
														</defs>
                            <clipPath id="SVGID_00000049199851374664821430000005941018227870713016_">
															<use xlink:href="#SVGID_00000106143678802167525770000001619245226108489112_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000049199851374664821430000005941018227870713016_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000099650770097962410110000016924377219721932956_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000013884976640033437940000010509428173735701680_">
																		<use xlink:href="#SVGID_00000099650770097962410110000016924377219721932956_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.2" y="711"
                                        style="clip-path:url(#SVGID_00000013884976640033437940000010509428173735701680_);fill:#3FB994;"
                                        width="5.4" height="6.2"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000041267919349646778150000005441710785041042571_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000049936143893948703190000013250746729126123400_">
												<use xlink:href="#SVGID_00000041267919349646778150000005441710785041042571_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000049936143893948703190000013250746729126123400_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000090996058568909874520000014634648635884377746_" points="562.1,714.3 561.3,715.2
																561.3,716 562.1,714.8 562.1,714.3 															"/>
														</defs>
                            <clipPath id="SVGID_00000170267355784489971370000012213616952586320008_">
															<use xlink:href="#SVGID_00000090996058568909874520000014634648635884377746_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000170267355784489971370000012213616952586320008_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000009560277374848936760000011014917411758288830_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000129186754190744541480000009000819865767826610_">
																		<use xlink:href="#SVGID_00000009560277374848936760000011014917411758288830_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.2" y="712.3"
                                        style="clip-path:url(#SVGID_00000129186754190744541480000009000819865767826610_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000105406279499429613710000006590214213971434151_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000032628894351521459980000010316877322526485408_">
												<use xlink:href="#SVGID_00000105406279499429613710000006590214213971434151_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000032628894351521459980000010316877322526485408_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000109735145101767304830000017750328347611854780_" points="562.1,714.8 561.3,716
																561.3,716.4 562.1,715.2 562.1,714.8 															"/>
														</defs>
                            <clipPath id="SVGID_00000097498897082012409760000007620327042775024789_">
															<use xlink:href="#SVGID_00000109735145101767304830000017750328347611854780_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000097498897082012409760000007620327042775024789_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000142171082038744188730000009772455584472062349_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000103230001153430374370000008098788359652078217_">
																		<use xlink:href="#SVGID_00000142171082038744188730000009772455584472062349_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.2" y="712.7"
                                        style="clip-path:url(#SVGID_00000103230001153430374370000008098788359652078217_);fill:#3FB994;"
                                        width="5" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000061459062012704236690000006383217725734584501_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000115485953083038181730000016364189124934625687_">
												<use xlink:href="#SVGID_00000061459062012704236690000006383217725734584501_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000115485953083038181730000016364189124934625687_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000166642647953792309080000007292878295616588695_" points="562.1,715.2 561.3,716.4
																561.3,716.4 562.1,715.6 562.1,715.2 															"/>
														</defs>
                            <clipPath id="SVGID_00000096052295654485653490000010240287077824078781_">
															<use xlink:href="#SVGID_00000166642647953792309080000007292878295616588695_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000096052295654485653490000010240287077824078781_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000107575514491476963510000005149960721418233247_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000113324543246129544630000013568420998881516691_">
																		<use xlink:href="#SVGID_00000107575514491476963510000005149960721418233247_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.2" y="713.1"
                                        style="clip-path:url(#SVGID_00000113324543246129544630000013568420998881516691_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000158019733466491992950000001926332060655773885_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000034803056879758907330000014086140496532017339_">
												<use xlink:href="#SVGID_00000158019733466491992950000001926332060655773885_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000034803056879758907330000014086140496532017339_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000174581883449591639890000000765190998208180368_" points="562.1,715.6 561.3,716.4
																561.3,716.8 562.1,715.6 562.1,715.6 															"/>
														</defs>
                            <clipPath id="SVGID_00000088821255017562480510000007607539739116728747_">
															<use xlink:href="#SVGID_00000174581883449591639890000000765190998208180368_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000088821255017562480510000007607539739116728747_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000061434222570741657350000013822753879322890898_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000146465923919660581110000018262746262365799076_">
																		<use xlink:href="#SVGID_00000061434222570741657350000013822753879322890898_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.2" y="713.1"
                                        style="clip-path:url(#SVGID_00000146465923919660581110000018262746262365799076_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000070115729800976342740000018011535984065022396_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000178887744065733746010000007081256860131074477_">
												<use xlink:href="#SVGID_00000070115729800976342740000018011535984065022396_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000178887744065733746010000007081256860131074477_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000145027910591670133630000009040725655333427859_" points="562.1,715.6 561.3,716.8
																561.7,717.2 562.1,716 562.1,715.6 															"/>
														</defs>
                            <clipPath id="SVGID_00000083082024932717703390000001020474431399640450_">
															<use xlink:href="#SVGID_00000145027910591670133630000009040725655333427859_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000083082024932717703390000001020474431399640450_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000133527560742744731730000001347314896092860836_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000127746698524953669810000005091058509436077994_">
																		<use xlink:href="#SVGID_00000133527560742744731730000001347314896092860836_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.2" y="713.5"
                                        style="clip-path:url(#SVGID_00000127746698524953669810000005091058509436077994_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000016072127288295474690000009968147157260151480_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000127765767327546315060000008088592792499696563_">
												<use xlink:href="#SVGID_00000016072127288295474690000009968147157260151480_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000127765767327546315060000008088592792499696563_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000076578407878284219850000014195523172707061128_" points="562.1,716 561.7,717.2
																561.7,717.2 562.1,716 562.1,716 															"/>
														</defs>
                            <clipPath id="SVGID_00000067223916496437202940000015074723032095837319_">
															<use xlink:href="#SVGID_00000076578407878284219850000014195523172707061128_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000067223916496437202940000015074723032095837319_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000038388614395542262250000013254033791033769879_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000086684410585552185010000015546268638355575964_">
																		<use xlink:href="#SVGID_00000038388614395542262250000013254033791033769879_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.2" y="713.5"
                                        style="clip-path:url(#SVGID_00000086684410585552185010000015546268638355575964_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000137813103818377773280000005754403587616261303_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000171691755609259958600000002483222406713836471_">
												<use xlink:href="#SVGID_00000137813103818377773280000005754403587616261303_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000171691755609259958600000002483222406713836471_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000077303515172161481360000001072029597413738934_" points="562.1,716 561.7,717.2
																561.7,717.7 562.5,716.4 562.1,716 															"/>
														</defs>
                            <clipPath id="SVGID_00000092437775394233243280000009196279391678021523_">
															<use xlink:href="#SVGID_00000077303515172161481360000001072029597413738934_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000092437775394233243280000009196279391678021523_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000011001314870295476230000013949936516014758569_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000012458805124534223340000006010035386182688181_">
																		<use xlink:href="#SVGID_00000011001314870295476230000013949936516014758569_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.2" y="713.9"
                                        style="clip-path:url(#SVGID_00000012458805124534223340000006010035386182688181_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000163066353063884981710000013184979338723843509_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000163067477057518576720000014717721729797672065_">
												<use xlink:href="#SVGID_00000163066353063884981710000013184979338723843509_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000163067477057518576720000014717721729797672065_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000147935396049826292780000008501147009618660533_" points="562.5,716.4 561.7,717.7
																561.7,717.7 562.5,716.4 562.5,716.4 															"/>
														</defs>
                            <clipPath id="SVGID_00000147194140065772973190000010560540861886108573_">
															<use xlink:href="#SVGID_00000147935396049826292780000008501147009618660533_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000147194140065772973190000010560540861886108573_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000096059860538897661800000015557043272623256485_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000054264597046761617240000017777333403030551476_">
																		<use xlink:href="#SVGID_00000096059860538897661800000015557043272623256485_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.6" y="713.9"
                                        style="clip-path:url(#SVGID_00000054264597046761617240000017777333403030551476_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000176033284996025914020000013395395084765213363_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000021807703782801998600000017017171712735125134_">
												<use xlink:href="#SVGID_00000176033284996025914020000013395395084765213363_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000021807703782801998600000017017171712735125134_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000137107134549060300130000010339328900960782743_" points="562.5,716.4 561.7,717.7
																562.1,718.1 562.5,716.8 562.5,716.4 															"/>
														</defs>
                            <clipPath id="SVGID_00000037690213059840012220000010201758345619756689_">
															<use xlink:href="#SVGID_00000137107134549060300130000010339328900960782743_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000037690213059840012220000010201758345619756689_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000153664607727338439860000014869315533050649018_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000101813380336778684860000016204818133285232537_">
																		<use xlink:href="#SVGID_00000153664607727338439860000014869315533050649018_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.6" y="714.3"
                                        style="clip-path:url(#SVGID_00000101813380336778684860000016204818133285232537_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000177454714142543936000000013364006160656609210_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000177459758220615132850000015707857951455930248_">
												<use xlink:href="#SVGID_00000177454714142543936000000013364006160656609210_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000177459758220615132850000015707857951455930248_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000083804336201905743880000005373858492609239448_" points="562.5,716.8 562.1,718.1
																562.1,718.1 562.9,716.8 562.5,716.8 															"/>
														</defs>
                            <clipPath id="SVGID_00000000932525152397634700000016777329218700168838_">
															<use xlink:href="#SVGID_00000083804336201905743880000005373858492609239448_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000000932525152397634700000016777329218700168838_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000139271387492581220320000014282607950557971344_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000130612727597091159500000003503696823988031128_">
																		<use xlink:href="#SVGID_00000139271387492581220320000014282607950557971344_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="559.6" y="714.3"
                                        style="clip-path:url(#SVGID_00000130612727597091159500000003503696823988031128_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000114781286734315879580000006061427401953379464_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000134233466483341193440000008240817206331981752_">
												<use xlink:href="#SVGID_00000114781286734315879580000006061427401953379464_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000134233466483341193440000008240817206331981752_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000131345763505077158360000010543364024007489425_" points="562.9,716.8 562.1,718.1
																562.5,718.5 562.9,716.8 562.9,716.8 															"/>
														</defs>
                            <clipPath id="SVGID_00000038399050637732243340000012998236910975169188_">
															<use xlink:href="#SVGID_00000131345763505077158360000010543364024007489425_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000038399050637732243340000012998236910975169188_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000152977976240968154370000013393099915258689450_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000089561349063323064730000012455583973394067094_">
																		<use xlink:href="#SVGID_00000152977976240968154370000013393099915258689450_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="560" y="714.8"
                                        style="clip-path:url(#SVGID_00000089561349063323064730000012455583973394067094_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000070107403190191124270000017213392282254475452_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000003071789558368416160000007142918719306302088_">
												<use xlink:href="#SVGID_00000070107403190191124270000017213392282254475452_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000003071789558368416160000007142918719306302088_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000060716108868922257610000015989221388376873884_" points="562.9,716.8 562.5,718.5
																562.5,718.5 562.9,717.2 562.9,716.8 															"/>
														</defs>
                            <clipPath id="SVGID_00000157281393325392406180000015609745390086389668_">
															<use xlink:href="#SVGID_00000060716108868922257610000015989221388376873884_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000157281393325392406180000015609745390086389668_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000152249779610114848240000013594703905959688843_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000152942518320201226350000010023489067891447957_">
																		<use xlink:href="#SVGID_00000152249779610114848240000013594703905959688843_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="560" y="714.8"
                                        style="clip-path:url(#SVGID_00000152942518320201226350000010023489067891447957_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000152950373927057205330000007661681060990366085_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000113341150122120269350000014240305800554118843_">
												<use xlink:href="#SVGID_00000152950373927057205330000007661681060990366085_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000113341150122120269350000014240305800554118843_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000121259699075813657700000001118224359000348039_" points="562.9,717.2 562.5,718.5
																562.9,718.5 563.3,717.2 562.9,717.2 															"/>
														</defs>
                            <clipPath id="SVGID_00000075857765431576420230000017633206299360958896_">
															<use xlink:href="#SVGID_00000121259699075813657700000001118224359000348039_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000075857765431576420230000017633206299360958896_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000156585402380423398820000004783220248057634731_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000061469309392842661920000002984263499425450668_">
																		<use xlink:href="#SVGID_00000156585402380423398820000004783220248057634731_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="560.4" y="715.2"
                                        style="clip-path:url(#SVGID_00000061469309392842661920000002984263499425450668_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000089555458218675492550000000306218758182994608_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000134243825712631558680000005876551765662134691_">
												<use xlink:href="#SVGID_00000089555458218675492550000000306218758182994608_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000134243825712631558680000005876551765662134691_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000054983441671361703730000013571816448020237965_" points="563.3,717.2 562.9,718.5
																562.9,718.9 563.3,717.7 563.3,717.2 															"/>
														</defs>
                            <clipPath id="SVGID_00000020399361679967650080000008188159679253529002_">
															<use xlink:href="#SVGID_00000054983441671361703730000013571816448020237965_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000020399361679967650080000008188159679253529002_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000083801929653621202550000002885716756382064553_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000171705735471828780710000007175843332284786820_">
																		<use xlink:href="#SVGID_00000083801929653621202550000002885716756382064553_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="560.4" y="715.2"
                                        style="clip-path:url(#SVGID_00000171705735471828780710000007175843332284786820_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000044143485283476459970000016784721654574846878_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000072265797603761781220000009572102655662863779_">
												<use xlink:href="#SVGID_00000044143485283476459970000016784721654574846878_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000072265797603761781220000009572102655662863779_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000178175715699821146000000013845833998281190273_" points="563.3,717.7 562.9,718.9
																563.3,718.9 563.7,717.7 563.3,717.7 															"/>
														</defs>
                            <clipPath id="SVGID_00000005986146101971642520000003822669385759636864_">
															<use xlink:href="#SVGID_00000178175715699821146000000013845833998281190273_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000005986146101971642520000003822669385759636864_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000069388976694370465240000005390108289490327686_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000099646033975246900900000009887394353583725985_">
																		<use xlink:href="#SVGID_00000069388976694370465240000005390108289490327686_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="560.8" y="715.2"
                                        style="clip-path:url(#SVGID_00000099646033975246900900000009887394353583725985_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000145767734618676244610000009932211683970362298_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000151534943993661669060000012915799150295323310_">
												<use xlink:href="#SVGID_00000145767734618676244610000009932211683970362298_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000151534943993661669060000012915799150295323310_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000167389550249176241770000003123917873638182564_" points="563.7,717.7 563.3,718.9
																563.3,719.3 563.7,717.7 563.7,717.7 															"/>
														</defs>
                            <clipPath id="SVGID_00000103978327763587025820000013304197748512988831_">
															<use xlink:href="#SVGID_00000167389550249176241770000003123917873638182564_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000103978327763587025820000013304197748512988831_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000115516480716164741260000009515086214972054675_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000080185358166389541060000012347213779559778182_">
																		<use xlink:href="#SVGID_00000115516480716164741260000009515086214972054675_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="560.8" y="715.6"
                                        style="clip-path:url(#SVGID_00000080185358166389541060000012347213779559778182_);fill:#3FB994;"
                                        width="5.4" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000123419862538018759510000001942316979902468736_" x="561.3" y="712.7"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000021840448236398196040000013110772788023616413_">
												<use xlink:href="#SVGID_00000123419862538018759510000001942316979902468736_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000021840448236398196040000013110772788023616413_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000011019578085008221250000000876594063751762563_" points="563.7,717.7 563.3,719.3
																563.7,719.3 564.2,717.7 563.7,717.7 															"/>
														</defs>
                            <clipPath id="SVGID_00000169534380256909175760000002019353489798711947_">
															<use xlink:href="#SVGID_00000011019578085008221250000000876594063751762563_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000169534380256909175760000002019353489798711947_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000010301103488879566610000002527227978360818586_" x="558.8"
                                            y="712.7" width="6.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000078747214065808089630000015333904107137266079_">
																		<use xlink:href="#SVGID_00000010301103488879566610000002527227978360818586_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="561.3" y="715.6"
                                        style="clip-path:url(#SVGID_00000078747214065808089630000015333904107137266079_);fill:#3FB994;"
                                        width="5" height="5.8"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000068647378876559000770000001650058729069464466_" d="M772.3,680.8L772.3,680.8l-133.1,79.2
						c-0.4,0.4-0.8,0.4-1.2,0.4l0,0c-0.4,0-0.8,0.4-1.2,0.4h-0.4c-0.4,0-0.8,0-1.2,0.4l0,0l0,0c-0.8,0-1.2,0-2.1,0h-0.4
						c-0.8,0-1.2,0-2.1-0.4c-0.4,0-0.8,0-1.2-0.4l0,0c-0.4,0-0.8-0.4-1.2-0.4l-64.7-36.5l0.4,0.8l64.7,36.5l0.4,0.4
						c0,0,0.4,0,0.4,0.4l0,0l0,0c0.4,0,0.4,0,0.8,0.4l0,0c0.4,0,1.2,0.4,1.7,0.4h0.4c0.4,0,1.2,0,1.7,0l0,0l0,0l0,0
						c0.4,0,0.4,0,0.8,0l0,0h0.4h0.4c0.4,0,0.4,0,0.8-0.4l0,0l0,0c0.4,0,0.4,0,0.8-0.4l0.4-0.4L770.2,682c0.4-0.4,1.2-0.8,1.7-1.2
						l0.8-0.8C773.1,680.3,772.7,680.8,772.3,680.8"/>
				</defs>
        <clipPath id="SVGID_00000030450208701350671680000016447042327748228762_">
					<use xlink:href="#SVGID_00000068647378876559000770000001650058729069464466_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000030450208701350671680000016447042327748228762_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000049936385628154840200000017765346674835395971_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000082367077017306216860000014437245141691449258_">
								<use xlink:href="#SVGID_00000049936385628154840200000017765346674835395971_" style="overflow:visible;"/>
							</clipPath>

              <rect x="561.3" y="677.4"
                    style="clip-path:url(#SVGID_00000082367077017306216860000014437245141691449258_);fill:#154C3D;"
                    width="214.3" height="87.1"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000121251855418373487180000007346370803607740078_" points="639.2,755.4 639.2,760.4 771.9,681.2
						771.9,676.6 639.2,755.4 					"/>
				</defs>
        <clipPath id="SVGID_00000171706470952693880050000016578525451037734320_">
					<use xlink:href="#SVGID_00000121251855418373487180000007346370803607740078_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000171706470952693880050000016578525451037734320_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000106855155433015590830000005825956169525686953_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000060737409080696204560000004911314575041405872_">
								<use xlink:href="#SVGID_00000106855155433015590830000005825956169525686953_" style="overflow:visible;"/>
							</clipPath>

              <rect x="636.7" y="674.1"
                    style="clip-path:url(#SVGID_00000060737409080696204560000004911314575041405872_);fill:#226A57;"
                    width="137.2" height="88.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000065043455484623401270000000273419207693818498_" points="563.7,719.3 563.7,723.9 628.4,760.4
						628.4,755.8 563.7,719.3 					"/>
				</defs>
        <clipPath id="SVGID_00000029737109896297687060000001389709579619295135_">
					<use xlink:href="#SVGID_00000065043455484623401270000000273419207693818498_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000029737109896297687060000001389709579619295135_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000080925316523657824420000007119625797057471658_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000023986146002567659850000004712530044030097835_">
								<use xlink:href="#SVGID_00000080925316523657824420000007119625797057471658_" style="overflow:visible;"/>
							</clipPath>

              <rect x="561.3" y="716.8"
                    style="clip-path:url(#SVGID_00000023986146002567659850000004712530044030097835_);fill:#226A57;"
                    width="69.2" height="45.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000111906734398168371580000011604502884523948966_" points="638.4,754.1 639.2,755.4 771.9,676.6
						771.4,675 638.4,754.1 					"/>
				</defs>
        <clipPath id="SVGID_00000155126087495423846700000010136317225016480166_">
					<use xlink:href="#SVGID_00000111906734398168371580000011604502884523948966_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000155126087495423846700000010136317225016480166_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000019665937363181058110000015152296777263504261_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000115480395730601808550000001574461084103465658_">
								<use xlink:href="#SVGID_00000019665937363181058110000015152296777263504261_" style="overflow:visible;"/>
							</clipPath>

              <rect x="636.3" y="672.9"
                    style="clip-path:url(#SVGID_00000115480395730601808550000001574461084103465658_);fill:#3FB994;"
                    width="137.6" height="85"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000067943026755415762590000003910863759465024419_" points="564.2,717.7 563.7,719.3 628.4,755.8
						628.8,754.1 564.2,717.7 					"/>
				</defs>
        <clipPath id="SVGID_00000179624917666802547540000006131700691282072503_">
					<use xlink:href="#SVGID_00000067943026755415762590000003910863759465024419_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000179624917666802547540000006131700691282072503_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000014594263493056824940000009190089180060822164_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000072977650030705739450000010688557706473881513_">
								<use xlink:href="#SVGID_00000014594263493056824940000009190089180060822164_" style="overflow:visible;"/>
							</clipPath>

              <rect x="561.3" y="715.6"
                    style="clip-path:url(#SVGID_00000072977650030705739450000010688557706473881513_);fill:#3FB994;"
                    width="69.6" height="42.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000051377861009528832710000014111560442396024975_" d="M628.8,754.1c2.9,1.7,7,1.7,9.9,0L771.4,675
						c2.5-1.7,2.5-4.1,0-5.8l-64.7-36.5c-2.9-1.7-7-1.7-9.9,0l-132.7,79.2c-2.5,1.7-2.5,4.1,0,5.8L628.8,754.1"/>
				</defs>
        <clipPath id="SVGID_00000022554206583798360900000009409002609598801843_">
					<use xlink:href="#SVGID_00000051377861009528832710000014111560442396024975_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000022554206583798360900000009409002609598801843_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000082333005109105846210000013634978787508771769_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000100358076144577776910000007226751336011441312_">
								<use xlink:href="#SVGID_00000082333005109105846210000013634978787508771769_" style="overflow:visible;"/>
							</clipPath>

              <rect x="559.2" y="629.4"
                    style="clip-path:url(#SVGID_00000100358076144577776910000007226751336011441312_);fill:#25292A;"
                    width="217.2" height="128.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000160883495166637882950000013418833624546832305_" d="M638.4,754.1c-0.4,0-0.8,0.4-1.2,0.4l0,0
						c-0.4,0-0.8,0.4-1.2,0.4l0,0c-0.4,0-0.8,0-1.2,0.4l0,0c-0.4,0-0.8,0-1.2,0l0,0c-0.4,0-0.8,0-1.2,0l0,0c-0.4,0-0.8,0-1.2,0l0,0
						c-0.4,0-0.8-0.4-1.2-0.4l0,0c-0.4,0-0.8-0.4-1.2-0.4v1.2l0,0h0.4h0.4h0.4h0.4l0,0l0,0l0,0l0,0l0,0h0.4l0,0l0,0l0,0l0,0l0,0l0,0
						l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.4h0.4h0.4h0.4l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0
						l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.4h0.4h0.4h0.4h0.4h0.4h0.4
						l0,0L638.4,754.1"/>
				</defs>
        <clipPath id="SVGID_00000026855633583701213090000008768802206111571889_">
					<use xlink:href="#SVGID_00000160883495166637882950000013418833624546832305_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000026855633583701213090000008768802206111571889_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000008840615431330890380000011181384746636733333_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000050620681310623777780000014544972992163209141_">
								<use xlink:href="#SVGID_00000008840615431330890380000011181384746636733333_" style="overflow:visible;"/>
							</clipPath>

              <rect x="625.9" y="752.1"
                    style="clip-path:url(#SVGID_00000050620681310623777780000014544972992163209141_);fill:#3FB994;"
                    width="15.3" height="7"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000039131269212055126780000017187437716791903421_" d="M741.2,658.8c-0.4-0.4-0.4-0.4,0-0.8
						c0.4-0.4,1.2-0.4,1.7,0c0.4,0.4,0.4,0.4,0,0.8C742.4,659.2,741.6,659.2,741.2,658.8 M743.3,658c-0.4-0.4-1.7-0.4-2.1,0
						c-0.4,0.4-0.4,0.8,0,1.2c0.4,0.4,1.7,0.4,2.1,0C743.7,658.8,743.7,658,743.3,658"/>
				</defs>
        <clipPath id="SVGID_00000055695851147677268390000001973825822255799977_">
					<use xlink:href="#SVGID_00000039131269212055126780000017187437716791903421_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000055695851147677268390000001973825822255799977_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000070808125805515118560000008960034333561831344_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000173154247311690207770000001084897209368260762_">
								<use xlink:href="#SVGID_00000070808125805515118560000008960034333561831344_" style="overflow:visible;"/>
							</clipPath>

              <rect x="738.3" y="655.1"
                    style="clip-path:url(#SVGID_00000173154247311690207770000001084897209368260762_);fill:#42B994;"
                    width="7.9" height="6.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000059988021996407023340000017967914032614133680_" d="M742.8,658c0.4,0.4,0.4,0.4,0,0.8
						c-0.4,0.4-1.2,0.4-1.7,0c-0.4-0.4-0.4-0.4,0-0.8C741.6,658,742.4,657.5,742.8,658"/>
				</defs>
        <clipPath id="SVGID_00000165916474898108156370000009663939431045892797_">
					<use xlink:href="#SVGID_00000059988021996407023340000017967914032614133680_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000165916474898108156370000009663939431045892797_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000152223151456493649660000002310160048292184475_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000079477427546325464920000015235243455888757660_">
								<use xlink:href="#SVGID_00000152223151456493649660000002310160048292184475_" style="overflow:visible;"/>
							</clipPath>

              <rect x="738.7" y="655.5"
                    style="clip-path:url(#SVGID_00000079477427546325464920000015235243455888757660_);fill:#25292A;"
                    width="6.6" height="5.8"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000014631858176554317950000004261183276049615039_" d="M738.3,657.1c-0.4-0.4-0.4-0.4,0-0.8
						c0.4-0.4,1.2-0.4,1.7,0c0.4,0.4,0.4,0.4,0,0.8C739.5,657.5,738.7,657.5,738.3,657.1 M739.9,656.3c-0.4-0.4-1.7-0.4-2.1,0
						c-0.4,0.4-0.4,0.8,0,1.2c0.4,0.4,1.7,0.4,2.1,0C740.8,657.1,740.8,656.3,739.9,656.3"/>
				</defs>
        <clipPath id="SVGID_00000002380229849754003940000009355808075419307145_">
					<use xlink:href="#SVGID_00000014631858176554317950000004261183276049615039_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000002380229849754003940000009355808075419307145_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000087413978276914643480000010813985401964213686_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000012441202077179201070000014649658041877810847_">
								<use xlink:href="#SVGID_00000087413978276914643480000010813985401964213686_" style="overflow:visible;"/>
							</clipPath>

              <rect x="735.4" y="653.4"
                    style="clip-path:url(#SVGID_00000012441202077179201070000014649658041877810847_);fill:#42B994;"
                    width="7.9" height="6.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000041979035364793818810000004230276958618244235_" d="M739.9,656.3c0.4,0.4,0.4,0.4,0,0.8
						c-0.4,0.4-1.2,0.4-1.7,0c-0.4-0.4-0.4-0.4,0-0.8C738.7,656.3,739.5,655.9,739.9,656.3"/>
				</defs>
        <clipPath id="SVGID_00000045599913522660793010000015539205974076449198_">
					<use xlink:href="#SVGID_00000041979035364793818810000004230276958618244235_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000045599913522660793010000015539205974076449198_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000031913252035877198820000016760871669316098467_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000019662886148471452220000009375602030807247292_">
								<use xlink:href="#SVGID_00000031913252035877198820000016760871669316098467_" style="overflow:visible;"/>
							</clipPath>

              <rect x="735.8" y="653.8"
                    style="clip-path:url(#SVGID_00000019662886148471452220000009375602030807247292_);fill:#25292A;"
                    width="6.6" height="5.8"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000176000699537455186250000008888589630036429963_" d="M734.5,655.1l-8.3-4.6c-0.4,0-0.4-0.4,0-0.4l0.4-0.4
						c0.4,0,0.8,0,0.8,0l8.3,4.6c0.4,0,0.4,0.4,0,0.4l-0.4,0.4C735,655.1,734.5,655.1,734.5,655.1 M727.5,649.3c-0.4,0-0.8,0-0.8,0
						l-1.2,0.8c-0.4,0-0.4,0.4,0,0.4l9.1,5c0.4,0,0.8,0,0.8,0l1.2-0.8c0.4,0,0.4-0.4,0-0.4L727.5,649.3"/>
				</defs>
        <clipPath id="SVGID_00000171713344131111338930000011284542154460614282_">
					<use xlink:href="#SVGID_00000176000699537455186250000008888589630036429963_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000171713344131111338930000011284542154460614282_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000005958038607541919540000012442608757488730814_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000121980997608417612050000015629147260117847945_">
								<use xlink:href="#SVGID_00000005958038607541919540000012442608757488730814_" style="overflow:visible;"/>
							</clipPath>

              <rect x="722.9" y="646.8"
                    style="clip-path:url(#SVGID_00000121980997608417612050000015629147260117847945_);fill:#42B994;"
                    width="16.2" height="11.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000177453518778310552440000004607476099132556434_" d="M727.5,649.3l8.3,4.6c0.4,0,0.4,0.4,0,0.4l-0.4,0.4
						c-0.4,0-0.8,0-0.8,0l-8.3-4.6c-0.4,0-0.4-0.4,0-0.4l0.4-0.4C727.1,649.3,727.5,649.3,727.5,649.3"/>
				</defs>
        <clipPath id="SVGID_00000135672340829317833990000003208720782637014424_">
					<use xlink:href="#SVGID_00000177453518778310552440000004607476099132556434_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000135672340829317833990000003208720782637014424_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000147193597430127451330000004143404969204143493_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000165944635450141442260000010582984103724737178_">
								<use xlink:href="#SVGID_00000147193597430127451330000004143404969204143493_" style="overflow:visible;"/>
							</clipPath>

              <rect x="723.8" y="647.2"
                    style="clip-path:url(#SVGID_00000165944635450141442260000010582984103724737178_);fill:#25292A;"
                    width="14.9" height="10.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000107560684304438299470000004231707025087465380_" points="753.2,688.6 725,705.6 725,708.1
						753.2,691.5 753.2,688.6 					"/>
				</defs>
        <clipPath id="SVGID_00000130610144004150992190000006141284675976513168_">
					<use xlink:href="#SVGID_00000107560684304438299470000004231707025087465380_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000130610144004150992190000006141284675976513168_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000150789180940284952290000018347257927040917921_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000134217244119206646970000003743940838396345749_">
								<use xlink:href="#SVGID_00000150789180940284952290000018347257927040917921_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000134217244119206646970000003743940838396345749_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>

													<rect id="SVGID_00000104705743427989984190000003305331074130068613_" x="723.8" y="688.2"
                                width="31.1" height="19.9"/>
											</defs>
                      <clipPath id="SVGID_00000065781919557458467370000001290634820747938714_">
												<use xlink:href="#SVGID_00000104705743427989984190000003305331074130068613_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000065781919557458467370000001290634820747938714_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000057132161013209819780000011143334411031805322_" d="M725,706.9c0-0.8,1.2-2.1,2.5-2.5l11.6-6.6
																v2.5l-11.6,6.6C725.8,707.3,725,707.7,725,706.9"/>
														</defs>
                            <clipPath id="SVGID_00000178181153043969518310000003923917778245281412_">
															<use xlink:href="#SVGID_00000057132161013209819780000011143334411031805322_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000178181153043969518310000003923917778245281412_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000052802213024453638590000014815340984752518286_" x="723.8"
                                            y="688.2" width="31.1" height="19.9"/>
																	</defs>
                                  <clipPath id="SVGID_00000075144288444439563630000017985416655389166007_">
																		<use xlink:href="#SVGID_00000052802213024453638590000014815340984752518286_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="722.5" y="695.3"
                                        style="clip-path:url(#SVGID_00000075144288444439563630000017985416655389166007_);fill:#25292A;"
                                        width="18.2" height="14.5"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>

													<rect id="SVGID_00000160893495405150239430000011925837227409419690_" x="723.8" y="688.2"
                                width="31.1" height="19.9"/>
											</defs>
                      <clipPath id="SVGID_00000054975283804797543450000000235665381101009846_">
												<use xlink:href="#SVGID_00000160893495405150239430000011925837227409419690_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000054975283804797543450000000235665381101009846_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000021800204939377854870000013611824776591007659_" d="M739.5,699.4v-2.5l11.6-6.6
																c1.2-0.8,2.5-0.8,2.5,0s-1.2,2.1-2.5,2.5L739.5,699.4"/>
														</defs>
                            <clipPath id="SVGID_00000029015789127690494840000010924794039814181804_">
															<use xlink:href="#SVGID_00000021800204939377854870000013611824776591007659_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000029015789127690494840000010924794039814181804_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000070111987891975231980000004427553516652923283_" x="723.8"
                                            y="688.2" width="31.1" height="19.9"/>
																	</defs>
                                  <clipPath id="SVGID_00000031886036187331510170000007548822278729760130_">
																		<use xlink:href="#SVGID_00000070111987891975231980000004427553516652923283_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="737" y="687"
                                        style="clip-path:url(#SVGID_00000031886036187331510170000007548822278729760130_);fill:#25292A;"
                                        width="18.2" height="14.5"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000146465329264869204920000003706408945559080585_" points="611,746.3 611,750.4 614.3,752.5
						614.3,748.3 611,746.3 					"/>
				</defs>
        <clipPath id="SVGID_00000112613939532190637210000005351769609696604052_">
					<use xlink:href="#SVGID_00000146465329264869204920000003706408945559080585_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000112613939532190637210000005351769609696604052_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000145057912299812976790000011965618640677530523_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000086693737562437577130000007024223479389005503_">
								<use xlink:href="#SVGID_00000145057912299812976790000011965618640677530523_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000086693737562437577130000007024223479389005503_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>
												<rect id="SVGID_00000157268692046361225280000005389918499599319710_" x="610.2" y="746.3"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000147915020614796146250000003975831788109959089_">
												<use xlink:href="#SVGID_00000157268692046361225280000005389918499599319710_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000147915020614796146250000003975831788109959089_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000042717774486364799350000006480452642581231774_" d="M612.7,747.9c0.8,0.4,1.7,1.7,1.7,2.5
																c0,0.8-0.8,1.2-1.2,0.8c-0.8-0.4-1.7-1.7-1.7-2.5S611.8,747.1,612.7,747.9 M612.7,751.2c0.8,0.4,1.7,0,1.7-0.8
																c0-1.2-0.8-2.5-1.7-2.9s-1.7,0-1.7,0.8C611,749.6,611.8,750.8,612.7,751.2"/>
														</defs>
                            <clipPath id="SVGID_00000001655784740443970570000008180158917746421639_">
															<use xlink:href="#SVGID_00000042717774486364799350000006480452642581231774_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000001655784740443970570000008180158917746421639_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000044859784237536360550000007343471757755028665_" x="610.2"
                                            y="746.3" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000182515441827620293060000011935615450889205155_">
																		<use xlink:href="#SVGID_00000044859784237536360550000007343471757755028665_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="608.9" y="744.6"
                                        style="clip-path:url(#SVGID_00000182515441827620293060000011935615450889205155_);fill:#3FB994;"
                                        width="7.9" height="9.5"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
                  <g>
										<g>
											<defs>
												<rect id="SVGID_00000116204229576950013100000006236374003361237416_" x="610.2" y="746.3"
                              width="4.6" height="6.6"/>
											</defs>
                      <clipPath id="SVGID_00000160905981513326146080000002142684949095249544_">
												<use xlink:href="#SVGID_00000116204229576950013100000006236374003361237416_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000160905981513326146080000002142684949095249544_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000071527706914812503610000018206159658933717671_" d="M612.7,750.8c-0.8-0.4-1.7-1.7-1.7-2.5
																s0.8-1.2,1.2-0.8c0.8,0.4,1.7,1.7,1.7,2.5C614.3,751.2,613.5,751.7,612.7,750.8"/>
														</defs>
                            <clipPath id="SVGID_00000161594305530610922320000008418148863214028972_">
															<use xlink:href="#SVGID_00000071527706914812503610000018206159658933717671_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000161594305530610922320000008418148863214028972_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000116234330858827104800000012992802032418017687_" x="610.2"
                                            y="746.3" width="4.6" height="6.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000159432514625394333110000008989392822890916490_">
																		<use xlink:href="#SVGID_00000116234330858827104800000012992802032418017687_"
                                         style="overflow:visible;"/>
																	</clipPath>

                                  <rect x="608.9" y="745"
                                        style="clip-path:url(#SVGID_00000159432514625394333110000008989392822890916490_);fill:#001820;"
                                        width="7.5" height="8.7"/>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000095319721413782687730000004157257362051386047_" d="M487.5,566.3V614c0,10.4,5.8,20.3,14.5,25.7l29,16.6
						l85-49.3l-29-15.8c-9.1-5.4-14.9-14.9-14.9-25.7v-47.7L487.5,566.3"/>
				</defs>
        <clipPath id="SVGID_00000177476221894328994870000007139990800878459070_">
					<use xlink:href="#SVGID_00000095319721413782687730000004157257362051386047_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000177476221894328994870000007139990800878459070_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000178911343440760770790000014551618193101418632_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000106120484549942226120000013742654472385412531_">
								<use xlink:href="#SVGID_00000178911343440760770790000014551618193101418632_" style="overflow:visible;"/>
							</clipPath>

              <rect x="485.4" y="514.9"
                    style="clip-path:url(#SVGID_00000106120484549942226120000013742654472385412531_);fill:#25292A;"
                    width="133.1" height="143"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000129920693650961032690000000860625646832880017_" points="616.4,596.2 616.4,606.6 531.4,655.9
						531.4,645.5 616.4,596.2 					"/>
				</defs>
        <clipPath id="SVGID_00000145741612507209256280000005583549902531405726_">
					<use xlink:href="#SVGID_00000129920693650961032690000000860625646832880017_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000145741612507209256280000005583549902531405726_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000032638487157641585290000017517592355493045671_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000173858115314458386770000008152511056187199402_">
								<use xlink:href="#SVGID_00000032638487157641585290000017517592355493045671_" style="overflow:visible;"/>
							</clipPath>

              <rect x="529.3" y="593.7"
                    style="clip-path:url(#SVGID_00000173858115314458386770000008152511056187199402_);fill:#25292A;"
                    width="89.5" height="64.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000080180493682108375840000015222560775285805474_" points="285.2,689.1 285.2,689.1 285.2,689.1
						285.2,689.1 					"/>
				</defs>
        <clipPath id="SVGID_00000114773681519480222840000002386504590183853493_">
					<use xlink:href="#SVGID_00000080180493682108375840000015222560775285805474_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000114773681519480222840000002386504590183853493_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000169539711549856144810000013898099114934897591_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000159467384674599996620000005662091556204796307_">
								<use xlink:href="#SVGID_00000169539711549856144810000013898099114934897591_" style="overflow:visible;"/>
							</clipPath>

              <rect x="282.7" y="687"
                    style="clip-path:url(#SVGID_00000159467384674599996620000005662091556204796307_);fill:#A4A6A5;"
                    width="4.6" height="4.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000065050431767198806530000013781628158087201718_" points="285.2,689.1 284.8,688.6 285.2,689.1
						"/>
				</defs>
        <clipPath id="SVGID_00000158712660969617785390000005992309167626803587_">
					<use xlink:href="#SVGID_00000065050431767198806530000013781628158087201718_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000158712660969617785390000005992309167626803587_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000137128242408695935670000002040169084238474408_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000019642398297652565340000001673625634481879221_">
								<use xlink:href="#SVGID_00000137128242408695935670000002040169084238474408_" style="overflow:visible;"/>
							</clipPath>

              <rect x="282.7" y="686.6"
                    style="clip-path:url(#SVGID_00000019642398297652565340000001673625634481879221_);fill:#9CB3C6;"
                    width="5" height="4.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000034804441738588687560000008225788150739476926_" d="M731.6,67.2l1.7,0.8
						C732.9,67.6,732.1,67.6,731.6,67.2"/>
				</defs>
        <clipPath id="SVGID_00000176729665715852029210000013447802795452411570_">
					<use xlink:href="#SVGID_00000034804441738588687560000008225788150739476926_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000176729665715852029210000013447802795452411570_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000041997938074525599990000009746968935187751049_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000022545281866234052160000001169948870518439570_">
								<use xlink:href="#SVGID_00000041997938074525599990000009746968935187751049_" style="overflow:visible;"/>
							</clipPath>

              <rect x="729.6" y="64.7"
                    style="clip-path:url(#SVGID_00000022545281866234052160000001169948870518439570_);fill:#9CB3C6;"
                    width="6.2" height="5.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000065752803545365227460000006872786590431405226_" d="M721.3,61c-1.7-1.2-2.9-2.1-5-2.9
						c-2.9-1.2-6.2-1.7-9.5-1.2c-1.7,0-3.3,0.4-4.6,1.2l0,0c-0.8,0.4-1.7,0.8-2.5,1.2l-14.9,8.3l0,0L288.9,291.9l13.7,7.9
						L713.4,67.6c5.8-3.3,12.9-3.3,18.2-0.4L721.3,61"/>
				</defs>
        <clipPath id="SVGID_00000149362165278020569720000011671994847894164920_">
					<use xlink:href="#SVGID_00000065752803545365227460000006872786590431405226_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000149362165278020569720000011671994847894164920_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000060709296731372166130000007620353866477124232_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000176007946694944033030000000641579940701438636_">
								<use xlink:href="#SVGID_00000060709296731372166130000007620353866477124232_" style="overflow:visible;"/>
							</clipPath>

              <rect x="286.8" y="54.8"
                    style="clip-path:url(#SVGID_00000176007946694944033030000000641579940701438636_);fill:#25292A;"
                    width="447.3" height="247.5"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000013154879130281639750000013923949413454929086_" d="M295.1,303.9c-12.9,7.5-20.7,21.1-20.7,35.7
						l0.8,299.7L742,374.4l0.4-290.2c0-7-3.7-12.9-9.1-16.2l0,0l-1.7-0.8c-5.4-2.9-12-2.9-18.2,0.4L302.6,299.8L295.1,303.9"/>
				</defs>
        <clipPath id="SVGID_00000064325462356399213180000010410642306788862903_">
					<use xlink:href="#SVGID_00000013154879130281639750000013923949413454929086_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000064325462356399213180000010410642306788862903_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000007407649323746793520000013302982007423450005_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000039850632257845780470000000315746342163982503_">
								<use xlink:href="#SVGID_00000007407649323746793520000013302982007423450005_" style="overflow:visible;"/>
							</clipPath>

              <rect x="272.3" y="61.8"
                    style="clip-path:url(#SVGID_00000039850632257845780470000000315746342163982503_);fill:#E0E1DB;"
                    width="472.2" height="579.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000000208658973607502630000009130740945953009808_" d="M275.2,639.3v32.8c0,7.5,3.7,13.3,9.5,16.6l0.4,0.4
						l0,0c5.4,2.9,12.4,3.3,19.1,0l428.2-242.9c5.8-3.3,9.5-9.9,9.5-16.6v-54.7L275.2,639.3"/>
				</defs>
        <clipPath id="SVGID_00000146481485751834430210000002281183198673405586_">
					<use xlink:href="#SVGID_00000000208658973607502630000009130740945953009808_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000146481485751834430210000002281183198673405586_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000127723292553983966670000004896331111685835934_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000161622950272029690920000016180553642455767707_">
								<use xlink:href="#SVGID_00000127723292553983966670000004896331111685835934_" style="overflow:visible;"/>
							</clipPath>

              <rect x="273.1" y="372.3"
                    style="clip-path:url(#SVGID_00000161622950272029690920000016180553642455767707_);fill:#25292A;"
                    width="471.4" height="322.5"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000176724217792110916830000012411218717200185757_" d="M275.2,672.5v-32.8h-0.4l-13.3-7.9v32.3
						c0,6.6,3.3,12.4,8.3,15.8c0.8,0.4,1.7,1.2,2.5,1.7l12.4,7C279.4,685.3,275.2,679.5,275.2,672.5"/>
				</defs>
        <clipPath id="SVGID_00000113354514257321068980000017775966872522471590_">
					<use xlink:href="#SVGID_00000176724217792110916830000012411218717200185757_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000113354514257321068980000017775966872522471590_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000069397590890724172470000012135660164255686840_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000008134735921635050170000017165896959630384556_">
								<use xlink:href="#SVGID_00000069397590890724172470000012135660164255686840_" style="overflow:visible;"/>
							</clipPath>

              <rect x="259.5" y="629.8"
                    style="clip-path:url(#SVGID_00000008134735921635050170000017165896959630384556_);fill:#25292A;"
                    width="27.8" height="61.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000011751555437010460100000003401650594532171950_" d="M275.2,639.3l-0.8-299.7c0-14.9,7.9-28.6,20.7-35.7
						l7-4.1l-13.7-7.9l-7.5,4.1c-12.9,7.5-20.7,21.1-20.7,35.7l0.8,300.1L275.2,639.3L275.2,639.3"/>
				</defs>
        <clipPath id="SVGID_00000107566517287157121450000009046689755330634381_">
					<use xlink:href="#SVGID_00000011751555437010460100000003401650594532171950_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000107566517287157121450000009046689755330634381_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000013163156147515224630000014622911521793668542_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000114759859010356317020000011575520478007843246_">
								<use xlink:href="#SVGID_00000013163156147515224630000014622911521793668542_" style="overflow:visible;"/>
							</clipPath>

              <rect x="258.6" y="289.4"
                    style="clip-path:url(#SVGID_00000114759859010356317020000011575520478007843246_);fill:#25292A;"
                    width="46" height="352.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000072250254037756355920000008863053462069391031_" points="302.6,299.8 302.6,299.8 295.1,303.9
						302.6,299.8 					"/>
				</defs>
        <clipPath id="SVGID_00000181792566823452212810000014524392050090418620_">
					<use xlink:href="#SVGID_00000072250254037756355920000008863053462069391031_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000181792566823452212810000014524392050090418620_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000085241895523271689950000006769697924664278683_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000127034547875117195000000014720728729318734508_">
								<use xlink:href="#SVGID_00000085241895523271689950000006769697924664278683_" style="overflow:visible;"/>
							</clipPath>

              <rect x="293" y="297.7"
                    style="clip-path:url(#SVGID_00000127034547875117195000000014720728729318734508_);fill:#A4A6A5;"
                    width="11.6" height="8.7"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000090263145943294789530000003409774673398204040_" d="M642.9,655.9c6.6-2.9,15.3-4.6,24.9-4.6
						c7.9,0,15.3,1.2,21.6,3.3L667.8,670L642.9,655.9"/>
				</defs>
        <clipPath id="SVGID_00000083779693814879295260000004048952254687954823_">
					<use xlink:href="#SVGID_00000090263145943294789530000003409774673398204040_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000083779693814879295260000004048952254687954823_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000152252740091975778130000009600098280496437152_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000073681004022187616880000017341764399320128402_">
								<use xlink:href="#SVGID_00000152252740091975778130000009600098280496437152_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000073681004022187616880000017341764399320128402_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>

													<rect id="SVGID_00000169555495580103120340000006406910015492264124_" x="641.3" y="650.5"
                                width="48.9" height="19.9"/>
											</defs>
                      <clipPath id="SVGID_00000119099837496729695880000003879044004328420780_">
												<use xlink:href="#SVGID_00000169555495580103120340000006406910015492264124_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000119099837496729695880000003879044004328420780_);">
												<g>
													<g>
														<defs>
															<path id="SVGID_00000085247867594685152320000011293831572925882809_" d="M642.9,655.9c6.6-2.9,15.3-4.6,24.9-4.6
																c7.9,0,15.3,1.2,21.6,3.3L667.8,670L642.9,655.9"/>
														</defs>
                            <clipPath id="SVGID_00000081647146965224269670000015710442599417563320_">
															<use xlink:href="#SVGID_00000085247867594685152320000011293831572925882809_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000081647146965224269670000015710442599417563320_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000121978245765294367950000005031285626556972939_" x="641.3"
                                            y="650.5" width="48.9" height="19.9"/>
																	</defs>
                                  <clipPath id="SVGID_00000162328881291108116120000016927483626336433285_">
																		<use xlink:href="#SVGID_00000121978245765294367950000005031285626556972939_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="opacity:0;clip-path:url(#SVGID_00000162328881291108116120000016927483626336433285_);">
																		<g class="st5">
																			<g>
																				<g>
																					<g>
																						<defs>

																								<rect id="SVGID_00000075149805915354700490000000591755258787591296_"
                                                      x="641.3" y="650.5" width="48.9" height="19.9"/>
																						</defs>
                                            <clipPath id="SVGID_00000080915006235218000150000018295703546591024819_">
																							<use
                                                  xlink:href="#SVGID_00000075149805915354700490000000591755258787591296_"
                                                  style="overflow:visible;"/>
																						</clipPath>
																					</g>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
                              <g>
																<g>
																	<defs>

																			<rect id="SVGID_00000130640082099692230610000002568108880387904405_" x="641.3"
                                            y="650.5" width="48.9" height="19.9"/>
																	</defs>
                                  <clipPath id="SVGID_00000071534602776733387400000012032779534377567373_">
																		<use xlink:href="#SVGID_00000130640082099692230610000002568108880387904405_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="clip-path:url(#SVGID_00000071534602776733387400000012032779534377567373_);">
																		<g>
																			<g>
																				<g>
																					<defs>

																							<rect id="SVGID_00000084488393874095177410000011344816413996428969_"
                                                    x="641.3" y="650.5" width="48.9" height="19.9"/>
																					</defs>
                                          <clipPath id="SVGID_00000016075322788982446500000013566433999934411648_">
																						<use xlink:href="#SVGID_00000084488393874095177410000011344816413996428969_"
                                                 style="overflow:visible;"/>
																					</clipPath>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000151507841348534149810000002347456386574316433_" points="689.4,654.6 689.4,670 667.8,685.3
						667.8,670 689.4,654.6 					"/>
				</defs>
        <clipPath id="SVGID_00000183966107545474150880000011294914588810350980_">
					<use xlink:href="#SVGID_00000151507841348534149810000002347456386574316433_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000183966107545474150880000011294914588810350980_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000114048238280515147090000001565205172719593889_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000089575105075696463700000000493289690853077148_">
								<use xlink:href="#SVGID_00000114048238280515147090000001565205172719593889_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000089575105075696463700000000493289690853077148_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>

													<rect id="SVGID_00000106128901396160095940000013261010037834808476_" x="665.7" y="652.6"
                                width="24.5" height="33.6"/>
											</defs>
                      <clipPath id="SVGID_00000125574530120609753120000013905285771151074194_">
												<use xlink:href="#SVGID_00000106128901396160095940000013261010037834808476_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000125574530120609753120000013905285771151074194_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000071558049572451660350000007212740341003959190_" points="689.4,654.6 689.4,670
																667.8,685.3 667.8,670 689.4,654.6 															"/>
														</defs>
                            <clipPath id="SVGID_00000096745427984441843600000003510253279505457539_">
															<use xlink:href="#SVGID_00000071558049572451660350000007212740341003959190_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000096745427984441843600000003510253279505457539_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000050645535223707017180000003031051923620589196_" x="665.7"
                                            y="652.6" width="24.5" height="33.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000068669836965567593810000007050665841467006871_">
																		<use xlink:href="#SVGID_00000050645535223707017180000003031051923620589196_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="opacity:0;clip-path:url(#SVGID_00000068669836965567593810000007050665841467006871_);">
																		<g class="st5">
																			<g>
																				<g>
																					<g>
																						<defs>

																								<rect id="SVGID_00000148661888518663596360000017181364649691377822_"
                                                      x="665.7" y="652.6" width="24.5" height="33.6"/>
																						</defs>
                                            <clipPath id="SVGID_00000093864363806607935030000007207558788433286053_">
																							<use
                                                  xlink:href="#SVGID_00000148661888518663596360000017181364649691377822_"
                                                  style="overflow:visible;"/>
																						</clipPath>
																					</g>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
                              <g>
																<g>
																	<defs>

																			<rect id="SVGID_00000021836546750042515500000013795015836364419512_" x="665.7"
                                            y="652.6" width="24.5" height="33.6"/>
																	</defs>
                                  <clipPath id="SVGID_00000028292981852331116660000010818137228600094630_">
																		<use xlink:href="#SVGID_00000021836546750042515500000013795015836364419512_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="clip-path:url(#SVGID_00000028292981852331116660000010818137228600094630_);">
																		<g>
																			<g>
																				<g>
																					<defs>

																							<rect id="SVGID_00000164488155459605874810000006195381798386456192_"
                                                    x="665.7" y="652.6" width="24.5" height="33.6"/>
																					</defs>
                                          <clipPath id="SVGID_00000140016761925113696780000009247697548750624180_">
																						<use xlink:href="#SVGID_00000164488155459605874810000006195381798386456192_"
                                                 style="overflow:visible;"/>
																					</clipPath>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000050637794487707362840000007768294925587637382_" points="642.9,655.9 642.9,671.2 667.8,685.3
						667.8,670 642.9,655.9 					"/>
				</defs>
        <clipPath id="SVGID_00000044870615681814572120000011883729471513532040_">
					<use xlink:href="#SVGID_00000050637794487707362840000007768294925587637382_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000044870615681814572120000011883729471513532040_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000047752927599135241830000000198131906291878559_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000086686650760261964440000003232477472572125861_">
								<use xlink:href="#SVGID_00000047752927599135241830000000198131906291878559_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000086686650760261964440000003232477472572125861_);enable-background:new    ;">
								<g>
									<g>
										<g>
											<defs>

													<rect id="SVGID_00000089538876705752815980000011695190530284792508_" x="641.3" y="655.1"
                                width="26.5" height="31.1"/>
											</defs>
                      <clipPath id="SVGID_00000145017711413733055910000003927539672651465617_">
												<use xlink:href="#SVGID_00000089538876705752815980000011695190530284792508_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000145017711413733055910000003927539672651465617_);">
												<g>
													<g>
														<defs>
															<polyline id="SVGID_00000030451898142793092160000001921292233550668967_" points="642.9,655.9 642.9,671.2
																667.8,685.3 667.8,670 642.9,655.9 															"/>
														</defs>
                            <clipPath id="SVGID_00000156557101609047686400000007454739505941689011_">
															<use xlink:href="#SVGID_00000030451898142793092160000001921292233550668967_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000156557101609047686400000007454739505941689011_);">
															<g>
																<g>
																	<defs>

																			<rect id="SVGID_00000158005396940644104630000004987619637748954551_" x="641.3"
                                            y="655.1" width="26.5" height="31.1"/>
																	</defs>
                                  <clipPath id="SVGID_00000070107141873776782730000000142919496216672161_">
																		<use xlink:href="#SVGID_00000158005396940644104630000004987619637748954551_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="opacity:0;clip-path:url(#SVGID_00000070107141873776782730000000142919496216672161_);">
																		<g class="st5">
																			<g>
																				<g>
																					<g>
																						<defs>

																								<rect id="SVGID_00000120544646931595823300000007719315877442066867_"
                                                      x="641.3" y="655.1" width="26.5" height="31.1"/>
																						</defs>
                                            <clipPath id="SVGID_00000014609280987497234240000010433217103140213148_">
																							<use
                                                  xlink:href="#SVGID_00000120544646931595823300000007719315877442066867_"
                                                  style="overflow:visible;"/>
																						</clipPath>
																					</g>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
                              <g>
																<g>
																	<defs>

																			<rect id="SVGID_00000116198527460411748800000001110304312236870078_" x="641.3"
                                            y="655.1" width="26.5" height="31.1"/>
																	</defs>
                                  <clipPath id="SVGID_00000019637571233775965380000017567445191779909055_">
																		<use xlink:href="#SVGID_00000116198527460411748800000001110304312236870078_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="clip-path:url(#SVGID_00000019637571233775965380000017567445191779909055_);">
																		<g>
																			<g>
																				<g>
																					<defs>

																							<rect id="SVGID_00000145760166889176062310000004355485021064721795_"
                                                    x="641.3" y="655.1" width="26.5" height="31.1"/>
																					</defs>
                                          <clipPath id="SVGID_00000147197468957037408440000001936409919794254234_">
																						<use xlink:href="#SVGID_00000145760166889176062310000004355485021064721795_"
                                                 style="overflow:visible;"/>
																					</clipPath>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000018195937244288386430000001293110974265798281_" points="705.1,676.2 705.1,681.6 667.8,685.3
						667.8,680.3 705.1,676.2 					"/>
				</defs>
        <clipPath id="SVGID_00000089570623863411260500000017342377684539835580_">
					<use xlink:href="#SVGID_00000018195937244288386430000001293110974265798281_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000089570623863411260500000017342377684539835580_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000181060103244577023190000016676505034961572778_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000138564742349747522680000010874128417831225256_">
								<use xlink:href="#SVGID_00000181060103244577023190000016676505034961572778_" style="overflow:visible;"/>
							</clipPath>

              <rect x="665.3" y="674.1"
                    style="clip-path:url(#SVGID_00000138564742349747522680000010874128417831225256_);fill:#4EBD99;"
                    width="41.9" height="13.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000011743649739737126970000007020954259783242394_" points="587.8,404.7 572,413 557.1,407.6
						557.1,334.2 572.9,327.6 587.8,330.9 587.8,404.7 					"/>
				</defs>
        <clipPath id="SVGID_00000006693745920333185910000005122390329711035042_">
					<use xlink:href="#SVGID_00000011743649739737126970000007020954259783242394_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000006693745920333185910000005122390329711035042_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000057860038049471233230000011613409845658926495_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000005239301082592111140000002627429259547668920_">
								<use xlink:href="#SVGID_00000057860038049471233230000011613409845658926495_" style="overflow:visible;"/>
							</clipPath>

              <rect x="555" y="325.1"
                    style="clip-path:url(#SVGID_00000005239301082592111140000002627429259547668920_);fill:#42B994;"
                    width="34.8" height="90"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000014598119936682041840000013398824604073754806_" points="572,413 572,339.2 557.1,334.2 557.1,407.6
						572,413 					"/>
				</defs>
        <clipPath id="SVGID_00000128467369388014944170000003971837196581719975_">
					<use xlink:href="#SVGID_00000014598119936682041840000013398824604073754806_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000128467369388014944170000003971837196581719975_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000038400486860155700880000003322203916832781956_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000024710838524762273480000002334395008251819393_">
								<use xlink:href="#SVGID_00000038400486860155700880000003322203916832781956_" style="overflow:visible;"/>
							</clipPath>

              <rect x="555" y="331.7"
                    style="clip-path:url(#SVGID_00000024710838524762273480000002334395008251819393_);fill:#226A57;"
                    width="19.5" height="83.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000160183780410982869870000000735336674421844651_" points="587.8,330.9 572,339.2 557.1,334.2
						572.9,325.5 587.8,330.9 					"/>
				</defs>
        <clipPath id="SVGID_00000126300925942485212350000009400067404632637363_">
					<use xlink:href="#SVGID_00000160183780410982869870000000735336674421844651_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000126300925942485212350000009400067404632637363_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000057142978111834255220000018327987410427981197_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000085932560118843503240000010716934941475837830_">
								<use xlink:href="#SVGID_00000057142978111834255220000018327987410427981197_" style="overflow:visible;"/>
							</clipPath>

              <rect x="555" y="323.4"
                    style="clip-path:url(#SVGID_00000085932560118843503240000010716934941475837830_);fill:#165748;"
                    width="34.8" height="18.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000023964174941711477850000002877937723422149505_" points="561.3,419.2 545.5,427.5 530.6,422.5
						530.6,325.5 546.3,318.4 561.3,322.2 561.3,419.2 					"/>
				</defs>
        <clipPath id="SVGID_00000162325769592591397480000017919550809610761651_">
					<use xlink:href="#SVGID_00000023964174941711477850000002877937723422149505_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000162325769592591397480000017919550809610761651_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000158719360451731273830000010303553806146107823_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000045579933693965230340000011165345092498887605_">
								<use xlink:href="#SVGID_00000158719360451731273830000010303553806146107823_" style="overflow:visible;"/>
							</clipPath>

              <rect x="528.5" y="316.4"
                    style="clip-path:url(#SVGID_00000045579933693965230340000011165345092498887605_);fill:#42B994;"
                    width="34.8" height="113.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000157310375294675678450000015320592519126001314_" points="545.5,427.5 545.5,330.5 530.6,325.5
						530.6,422.5 545.5,427.5 					"/>
				</defs>
        <clipPath id="SVGID_00000003091814853043847780000004408210411055779978_">
					<use xlink:href="#SVGID_00000157310375294675678450000015320592519126001314_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000003091814853043847780000004408210411055779978_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000157271347701516988020000013489947948446247066_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000130619684526140375830000002817825231335491751_">
								<use xlink:href="#SVGID_00000157271347701516988020000013489947948446247066_" style="overflow:visible;"/>
							</clipPath>

              <rect x="528.5" y="323"
                    style="clip-path:url(#SVGID_00000130619684526140375830000002817825231335491751_);fill:#226A57;"
                    width="19.5" height="107"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000022550161589591588980000015142704079997823916_" points="561.3,322.2 545.5,330.5 530.6,325.5
						546.3,316.8 561.3,322.2 					"/>
				</defs>
        <clipPath id="SVGID_00000173122726754385497900000012027186502866527393_">
					<use xlink:href="#SVGID_00000022550161589591588980000015142704079997823916_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000173122726754385497900000012027186502866527393_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000137833432502370248240000008311508806209033877_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000069375418879951252940000010714660591343788725_">
								<use xlink:href="#SVGID_00000137833432502370248240000008311508806209033877_" style="overflow:visible;"/>
							</clipPath>

              <rect x="528.5" y="314.7"
                    style="clip-path:url(#SVGID_00000069375418879951252940000010714660591343788725_);fill:#165748;"
                    width="34.8" height="18.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000114055071044678913050000006357673877091802512_" points="534.3,433.7 519,442.4 504.1,437
						504.1,312.2 519.4,305.6 534.3,308.9 534.3,433.7 					"/>
				</defs>
        <clipPath id="SVGID_00000133495900541125548960000016941850963125559994_">
					<use xlink:href="#SVGID_00000114055071044678913050000006357673877091802512_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000133495900541125548960000016941850963125559994_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000104665370904864453310000005887744106735306929_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000182509247348452951060000009178256130012822427_">
								<use xlink:href="#SVGID_00000104665370904864453310000005887744106735306929_" style="overflow:visible;"/>
							</clipPath>

              <rect x="501.6" y="303.1"
                    style="clip-path:url(#SVGID_00000182509247348452951060000009178256130012822427_);fill:#42B994;"
                    width="34.8" height="141.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000133502260355580302340000000975606453569769629_" points="519,442.4 519,317.2 504.1,312.2 504.1,437
						519,442.4 					"/>
				</defs>
        <clipPath id="SVGID_00000081621481728472996500000003190973775427814532_">
					<use xlink:href="#SVGID_00000133502260355580302340000000975606453569769629_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000081621481728472996500000003190973775427814532_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000116219365663969154240000012129330242891789999_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000026140880125499578770000016422947906834840468_">
								<use xlink:href="#SVGID_00000116219365663969154240000012129330242891789999_" style="overflow:visible;"/>
							</clipPath>

              <rect x="501.6" y="309.7"
                    style="clip-path:url(#SVGID_00000026140880125499578770000016422947906834840468_);fill:#226A57;"
                    width="19.5" height="134.7"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000105428496343833391400000005098858198380552578_" points="534.3,308.9 519,317.2 504.1,312.2
						519.4,303.5 534.3,308.9 					"/>
				</defs>
        <clipPath id="SVGID_00000053511395512079795010000006854040226917162648_">
					<use xlink:href="#SVGID_00000105428496343833391400000005098858198380552578_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000053511395512079795010000006854040226917162648_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000101080267444439908700000009357247895178696330_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000058554046586127580450000004102405051720728983_">
								<use xlink:href="#SVGID_00000101080267444439908700000009357247895178696330_" style="overflow:visible;"/>
							</clipPath>

              <rect x="501.6" y="301.4"
                    style="clip-path:url(#SVGID_00000058554046586127580450000004102405051720728983_);fill:#165748;"
                    width="34.8" height="18.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000183218540810140438730000017557838469843837827_" points="507.8,448.6 492.4,456.9 477.5,451.9
						477.5,352.8 492.9,346.2 507.8,349.5 507.8,448.6 					"/>
				</defs>
        <clipPath id="SVGID_00000151530861526046375710000010236963400081368995_">
					<use xlink:href="#SVGID_00000183218540810140438730000017557838469843837827_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000151530861526046375710000010236963400081368995_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000039830659359363618440000017821708313156343713_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000106828968116871103760000004669037671834352295_">
								<use xlink:href="#SVGID_00000039830659359363618440000017821708313156343713_" style="overflow:visible;"/>
							</clipPath>

              <rect x="475" y="344.1"
                    style="clip-path:url(#SVGID_00000106828968116871103760000004669037671834352295_);fill:#42B994;"
                    width="34.8" height="115.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000001648543843221233290000008892435505723454115_" points="492.4,456.9 492.4,358.2 477.5,352.8
						477.5,451.9 492.4,456.9 					"/>
				</defs>
        <clipPath id="SVGID_00000100362623427844949290000001795313543669066902_">
					<use xlink:href="#SVGID_00000001648543843221233290000008892435505723454115_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000100362623427844949290000001795313543669066902_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000014620792947515620370000003351738681366594949_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000173841364406952138240000016259460456986434747_">
								<use xlink:href="#SVGID_00000014620792947515620370000003351738681366594949_" style="overflow:visible;"/>
							</clipPath>

              <rect x="475" y="350.8"
                    style="clip-path:url(#SVGID_00000173841364406952138240000016259460456986434747_);fill:#226A57;"
                    width="19.5" height="108.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000051359994256492248670000000599998665571772078_" points="507.8,349.5 492.4,358.2 477.5,352.8
						492.9,344.6 507.8,349.5 					"/>
				</defs>
        <clipPath id="SVGID_00000131355278877256243820000005514376644228159401_">
					<use xlink:href="#SVGID_00000051359994256492248670000000599998665571772078_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000131355278877256243820000005514376644228159401_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000151509160134212170450000002534152345757189781_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000003805911947166716900000010338157813614128820_">
								<use xlink:href="#SVGID_00000151509160134212170450000002534152345757189781_" style="overflow:visible;"/>
							</clipPath>

              <rect x="475" y="342.1"
                    style="clip-path:url(#SVGID_00000003805911947166716900000010338157813614128820_);fill:#165748;"
                    width="34.8" height="18.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000123422654523654137010000002628240105924549265_" points="481.3,463.1 465.5,471.8 450.6,466.4
						450.6,381 466.3,374.4 481.3,377.7 481.3,463.1 					"/>
				</defs>
        <clipPath id="SVGID_00000059311136490658975370000004218227199297148853_">
					<use xlink:href="#SVGID_00000123422654523654137010000002628240105924549265_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000059311136490658975370000004218227199297148853_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000077304359454550203730000017041655263667261607_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000066483341470218031220000001793485680195304894_">
								<use xlink:href="#SVGID_00000077304359454550203730000017041655263667261607_" style="overflow:visible;"/>
							</clipPath>

              <rect x="448.5" y="372.3"
                    style="clip-path:url(#SVGID_00000066483341470218031220000001793485680195304894_);fill:#42B994;"
                    width="34.8" height="101.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000117659305825180675820000014894969518163395732_" points="465.5,471.8 465.5,386.4 450.6,381
						450.6,466.4 465.5,471.8 					"/>
				</defs>
        <clipPath id="SVGID_00000143578591490463293550000018121522771325038724_">
					<use xlink:href="#SVGID_00000117659305825180675820000014894969518163395732_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000143578591490463293550000018121522771325038724_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000116234964148547568790000012125018682296342416_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000152259687440310458610000005207933920557591183_">
								<use xlink:href="#SVGID_00000116234964148547568790000012125018682296342416_" style="overflow:visible;"/>
							</clipPath>

              <rect x="448.5" y="379"
                    style="clip-path:url(#SVGID_00000152259687440310458610000005207933920557591183_);fill:#226A57;"
                    width="19.5" height="94.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000004535157951221346570000017503263826107567281_" points="481.3,377.7 465.5,386.4 450.6,381
						466.3,372.7 481.3,377.7 					"/>
				</defs>
        <clipPath id="SVGID_00000026147986725211359590000003473072039978000519_">
					<use xlink:href="#SVGID_00000004535157951221346570000017503263826107567281_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000026147986725211359590000003473072039978000519_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000067948341718458859590000008070763428421737359_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000094598392268890100750000015060946225258720913_">
								<use xlink:href="#SVGID_00000067948341718458859590000008070763428421737359_" style="overflow:visible;"/>
							</clipPath>

              <rect x="448.5" y="370.3"
                    style="clip-path:url(#SVGID_00000094598392268890100750000015060946225258720913_);fill:#165748;"
                    width="34.8" height="18.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000054964232650810781560000012570969022128099251_" d="M464.7,367.8c-0.4,0-0.8,0-0.8-0.4l-23.2-35.2
						c-0.4-0.4,0-1.2,0.4-1.7s1.2-0.4,1.7,0l22,32.8l11.6-71.7c0-0.4,0.4-0.8,1.2-1.2c0.4,0,0.8,0,1.2,0.8l12.9,40.2l14.5-88.7
						c0-0.4,0.4-1.2,1.2-1.2c0.4,0,1.2,0.4,1.2,0.8l10.8,51l13.7-37.7c0-0.4,0.8-0.8,1.2-0.8c0.4,0,0.8,0.4,1.2,0.8l10.8,51.8
						l10.8-20.3c0.4-0.4,0.8-0.8,1.2-0.8s0.8,0,0.8,0.4l14.1,31.9c0.4,0.4,0,1.2-0.4,1.7s-1.2,0-1.7-0.4l-13.3-29.8L546.8,311
						c-0.4,0.4-0.8,0.8-1.2,0.8s-0.8-0.4-0.8-0.8l-11.6-51l-13.7,37.7c0,0.4-0.8,0.8-1.2,0.8c-0.4,0-0.8-0.4-0.8-0.8L507,248.8
						l-14.1,87.5c0,0.4-0.4,0.8-1.2,1.2c-0.4,0-0.8,0-1.2-0.8l-12.9-40.2l-11.6,69.6C465.9,366.9,465.5,367.4,464.7,367.8
						L464.7,367.8"/>
				</defs>
        <clipPath id="SVGID_00000129912464771416746060000000741167764561370293_">
					<use xlink:href="#SVGID_00000054964232650810781560000012570969022128099251_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000129912464771416746060000000741167764561370293_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000075128623308690876660000008387746669991108745_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000073683948007348077670000006874875593549159603_">
								<use xlink:href="#SVGID_00000075128623308690876660000008387746669991108745_" style="overflow:visible;"/>
							</clipPath>

              <rect x="437.7" y="239.3"
                    style="clip-path:url(#SVGID_00000073683948007348077670000006874875593549159603_);fill:#226A57;"
                    width="137.2" height="130.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000018236788138490519340000000208799522208468137_" d="M465.9,367.4c-0.4,0-0.8,0-0.8-0.4l-23.2-35.2
						c-0.4-0.4,0-1.2,0.4-1.7s1.2-0.4,1.7,0l22,32.8l11.2-71.3c0-0.4,0.4-0.8,1.2-1.2c0.4,0,0.8,0,1.2,0.8l12.9,40.2l14.5-88.7
						c0-0.4,0.4-1.2,1.2-1.2c0.4,0,1.2,0.4,1.2,0.8l10.8,51l13.7-37.7c0-0.4,0.8-0.8,1.2-0.8c0.4,0,0.8,0.4,1.2,0.8l10.8,51.8
						l10.8-20.3c0.4-0.4,0.8-0.8,1.2-0.8s0.8,0,0.8,0.4l14.1,31.9c0.4,0.4,0,1.2-0.4,1.7s-1.2,0-1.7-0.4l-14.1-29.8L546.8,311
						c-0.4,0.4-0.8,0.8-1.2,0.8s-0.8-0.4-0.8-0.8l-10.8-51l-13.7,37.7c0,0.4-0.8,0.8-1.2,0.8s-0.8-0.4-1.2-0.8l-10.4-48.9
						l-14.1,87.5c0,0.4-0.4,0.8-1.2,1.2c-0.4,0-0.8,0-1.2-0.8l-12.9-40.2l-11.6,69.6C467.2,366.9,466.7,367.4,465.9,367.4
						L465.9,367.4"/>
				</defs>
        <clipPath id="SVGID_00000083086507608602327430000012111149299539206318_">
					<use xlink:href="#SVGID_00000018236788138490519340000000208799522208468137_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000083086507608602327430000012111149299539206318_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000121257263754576915080000004400890126437719740_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000066485360502495745440000010784937341746758069_">
								<use xlink:href="#SVGID_00000121257263754576915080000004400890126437719740_" style="overflow:visible;"/>
							</clipPath>

              <rect x="439" y="238.8"
                    style="clip-path:url(#SVGID_00000066485360502495745440000010784937341746758069_);fill:#FFFFFF;"
                    width="137.2" height="130.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000039098607534272365900000016693067240093446036_" d="M509.9,233c0,2.9-1.2,5-2.9,5.4
						c-1.7,0-2.9-1.7-2.9-4.6c0-2.9,1.2-5,2.9-5.4C508.6,228.1,509.9,230.1,509.9,233"/>
				</defs>
        <clipPath id="SVGID_00000072970010173788448600000015707598341085618074_">
					<use xlink:href="#SVGID_00000039098607534272365900000016693067240093446036_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000072970010173788448600000015707598341085618074_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000103963356631961458150000008853568970293037240_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000090276017231782437580000011961666391509351308_">
								<use xlink:href="#SVGID_00000103963356631961458150000008853568970293037240_" style="overflow:visible;"/>
							</clipPath>

              <rect x="501.6" y="226"
                    style="clip-path:url(#SVGID_00000090276017231782437580000011961666391509351308_);fill:#226A57;"
                    width="10.4" height="14.5"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000011730994078833191090000001363962671825497253_" d="M510.7,233c0,2.9-1.2,5-2.9,5.4
						c-1.7,0-2.9-1.7-2.9-4.6c0-2.9,1.2-5,2.9-5.4C509,228.1,510.7,230.1,510.7,233"/>
				</defs>
        <clipPath id="SVGID_00000078037387433613030220000018106327900562342549_">
					<use xlink:href="#SVGID_00000011730994078833191090000001363962671825497253_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000078037387433613030220000018106327900562342549_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000047034702428735249400000009257751781713766823_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000016060143031316999230000016452967458036575391_">
								<use xlink:href="#SVGID_00000047034702428735249400000009257751781713766823_" style="overflow:visible;"/>
							</clipPath>

              <rect x="502.4" y="226"
                    style="clip-path:url(#SVGID_00000016060143031316999230000016452967458036575391_);fill:#42B994;"
                    width="10.4" height="14.5"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000068668619252612877650000017851182598017337267_" d="M479.2,284.9c0,1.7-0.8,3.3-1.7,3.3
						c-0.8,0-1.7-1.2-1.7-2.9s0.8-3.3,1.7-3.3S479.2,283.2,479.2,284.9"/>
				</defs>
        <clipPath id="SVGID_00000155840739435503241460000012079534628387766961_">
					<use xlink:href="#SVGID_00000068668619252612877650000017851182598017337267_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000155840739435503241460000012079534628387766961_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000066512793510013649950000005632504400049333435_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000045613324973076007830000007553113929609705394_">
								<use xlink:href="#SVGID_00000066512793510013649950000005632504400049333435_" style="overflow:visible;"/>
							</clipPath>

              <rect x="473.4" y="279.5"
                    style="clip-path:url(#SVGID_00000045613324973076007830000007553113929609705394_);fill:#226A57;"
                    width="8.3" height="11.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000062193050066640748520000012164924462659967121_" d="M479.6,284.9c0,1.7-0.8,3.3-1.7,3.3
						c-0.8,0-1.7-1.2-1.7-2.9s0.8-3.3,1.7-3.3S479.6,283.2,479.6,284.9"/>
				</defs>
        <clipPath id="SVGID_00000134966194079508719720000002669013821844265887_">
					<use xlink:href="#SVGID_00000062193050066640748520000012164924462659967121_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000134966194079508719720000002669013821844265887_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000161592031661940860430000013918686039545649580_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000104680400663638173880000016628833899133603716_">
								<use xlink:href="#SVGID_00000161592031661940860430000013918686039545649580_" style="overflow:visible;"/>
							</clipPath>

              <rect x="473.8" y="279.5"
                    style="clip-path:url(#SVGID_00000104680400663638173880000016628833899133603716_);fill:#42B994;"
                    width="8.3" height="11.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000079463582183222809550000001393863952914003073_" d="M536,248c0,1.7-0.8,3.3-1.7,3.3
						c-0.8,0-1.7-1.2-1.7-2.9c0-1.7,0.8-3.3,1.7-3.3C535.1,244.6,536,245.9,536,248"/>
				</defs>
        <clipPath id="SVGID_00000090275405812323024220000010208472377481649792_">
					<use xlink:href="#SVGID_00000079463582183222809550000001393863952914003073_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000090275405812323024220000010208472377481649792_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000059299572743901998710000008218417017224937908_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000025422257158144973280000004124332666128414886_">
								<use xlink:href="#SVGID_00000059299572743901998710000008218417017224937908_" style="overflow:visible;"/>
							</clipPath>

              <rect x="529.8" y="242.6"
                    style="clip-path:url(#SVGID_00000025422257158144973280000004124332666128414886_);fill:#226A57;"
                    width="8.3" height="11.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000075862245780988130000000009631660837644771202_" d="M536.4,248c0,1.7-0.8,3.3-1.7,3.3s-1.7-1.2-1.7-2.9
						c0-1.7,0.8-3.3,1.7-3.3C535.6,244.6,536.4,245.9,536.4,248"/>
				</defs>
        <clipPath id="SVGID_00000155144947775491583770000007522917128707560593_">
					<use xlink:href="#SVGID_00000075862245780988130000000009631660837644771202_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000155144947775491583770000007522917128707560593_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000002356273341483417520000018035033717495581367_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000047744227805394325810000016896385095890453675_">
								<use xlink:href="#SVGID_00000002356273341483417520000018035033717495581367_" style="overflow:visible;"/>
							</clipPath>

              <rect x="530.2" y="242.6"
                    style="clip-path:url(#SVGID_00000047744227805394325810000016896385095890453675_);fill:#42B994;"
                    width="8.3" height="11.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000167362263029661946550000011356246372319374509_" d="M474.6,526.5L474.6,526.5L742,374.4v-24l33.2-19.1
						c0.4,0,0.4-0.4,0.4-0.8s0-0.4,0-0.8s-0.4-0.4-0.8-0.4c0,0,0,0-0.4,0l0,0c0-2.5-0.4-4.6-0.4-7.5c-0.8-8.7-1.7-16.6-3.3-23.2
						c-3.7-15.3-9.5-23.2-17-23.2c-2.5,0-5.4,0.8-8.3,2.5c-1.2,0.8-2.5,1.7-3.3,2.5v-87.1l68.4-39l0.4-44.8l-0.8,257l-67.6,39v-30.7
						L474.6,526.5"/>
				</defs>
        <clipPath id="SVGID_00000043448336043961600610000000943587198759389103_">
					<use xlink:href="#SVGID_00000167362263029661946550000011356246372319374509_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000043448336043961600610000000943587198759389103_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000134963390108375428440000018097999481914720144_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000028309883033440871860000010670321766783771070_">
								<use xlink:href="#SVGID_00000134963390108375428440000018097999481914720144_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="107"
                    style="clip-path:url(#SVGID_00000028309883033440871860000010670321766783771070_);fill:#EBEAE6;"
                    width="340.8" height="421.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000101083475914400546600000006038544432758415030_" d="M477.5,376.5l-2.9-1.2v-52.6l0,0V347l16.6-9.5h0.4
						c0,0,0,0,0.4,0c0,0,0.4,0,0.4-0.4h0.4c0,0,0,0,0.4,0s0.8-0.4,1.2-1.2v-0.4l10.4-5.8v18.2l-11.2-3.7l-15.8,8.7L477.5,376.5
						 M604,400.5L604,400.5L604,400.5c-0.8-2.5-1.2-5-1.7-7c-0.8-4.1-2.1-7.9-4.1-10.4c-2.9-4.1-6.2-6.6-10.8-7v-44.8l-14.9-5.4
						l-11.6,6.2v-9.9l-14.9-5.4l-11.6,6.2v-10.8l8.3-5l0.8,3.3c0,0.4,0.4,0.8,0.8,0.8l0,0c0.4,0,0.4,0,0.8-0.4h0.4l0,0
						c0.4,0,0.8-0.4,1.2-0.8l4.1-7.9l9.1-5.4l9.9,22.4c0,0.4,0.4,0.4,0.8,0.4h0.4l0,0h0.4h0.4c0.4-0.4,0.8-1.2,0.4-1.7l-9.9-22.8
						l178.7-102.4v87.1c-2.9,2.5-5.8,5.4-8.7,9.9c-3.3,4.6-6.6,10.4-10.8,17.8c-4.1,8.3-7.5,13.7-9.1,17c-2.9,5.4-5.4,8.3-6.6,9.1
						c-0.4,0.4-0.8,0.4-1.2,0.4c-2.1,0-4.1-2.9-6.2-8.3c-2.9-9.5-5.4-17-7.5-22c-3.7-9.1-8.3-14.9-12.9-17.4
						c-2.1-0.8-4.1-1.7-6.2-1.7c-5,0-10.8,2.5-17.4,7.5c-10.4,7.9-18.7,17.8-25.3,30.7c-5,9.5-9.1,21.1-12.9,34
						c-1.2,4.6-2.1,9.5-3.3,15.3c-0.8,3.3-1.7,7.5-2.5,12.9c-0.8,4.1-1.7,7.5-2.1,9.5c-0.8,2.5-1.7,4.1-2.9,4.6
						C605.2,400.1,604.4,400.5,604,400.5 M474.6,526.5v-59.7l6.6-3.7v-9.9l11.2,3.7l15.8-8.7v-9.9l11.2,3.7l15.8-8.7v-9.9l5,1.7
						c-0.4,0.8-0.4,2.1-0.8,2.9c-3.7,12.9-5.4,26.1-5.8,39.4l-0.4,0.4c-0.4,0-0.4,0.4-0.4,0.8s0,0.4,0,0.8s0.4,0.4,0.8,0.4
						c0,0,0,0,0.4,0h0.4l33.2-19.1l7.5-4.1l167.9-96.2v24L474.6,526.5"/>
				</defs>
        <clipPath id="SVGID_00000150081286230673305460000000143806785017488822_">
					<use xlink:href="#SVGID_00000101083475914400546600000006038544432758415030_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000150081286230673305460000000143806785017488822_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000094576447462554943110000012767151498106312621_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000129185905283502193620000013243034518766205064_">
								<use xlink:href="#SVGID_00000094576447462554943110000012767151498106312621_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="191.2"
                    style="clip-path:url(#SVGID_00000129185905283502193620000013243034518766205064_);fill:#DCDDD7;"
                    width="272.4" height="337.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000075856343812085354220000015668809962964527798_" points="474.6,558.9 474.6,526.5 742,374.4
						742,405.5 474.6,558.9 					"/>
				</defs>
        <clipPath id="SVGID_00000013157747818758363560000008520294072459126666_">
					<use xlink:href="#SVGID_00000075856343812085354220000015668809962964527798_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000013157747818758363560000008520294072459126666_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000123424779111928079240000006798483665566356403_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000088111716535807187040000014418864108182239122_">
								<use xlink:href="#SVGID_00000123424779111928079240000006798483665566356403_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="372.3"
                    style="clip-path:url(#SVGID_00000088111716535807187040000014418864108182239122_);fill:#868B89;"
                    width="271.9" height="188.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000050632791302827733760000015417113476444955804_" d="M572,380.2v-40.6l15.8-8.7v44.8c-0.4,0-0.8,0-1.2,0
						C582.4,375.6,577.8,377.3,572,380.2"/>
				</defs>
        <clipPath id="SVGID_00000165198283130085709010000016934406041716633243_">
					<use xlink:href="#SVGID_00000050632791302827733760000015417113476444955804_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000165198283130085709010000016934406041716633243_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000165928599969719165940000003519228540084703382_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000160868915715430149450000003792804300624266667_">
								<use xlink:href="#SVGID_00000165928599969719165940000003519228540084703382_" style="overflow:visible;"/>
							</clipPath>

              <rect x="570" y="328.8"
                    style="clip-path:url(#SVGID_00000160868915715430149450000003792804300624266667_);fill:#95CCB9;"
                    width="19.9" height="53.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000046315537726823952760000002033987030591729579_" d="M561.3,388.1v-52.6l11.2,3.7v40.6
						c-0.4,0-0.4,0.4-0.8,0.4C567.5,382.7,564.2,385.2,561.3,388.1"/>
				</defs>
        <clipPath id="SVGID_00000096777878637920855450000009571679246158782895_">
					<use xlink:href="#SVGID_00000046315537726823952760000002033987030591729579_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000096777878637920855450000009571679246158782895_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000027588183375071717430000010791723411126348470_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000106116887190344733600000001737438683144581006_">
								<use xlink:href="#SVGID_00000027588183375071717430000010791723411126348470_" style="overflow:visible;"/>
							</clipPath>

              <rect x="558.8" y="333.4"
                    style="clip-path:url(#SVGID_00000106116887190344733600000001737438683144581006_);fill:#82A79C;"
                    width="15.8" height="57.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000114789837187854891080000010805169387500048056_" points="572,339.2 561.3,335.4 561.3,332.1
						572.9,325.5 587.8,330.9 572,339.2 					"/>
				</defs>
        <clipPath id="SVGID_00000075145875884532186550000002710708083593590166_">
					<use xlink:href="#SVGID_00000114789837187854891080000010805169387500048056_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000075145875884532186550000002710708083593590166_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000113342096679312772670000011459933946819989146_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000074443841754712539230000008731147941774228613_">
								<use xlink:href="#SVGID_00000113342096679312772670000011459933946819989146_" style="overflow:visible;"/>
							</clipPath>

              <rect x="558.8" y="323.4"
                    style="clip-path:url(#SVGID_00000074443841754712539230000008731147941774228613_);fill:#7FA096;"
                    width="31.1" height="18.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000159469555803366530950000008634388121045229725_" d="M545.5,409.6v-79.2l15.8-8.7v9.9v3.3v52.6
						C555,393.9,549.7,400.9,545.5,409.6"/>
				</defs>
        <clipPath id="SVGID_00000147922676527075644670000007273636101266767771_">
					<use xlink:href="#SVGID_00000159469555803366530950000008634388121045229725_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000147922676527075644670000007273636101266767771_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000021818667548806179730000014030539491445308808_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000176747207405882377430000009039152425648844966_">
								<use xlink:href="#SVGID_00000021818667548806179730000014030539491445308808_" style="overflow:visible;"/>
							</clipPath>

              <rect x="543.4" y="319.7"
                    style="clip-path:url(#SVGID_00000176747207405882377430000009039152425648844966_);fill:#95CCB9;"
                    width="19.9" height="92"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000082327060548984917780000005441927779482284176_" d="M539.3,425.4l-5-1.7v-97l11.2,3.7v79.2
						C543,414.6,541.4,419.6,539.3,425.4"/>
				</defs>
        <clipPath id="SVGID_00000007403122705929986640000004355608660138531496_">
					<use xlink:href="#SVGID_00000082327060548984917780000005441927779482284176_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000007403122705929986640000004355608660138531496_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000082355038839442306420000015821939262865594003_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000053542114894000153190000013736681323647576723_">
								<use xlink:href="#SVGID_00000082355038839442306420000015821939262865594003_" style="overflow:visible;"/>
							</clipPath>

              <rect x="532.2" y="324.2"
                    style="clip-path:url(#SVGID_00000053542114894000153190000013736681323647576723_);fill:#82A79C;"
                    width="15.8" height="103.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000029764834543398578590000017336584429038619536_" points="545.5,330.5 534.3,326.7 534.3,323
						546.3,316.8 561.3,322.2 545.5,330.5 					"/>
				</defs>
        <clipPath id="SVGID_00000026885739648746662520000015639863456308307844_">
					<use xlink:href="#SVGID_00000029764834543398578590000017336584429038619536_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000026885739648746662520000015639863456308307844_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000000908772760591140500000011611660115573648806_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000177469503644548029400000001786070596845962672_">
								<use xlink:href="#SVGID_00000000908772760591140500000011611660115573648806_" style="overflow:visible;"/>
							</clipPath>

              <rect x="532.2" y="314.7"
                    style="clip-path:url(#SVGID_00000177469503644548029400000001786070596845962672_);fill:#7FA096;"
                    width="31.1" height="18.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000121258351980381427470000015728325014239904434_" points="519,442.4 519,442.4 519,321.3 534.3,312.6
						534.3,323 534.3,326.7 534.3,433.7 519,442.4 					"/>
				</defs>
        <clipPath id="SVGID_00000082350853867387064580000011162392525935469957_">
					<use xlink:href="#SVGID_00000121258351980381427470000015728325014239904434_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000082350853867387064580000011162392525935469957_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000087387821007380450810000014486374523769048242_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000001629993677818365730000013634425996993435550_">
								<use xlink:href="#SVGID_00000087387821007380450810000014486374523769048242_" style="overflow:visible;"/>
							</clipPath>

              <rect x="516.5" y="310.6"
                    style="clip-path:url(#SVGID_00000001629993677818365730000013634425996993435550_);fill:#95CCB9;"
                    width="19.9" height="134.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000104682760614013315660000003968822991954912425_" points="519,442.4 507.8,438.2 507.8,349.5
						504.1,348.3 504.1,330 519,321.3 519,442.4 					"/>
				</defs>
        <clipPath id="SVGID_00000117655492016393801730000015538988726658591404_">
					<use xlink:href="#SVGID_00000104682760614013315660000003968822991954912425_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000117655492016393801730000015538988726658591404_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000154399063610282510080000016885090328065525393_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000169528222782691792460000017752206198152009650_">
								<use xlink:href="#SVGID_00000154399063610282510080000016885090328065525393_" style="overflow:visible;"/>
							</clipPath>

              <rect x="501.6" y="319.3"
                    style="clip-path:url(#SVGID_00000169528222782691792460000017752206198152009650_);fill:#82A79C;"
                    width="19.5" height="125.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000163054936349841112740000016220476055747913881_" points="492.4,456.9 492.4,456.9 492.4,358.2
						507.8,349.5 507.8,438.2 507.8,448.6 492.4,456.9 					"/>
				</defs>
        <clipPath id="SVGID_00000059995851554149757250000010139511341314062240_">
					<use xlink:href="#SVGID_00000163054936349841112740000016220476055747913881_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000059995851554149757250000010139511341314062240_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000051370897875231106550000011165697214953523622_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000085234676818731085460000017141677725012278199_">
								<use xlink:href="#SVGID_00000051370897875231106550000011165697214953523622_" style="overflow:visible;"/>
							</clipPath>

              <rect x="490" y="347.5"
                    style="clip-path:url(#SVGID_00000085234676818731085460000017141677725012278199_);fill:#95CCB9;"
                    width="19.9" height="111.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000054968331394435490880000004213335970971006879_" points="492.4,456.9 481.3,453.2 481.3,377.7
						477.5,376.5 477.5,352.8 492.4,358.2 492.4,456.9 					"/>
				</defs>
        <clipPath id="SVGID_00000075162532953984123010000017845978584595915925_">
					<use xlink:href="#SVGID_00000054968331394435490880000004213335970971006879_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000075162532953984123010000017845978584595915925_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000125598145625280668820000008115116102888048548_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000080912406200281561270000005099564223201246620_">
								<use xlink:href="#SVGID_00000125598145625280668820000008115116102888048548_" style="overflow:visible;"/>
							</clipPath>

              <rect x="475" y="350.8"
                    style="clip-path:url(#SVGID_00000080912406200281561270000005099564223201246620_);fill:#82A79C;"
                    width="19.5" height="108.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000135649545728956992570000012509054800963281582_" points="492.4,358.2 477.5,352.8 492.9,344.6
						507.8,349.5 492.4,358.2 					"/>
				</defs>
        <clipPath id="SVGID_00000043421841498839873530000009338325046645017243_">
					<use xlink:href="#SVGID_00000135649545728956992570000012509054800963281582_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000043421841498839873530000009338325046645017243_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000063606166430450228930000001936185177724678078_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000013171533196272798420000007217385931521309590_">
								<use xlink:href="#SVGID_00000063606166430450228930000001936185177724678078_" style="overflow:visible;"/>
							</clipPath>

              <rect x="475" y="342.1"
                    style="clip-path:url(#SVGID_00000013171533196272798420000007217385931521309590_);fill:#7FA096;"
                    width="34.8" height="18.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000112619057673170316970000015627103058098590117_" points="474.2,466.9 474.2,381.5 481.3,377.7
						481.3,463.1 474.2,466.9 					"/>
				</defs>
        <clipPath id="SVGID_00000169557810690997753170000004222256709598401459_">
					<use xlink:href="#SVGID_00000112619057673170316970000015627103058098590117_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000169557810690997753170000004222256709598401459_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000183929528712938702460000009116349934286584990_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000176734833954186404080000011528978773520280976_">
								<use xlink:href="#SVGID_00000183929528712938702460000009116349934286584990_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="375.6"
                    style="clip-path:url(#SVGID_00000176734833954186404080000011528978773520280976_);fill:#95CCB9;"
                    width="11.2" height="93.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000039826559295659979090000017210856415107850907_" points="474.2,381.5 474.2,375.6 477.5,376.5
						481.3,377.7 474.2,381.5 					"/>
				</defs>
        <clipPath id="SVGID_00000168831818287700683950000007805792694554886302_">
					<use xlink:href="#SVGID_00000039826559295659979090000017210856415107850907_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000168831818287700683950000007805792694554886302_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000163780792984547272840000004073637321228269746_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000010301870310793464110000000308843927649819017_">
								<use xlink:href="#SVGID_00000163780792984547272840000004073637321228269746_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="373.2"
                    style="clip-path:url(#SVGID_00000010301870310793464110000000308843927649819017_);fill:#7FA096;"
                    width="11.2" height="10.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000148627568886264440980000017852026400536829314_" d="M546.3,307.2l-0.4-1.2l1.2-0.8L546.3,307.2
						 M474.2,308.9v-6.2V308.9L474.2,308.9 M544.7,311.8L544.7,311.8c-0.4,0-0.8-0.4-0.8-0.8l-0.8-3.3l1.2-0.4l0.8,3.7
						c0,0.4,0.4,0.4,0.4,0.8C545.1,311.8,544.7,311.8,544.7,311.8 M571.2,320.5c-0.4,0-0.8,0-0.8-0.4l-9.9-22.4l0.8-0.4L571.2,320.5
						C571.2,320.5,571.6,320.5,571.2,320.5L571.2,320.5C571.6,320.5,571.6,320.5,571.2,320.5 M491.2,337.5L491.2,337.5L491.2,337.5
						h0.8C492,337.5,491.6,337.5,491.2,337.5C491.6,337.5,491.2,337.5,491.2,337.5"/>
				</defs>
        <clipPath id="SVGID_00000034054342441768105230000016477522746967157950_">
					<use xlink:href="#SVGID_00000148627568886264440980000017852026400536829314_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000034054342441768105230000016477522746967157950_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000115496562910083073120000005251330299498779580_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000155848900508259770890000003844267823029976972_">
								<use xlink:href="#SVGID_00000115496562910083073120000005251330299498779580_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="294.8"
                    style="clip-path:url(#SVGID_00000155848900508259770890000003844267823029976972_);fill:#82A79C;"
                    width="102" height="45.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000031185949232445582170000012587409873243996571_" d="M545.9,311.8C545.9,311.8,545.5,311.8,545.9,311.8
						L545.9,311.8c-0.8,0-0.8-0.4-0.8-0.8l-0.8-3.7l2.1-1.2l0.4,1.2l1.2-2.1l3.7-2.1l-4.1,7.9C546.8,311.4,546.3,311.8,545.9,311.8
						 M572.5,320.5L572.5,320.5c-0.8,0-0.8-0.4-0.8-0.4l-9.9-22.8l2.1-1.2l9.9,22.8c0.4,0.4,0,1.2-0.4,1.7
						C572.9,320.5,572.5,320.5,572.5,320.5 M474.2,322.6v-13.7l0,0V322.6L474.2,322.6 M492.4,337.5L492.4,337.5
						c-0.4,0-0.8,0-0.8-0.4l2.1-1.2v0.4C493.7,337.1,493.3,337.5,492.4,337.5L492.4,337.5"/>
				</defs>
        <clipPath id="SVGID_00000151506125889714401520000013475980733444738748_">
					<use xlink:href="#SVGID_00000031185949232445582170000012587409873243996571_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000151506125889714401520000013475980733444738748_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000068677978506804081500000017866920804554746290_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000117657844369169125200000012032272899753270672_">
								<use xlink:href="#SVGID_00000068677978506804081500000017866920804554746290_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="293.6"
                    style="clip-path:url(#SVGID_00000117657844369169125200000012032272899753270672_);fill:#EBEBE7;"
                    width="104.1" height="46"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000150093315326383427690000009148536315843266222_" points="810.8,109.5 474.2,302.7 464.7,299
						798.4,109.5 810.8,109.5 					"/>
				</defs>
        <clipPath id="SVGID_00000047025717421444234740000008172410691197282951_">
					<use xlink:href="#SVGID_00000150093315326383427690000009148536315843266222_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000047025717421444234740000008172410691197282951_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000128479983356281769080000006914272395165972151_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000031923724778461510880000010421509502525770175_">
								<use xlink:href="#SVGID_00000128479983356281769080000006914272395165972151_" style="overflow:visible;"/>
							</clipPath>

              <rect x="462.6" y="107"
                    style="clip-path:url(#SVGID_00000031923724778461510880000010421509502525770175_);fill:#999A98;"
                    width="350.3" height="197.7"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000138573438822973216170000010673195205680872839_" points="464.7,299 465.9,553.1 474.6,558.9
						474.2,302.7 464.7,299 					"/>
				</defs>
        <clipPath id="SVGID_00000155104750753940878990000011188244722643248046_">
					<use xlink:href="#SVGID_00000138573438822973216170000010673195205680872839_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000155104750753940878990000011188244722643248046_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000000193806344112426700000008707217509596367767_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000059277271637122463850000008678434777581141897_">
								<use xlink:href="#SVGID_00000000193806344112426700000008707217509596367767_" style="overflow:visible;"/>
							</clipPath>

              <rect x="462.6" y="296.9"
                    style="clip-path:url(#SVGID_00000059277271637122463850000008678434777581141897_);fill:#999A98;"
                    width="14.1" height="264.1"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000155140534092308037430000002469996394695418295_" d="M791.8,136.5c-0.8,0-1.7,0.4-2.9,0.8
						c-2.9,1.7-5,5-5.8,8.3c0,0.8-0.4,1.2-0.4,2.1c0,2.5,1.2,4.1,3.3,4.1c0.8,0,1.7-0.4,2.9-0.8c3.3-2.1,6.2-6.6,6.2-10.4
						c0-2.1-0.8-3.3-1.7-3.7C792.6,136.5,792.2,136.5,791.8,136.5 M771.4,148.9c-0.8,0-1.7,0.4-2.9,0.8c-2.9,1.7-5,5-5.8,8.3
						c0,0.8,0,1.2,0,2.1c0,2.5,1.2,4.1,3.3,4.1c0.8,0,1.7-0.4,2.9-0.8c3.3-2.1,6.2-6.6,6.2-10.4c0-2.1-0.8-3.3-1.7-3.7
						C772.3,148.9,771.9,148.9,771.4,148.9 M751.1,160.1c-0.8,0-1.7,0.4-2.9,0.8c-2.9,1.7-5,5-5.8,8.3c0,0.8,0,1.2,0,2.1
						c0,2.5,1.2,4.1,3.3,4.1c0.8,0,1.7-0.4,2.9-0.8c3.3-2.1,6.2-6.6,6.2-10.4c0-2.1-0.8-3.3-1.7-3.7
						C752.4,160.5,752,160.1,751.1,160.1 M742.4,193.2v-44.8l68.4-39.4l-0.4,44.8L742.4,193.2"/>
				</defs>
        <use xlink:href="#SVGID_00000155140534092308037430000002469996394695418295_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000142157333191830713010000006771342043777884058_">
					<use xlink:href="#SVGID_00000155140534092308037430000002469996394695418295_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000142157333191830713010000006771342043777884058_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000130621497719262316000000008687929454509825982_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000130621497719262316000000008687929454509825982_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000008142798140722091530000017033555547568096390_">
								<use xlink:href="#SVGID_00000130621497719262316000000008687929454509825982_" style="overflow:visible;"/>
							</clipPath>

              <rect x="739.9" y="107"
                    style="clip-path:url(#SVGID_00000008142798140722091530000017033555547568096390_);fill:#6B59A6;"
                    width="73" height="88.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000075848132130983784230000009518895989681516725_" d="M519,291.1l-2.5-12.4l9.1-5.4L519,291.1 M550.9,303.1
						l6.2-12l2.9,6.6L550.9,303.1 M545.9,305.6l-8.3-39.4L742,148.9v44.8L563.3,296.1l-4.1-9.1c0-0.4-0.4-0.4-0.8-0.4l0,0
						c-0.4,0-0.4,0-0.8,0.4h-0.4l0,0c-0.4,0-0.8,0.4-1.2,0.8L545.9,305.6 M491.6,328.8l-9.5-30.7l16.2-9.1L491.6,328.8 M493.7,335.9
						l7.9-48.9l11.6-6.6l3.7,17.4c0,0.4,0.4,0.8,0.8,0.8l0,0c0.4,0,0.4,0,0.8-0.4h0.4l0,0c0.4,0,0.8-0.4,1.2-0.8l9.9-26.9l4.6-2.5
						l8.3,39.8l-8.3,5v-3.7l-14.9-5.4l-15.8,8.7V330L493.7,335.9 M474.6,347v-24.5l3.7-22l0.8-0.4l11.6,36.9c0,0.4,0.4,0.4,0.4,0.4
						L474.6,347"/>
				</defs>
        <use xlink:href="#SVGID_00000075848132130983784230000009518895989681516725_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000155828084111042749960000006595407977177333642_">
					<use xlink:href="#SVGID_00000075848132130983784230000009518895989681516725_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000155828084111042749960000006595407977177333642_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000022528964346400194580000018159987162658725304_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000022528964346400194580000018159987162658725304_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000075855077475667754020000012949324476827793076_">
								<use xlink:href="#SVGID_00000022528964346400194580000018159987162658725304_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="146.4"
                    style="clip-path:url(#SVGID_00000075855077475667754020000012949324476827793076_);fill:#6B59A6;"
                    width="272.4" height="202.7"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000087410156255762852030000014817833724087819197_" points="519,321.3 519,317.2 534.3,308.9
						534.3,312.6 519,321.3 					"/>
				</defs>
        <clipPath id="SVGID_00000155833463667436801640000005654997322893523131_">
					<use xlink:href="#SVGID_00000087410156255762852030000014817833724087819197_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000155833463667436801640000005654997322893523131_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000066487125833113251320000014507214566471203248_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000002371242808352070470000001923251312826728605_">
								<use xlink:href="#SVGID_00000066487125833113251320000014507214566471203248_" style="overflow:visible;"/>
							</clipPath>

              <rect x="516.5" y="306.4"
                    style="clip-path:url(#SVGID_00000002371242808352070470000001923251312826728605_);fill:#548D7A;"
                    width="19.9" height="17"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000152242381241748307060000006223637515455609011_" points="504.1,330 504.1,312.2 519,317.2 519,321.3
						504.1,330 					"/>
				</defs>
        <clipPath id="SVGID_00000145741102894558187980000011279562450950156166_">
					<use xlink:href="#SVGID_00000152242381241748307060000006223637515455609011_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000145741102894558187980000011279562450950156166_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000003088788586309890360000014615835910715903416_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000047766464845995924950000002809789182448937650_">
								<use xlink:href="#SVGID_00000003088788586309890360000014615835910715903416_" style="overflow:visible;"/>
							</clipPath>

              <rect x="501.6" y="309.7"
                    style="clip-path:url(#SVGID_00000047766464845995924950000002809789182448937650_);fill:#4D8271;"
                    width="19.5" height="22.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000050662460770479843080000015676640081698971540_" points="519,317.2 504.1,312.2 519.4,303.5
						534.3,308.9 519,317.2 					"/>
				</defs>
        <clipPath id="SVGID_00000163048162173689481140000003911771556902673543_">
					<use xlink:href="#SVGID_00000050662460770479843080000015676640081698971540_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000163048162173689481140000003911771556902673543_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000113316140560679695940000004260931964495571623_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000129199487758449653300000006347128683897959322_">
								<use xlink:href="#SVGID_00000113316140560679695940000004260931964495571623_" style="overflow:visible;"/>
							</clipPath>

              <rect x="501.6" y="301.4"
                    style="clip-path:url(#SVGID_00000129199487758449653300000006347128683897959322_);fill:#4A7F6F;"
                    width="34.8" height="18.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000046336349793892252370000014016147211628031892_" d="M519.4,293.2l-0.4-2.1l6.6-17.8l1.2-0.8L519.4,293.2
						 M560.4,297.7l-2.9-6.6l0.8-1.2l3.3,7.5L560.4,297.7 M517.7,298.5c-0.4,0-0.8-0.4-0.8-0.8l-3.7-17.4l1.2-0.4l3.7,17.8
						c0,0.4,0.4,0.4,0.4,0.8C518.6,298.5,518.1,298.5,517.7,298.5C518.1,298.5,517.7,298.5,517.7,298.5 M546.3,306L546.3,306
						l9.9-19.1c0.4-0.4,0.8-0.8,1.2-0.8l0,0h0.4l-0.4,0.4l-9.9,18.2L546.3,306 M543,307.7l-8.3-39.8l1.2-0.4l8.3,39.8L543,307.7
						 M474.2,308.9v-6.2l1.2-0.8L474.2,308.9 M492.4,331.3l-0.8-2.5l6.6-39.8l1.2-0.8L492.4,331.3 M490.8,337.5
						C490.4,337.5,490.4,337.1,490.8,337.5l-12-37.3l0.8-0.4L490.8,337.5L490.8,337.5L490.8,337.5"/>
				</defs>
        <clipPath id="SVGID_00000040537660143000389780000005112159796579313537_">
					<use xlink:href="#SVGID_00000046336349793892252370000014016147211628031892_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000040537660143000389780000005112159796579313537_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000024710707882916994600000005113766090138418828_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000143615698692890654580000013953922545116376729_">
								<use xlink:href="#SVGID_00000024710707882916994600000005113766090138418828_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="265.4"
                    style="clip-path:url(#SVGID_00000143615698692890654580000013953922545116376729_);fill:#4D8271;"
                    width="91.6" height="74.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000047772985554268769080000012250907594642902682_" d="M519,298.5L519,298.5c-0.8,0-0.8-0.4-0.8-0.8
						l-3.7-17.8l2.1-1.2l2.9,14.5l7.5-20.7l2.9-1.7l-9.9,26.9C520.2,298.1,519.8,298.5,519,298.5L519,298.5 M547.6,305.2l9.9-18.2
						l0.4-0.4c0,0,0.4-0.4,0.8-0.4l0,0c0.4,0,0.8,0.4,0.8,0.4l4.1,9.1l-2.1,1.2l-3.7-7l-7,13.3L547.6,305.2 M543.9,307.2l-8.3-39.8
						l2.1-1.2l8.3,39.4v0.4L543.9,307.2 M474.2,322.6v-13.7l1.2-6.6l2.5-1.7L474.2,322.6 M491.6,337.1L491.6,337.1l-12-37.3l2.1-1.2
						l10.4,32.8l7-42.7l2.5-1.7l-7.9,48.9L491.6,337.1"/>
				</defs>
        <clipPath id="SVGID_00000043443760178525561210000002249277290236946073_">
					<use xlink:href="#SVGID_00000047772985554268769080000012250907594642902682_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000043443760178525561210000002249277290236946073_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000170243062864845414970000017703536971143855013_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000053528542511090821680000005226708560919254150_">
								<use xlink:href="#SVGID_00000170243062864845414970000017703536971143855013_" style="overflow:visible;"/>
							</clipPath>

              <rect x="472.1" y="264.1"
                    style="clip-path:url(#SVGID_00000053528542511090821680000005226708560919254150_);fill:#699687;"
                    width="93.7" height="75.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000013193526354598107660000008628445895324498311_" d="M745.7,175.4c-2.1,0-3.3-1.7-3.3-4.1
						c0-0.4,0-1.2,0-2.1c0.8-3.3,2.9-6.6,5.8-8.3c0.8-0.4,2.1-0.8,2.9-0.8c0.4,0,1.2,0,1.7,0.4c1.2,0.4,1.7,2.1,1.7,3.7
						c0,3.7-2.9,8.3-6.2,10.4C747.4,175.4,746.6,175.4,745.7,175.4"/>
				</defs>
        <clipPath id="SVGID_00000094578955112991459980000007855919665849311126_">
					<use xlink:href="#SVGID_00000013193526354598107660000008628445895324498311_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000094578955112991459980000007855919665849311126_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000148649179718381499730000000923208999906948995_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000160148688567019143240000001402796388185941688_">
								<use xlink:href="#SVGID_00000148649179718381499730000000923208999906948995_" style="overflow:visible;"/>
							</clipPath>

              <rect x="740.4" y="158"
                    style="clip-path:url(#SVGID_00000160148688567019143240000001402796388185941688_);fill:#C9DAD1;"
                    width="16.6" height="19.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000133501666260956879760000008698194635100842650_" d="M766.1,164.2c-2.1,0-3.3-1.7-3.3-4.1
						c0-0.4,0-1.2,0-2.1c0.8-3.3,2.9-6.6,5.8-8.3c0.8-0.4,2.1-0.8,2.9-0.8c0.4,0,1.2,0,1.7,0.4c1.2,0.4,1.7,2.1,1.7,3.7
						c0,3.7-2.9,8.3-6.2,10.4C767.7,163.8,766.9,164.2,766.1,164.2"/>
				</defs>
        <clipPath id="SVGID_00000148619759762829847970000000836169909675194507_">
					<use xlink:href="#SVGID_00000133501666260956879760000008698194635100842650_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000148619759762829847970000000836169909675194507_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000077313320690751840980000009360598259538807730_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000026146331970889443480000000364050091786233758_">
								<use xlink:href="#SVGID_00000077313320690751840980000009360598259538807730_" style="overflow:visible;"/>
							</clipPath>

              <rect x="760.2" y="146.4"
                    style="clip-path:url(#SVGID_00000026146331970889443480000000364050091786233758_);fill:#C9DAD1;"
                    width="16.6" height="19.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000012437191281226494900000006501195549256640903_" d="M786,151.8c-2.1,0-3.3-1.7-3.3-4.1
						c0-0.4,0-1.2,0.4-2.1c0.8-3.3,2.9-6.6,5.8-8.3c0.8-0.4,2.1-0.8,2.9-0.8c0.4,0,1.2,0,1.7,0.4c1.2,0.4,1.7,2.1,1.7,3.7
						c0,3.7-2.9,8.3-6.2,10.4C788,151.4,786.8,151.8,786,151.8"/>
				</defs>
        <clipPath id="SVGID_00000071543200229051254740000009857149473987777666_">
					<use xlink:href="#SVGID_00000012437191281226494900000006501195549256640903_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000071543200229051254740000009857149473987777666_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000084509065046007768580000003577362753341164706_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000165949203448966399880000016773845115836023997_">
								<use xlink:href="#SVGID_00000084509065046007768580000003577362753341164706_" style="overflow:visible;"/>
							</clipPath>

              <rect x="780.6" y="134.4"
                    style="clip-path:url(#SVGID_00000165949203448966399880000016773845115836023997_);fill:#C9DAD1;"
                    width="16.6" height="19.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000126315266608797559090000008401838554562582179_" d="M565.8,449l7.5-4.1l15.8-9.1l184.9-106.1
						c0.4,0,0.4,0,0.8,0s0.4,0.4,0.8,0.4c0,0.4,0,0.4,0,0.8s-0.4,0.4-0.4,0.8L574.1,447l-7.5,4.1l-33.2,19.1c-0.4,0-0.4,0-0.8,0
						s-0.4-0.4-0.8-0.4c0-0.4,0-0.4,0-0.8s0.4-0.4,0.4-0.8l30.3-17.4L565.8,449"/>
				</defs>
        <clipPath id="SVGID_00000059267427317124506230000002225941632719441337_">
					<use xlink:href="#SVGID_00000126315266608797559090000008401838554562582179_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000059267427317124506230000002225941632719441337_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000043448849584670721890000007486117577935862178_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000084514892268090787100000003488946270571185576_">
								<use xlink:href="#SVGID_00000043448849584670721890000007486117577935862178_" style="overflow:visible;"/>
							</clipPath>

              <rect x="529.3" y="327.1"
                    style="clip-path:url(#SVGID_00000084514892268090787100000003488946270571185576_);fill:#165748;"
                    width="248.7" height="145.5"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000065043857932102153160000007817995431338106020_" d="M781,281.5c-0.4-0.4-0.8-0.4-1.2-0.8l0,0
						c-1.2-1.2-1.7-2.9-1.7-4.6s0.8-3.3,2.1-4.6c1.2-1.2,2.9-2.1,4.6-2.1c1.7,0,3.3,0.8,4.6,2.1c1.2,1.2,2.1,2.9,2.1,4.6
						c0,1.7-0.8,3.3-2.1,4.6c-1.2,1.2-2.9,2.1-4.6,2.1C783.1,282.4,781.8,282.4,781,281.5"/>
				</defs>
        <clipPath id="SVGID_00000116940640227669638680000011294698791379794104_">
					<use xlink:href="#SVGID_00000065043857932102153160000007817995431338106020_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000116940640227669638680000011294698791379794104_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000010299721470181787920000004765727167003350927_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000029017945337917109410000002048770788001167516_">
								<use xlink:href="#SVGID_00000010299721470181787920000004765727167003350927_" style="overflow:visible;"/>
							</clipPath>

              <rect x="775.6" y="267.5"
                    style="clip-path:url(#SVGID_00000029017945337917109410000002048770788001167516_);fill:#165748;"
                    width="17.4" height="17.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000154414757790364949800000018066477696207086773_" d="M725.8,263.3c-0.4,0.8-0.8,1.2-1.2,2.1
						c-1.2,1.2-2.9,2.1-4.6,2.1c-1.7,0-3.3-0.8-4.6-2.1c-0.4-0.4-0.4-0.4-0.4-0.8c-0.4-0.4-0.8-0.8-0.8-1.7
						c-0.4-0.8-0.4-1.7-0.4-2.5c0-1.7,0.8-3.3,2.1-4.6c1.2-1.2,2.9-2.1,4.6-2.1c1.7,0,3.3,0.8,4.6,2.1c1.2,1.2,2.1,2.9,2.1,4.6
						c0,0.4,0,0.8,0,0.8C726.3,262.1,725.8,262.9,725.8,263.3"/>
				</defs>
        <clipPath id="SVGID_00000153684832263559116940000008123670069130320279_">
					<use xlink:href="#SVGID_00000154414757790364949800000018066477696207086773_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000153684832263559116940000008123670069130320279_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000016044167693087518370000001014381735413012377_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000106135713856487361340000014393261395480711836_">
								<use xlink:href="#SVGID_00000016044167693087518370000001014381735413012377_" style="overflow:visible;"/>
							</clipPath>

              <rect x="711.3" y="252.1"
                    style="clip-path:url(#SVGID_00000106135713856487361340000014393261395480711836_);fill:#165748;"
                    width="17.4" height="17.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000127036166164569196340000005424672554602708127_" d="M506.1,419.2c0.8,1.2,1.2,2.5,1.2,3.7
						c0,1.7-0.8,3.3-2.1,4.6c-1.2,1.2-2.9,2.1-4.6,2.1s-3.3-0.8-4.6-2.1c-1.2-1.2-2.1-2.9-2.1-4.6s0.8-3.3,2.1-4.6
						c1.2-1.2,2.9-2.1,4.6-2.1s2.9,0.4,4.1,1.2l0.4,0.4C505.7,418.8,505.7,418.8,506.1,419.2"/>
				</defs>
        <clipPath id="SVGID_00000075875443132147315510000010674013350057652400_">
					<use xlink:href="#SVGID_00000127036166164569196340000005424672554602708127_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000075875443132147315510000010674013350057652400_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000052819249653939403640000013963067160853724814_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000092439198021602879250000007003462589534821548_">
								<use xlink:href="#SVGID_00000052819249653939403640000013963067160853724814_" style="overflow:visible;"/>
							</clipPath>

              <rect x="492" y="414.2"
                    style="clip-path:url(#SVGID_00000092439198021602879250000007003462589534821548_);fill:#165748;"
                    width="17.4" height="17.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000143617759745975386120000009411308897985483165_" d="M742,347.9v-67.6c1.2-0.8,2.5-1.7,3.3-2.5
						c2.9-1.7,5.8-2.5,8.3-2.5c7.5,0,13.3,7.9,17,23.2c1.7,6.6,2.9,14.5,3.3,23.2c0.4,2.5,0.4,5,0.4,7.5h-0.4L742,347.9"/>
				</defs>
        <clipPath id="SVGID_00000130643023676839990260000003504480322934951857_">
					<use xlink:href="#SVGID_00000143617759745975386120000009411308897985483165_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000130643023676839990260000003504480322934951857_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000052822086655627208970000009244479236431888829_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000081620770470016503930000013349514507703949501_">
								<use xlink:href="#SVGID_00000052822086655627208970000009244479236431888829_" style="overflow:visible;"/>
							</clipPath>

              <rect x="739.9" y="273.3"
                    style="clip-path:url(#SVGID_00000081620770470016503930000013349514507703949501_);fill:#A4B6AD;"
                    width="36.9" height="77.1"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000121239851993277564390000000157298123600312744_" d="M532.7,468.1c0-13.7,2.1-26.5,5.8-39.4
						c0.4-0.8,0.4-2.1,0.8-2.9l6.2,2.1l15.8-8.7v-9.9l11.2,3.7l15.8-8.7v-28.6c4.6,0.4,8.3,2.9,10.8,7c1.7,2.5,2.9,6.2,4.1,10.4
						c0.4,2.1,0.8,4.6,1.2,6.6v0.4c0,0,0,0,0.4,0s0.8-0.4,1.7-0.8c0.8-0.4,2.1-2.1,2.9-4.6c0.8-2.1,1.2-5,2.1-9.5
						c0.8-5.4,1.7-9.5,2.5-12.9c1.2-5.8,2.1-11.2,3.3-15.3c3.3-12.9,7.5-24.5,12.9-34c6.6-12.4,15.3-22.8,25.3-30.7
						c6.6-5,12.4-7.5,17.4-7.5c2.5,0,4.6,0.4,6.2,1.7c5,2.5,9.1,8.3,12.9,17.4c2.1,5,4.6,12.4,7.5,22c2.1,5.4,4.1,8.3,6.2,8.3
						c0.4,0,0.8,0,1.2-0.4c1.7-0.8,3.7-3.7,6.6-9.1c1.7-3.3,5-8.7,9.1-17c4.1-7.5,7.9-13.7,10.8-17.8c2.9-4.1,5.8-7.5,8.7-9.9v67.6
						l-153,88.3l-15.8,9.1l-7.5,4.1l-3.3,1.7L532.7,468.1"/>
				</defs>
        <clipPath id="SVGID_00000078765267498667009950000016116814448130351036_">
					<use xlink:href="#SVGID_00000121239851993277564390000000157298123600312744_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000078765267498667009950000016116814448130351036_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000105388286411118611580000001200572427973408655_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000017486512574832707420000002261923562419842463_">
								<use xlink:href="#SVGID_00000105388286411118611580000001200572427973408655_" style="overflow:visible;"/>
							</clipPath>

              <rect x="530.6" y="278.2"
                    style="clip-path:url(#SVGID_00000017486512574832707420000002261923562419842463_);fill:#A2B3AB;"
                    width="213.9" height="192.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000080904540992546603480000000888961666764643460_" d="M572,413L572,413v-32.8c5.4-2.9,10.4-4.6,14.1-4.6
						c0.4,0,0.8,0,1.2,0v28.6L572,413"/>
				</defs>
        <clipPath id="SVGID_00000065763583945641865820000016790557623336431543_">
					<use xlink:href="#SVGID_00000080904540992546603480000000888961666764643460_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000065763583945641865820000016790557623336431543_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000088847849337073820470000009976494675416550033_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000157296394222284296770000007093286671722937501_">
								<use xlink:href="#SVGID_00000088847849337073820470000009976494675416550033_" style="overflow:visible;"/>
							</clipPath>

              <rect x="570" y="373.6"
                    style="clip-path:url(#SVGID_00000157296394222284296770000007093286671722937501_);fill:#91B1A5;"
                    width="19.9" height="41.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000128457753481888325950000018393715124358793379_" d="M572,413l-11.2-3.7v-20.7c3.3-2.9,6.6-5.4,10.4-7.5
						c0.4,0,0.4-0.4,0.8-0.4V413"/>
				</defs>
        <clipPath id="SVGID_00000044149604059551291420000001321848012726859671_">
					<use xlink:href="#SVGID_00000128457753481888325950000018393715124358793379_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000044149604059551291420000001321848012726859671_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000165227973896201820320000011747917961086423980_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000113347239121130311310000017975098289740414623_">
								<use xlink:href="#SVGID_00000165227973896201820320000011747917961086423980_" style="overflow:visible;"/>
							</clipPath>

              <rect x="558.8" y="378.1"
                    style="clip-path:url(#SVGID_00000113347239121130311310000017975098289740414623_);fill:#8BA79D;"
                    width="15.8" height="37.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000075841851590635475920000014991708235554308239_" d="M545.5,427.5L545.5,427.5v-17.8
						c4.1-8.7,9.5-15.8,15.8-21.6v31.1L545.5,427.5"/>
				</defs>
        <clipPath id="SVGID_00000083058562315588194460000009002199922236297131_">
					<use xlink:href="#SVGID_00000075841851590635475920000014991708235554308239_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000083058562315588194460000009002199922236297131_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000026863407629834121970000006099538370818717354_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000043437583369715250690000014260586603738892695_">
								<use xlink:href="#SVGID_00000026863407629834121970000006099538370818717354_" style="overflow:visible;"/>
							</clipPath>

              <rect x="543.4" y="386"
                    style="clip-path:url(#SVGID_00000043437583369715250690000014260586603738892695_);fill:#91B1A5;"
                    width="19.9" height="43.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000152248217778075693320000015916593595562909352_" d="M545.5,427.5l-6.2-2.1c1.7-5.8,3.7-11.2,6.2-15.8
						V427.5"/>
				</defs>
        <clipPath id="SVGID_00000129180703278713530540000006441659227810630829_">
					<use xlink:href="#SVGID_00000152248217778075693320000015916593595562909352_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000129180703278713530540000006441659227810630829_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000086680590776596392740000015913436798595832462_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000150789924440217800490000017961830118643430550_">
								<use xlink:href="#SVGID_00000086680590776596392740000015913436798595832462_" style="overflow:visible;"/>
							</clipPath>

              <rect x="537.2" y="407.6"
                    style="clip-path:url(#SVGID_00000150789924440217800490000017961830118643430550_);fill:#8BA79D;"
                    width="10.8" height="22.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000153686550209863961110000000689861279801350836_" d="M532.7,469.3c0-0.4,0-0.8,0-1.2l29.8-17l3.3-1.7
						l7.5-4.1l15.8-9.1L773.9,330h0.4c0,0.4,0,0.8,0,1.2L532.7,469.3"/>
				</defs>
        <clipPath id="SVGID_00000045614073290976215880000000965728717324001920_">
					<use xlink:href="#SVGID_00000153686550209863961110000000689861279801350836_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000045614073290976215880000000965728717324001920_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000053526113228269889860000015180840393021834133_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000142889072940972188060000004997935002239531658_">
								<use xlink:href="#SVGID_00000053526113228269889860000015180840393021834133_" style="overflow:visible;"/>
							</clipPath>

              <rect x="530.6" y="327.1"
                    style="clip-path:url(#SVGID_00000142889072940972188060000004997935002239531658_);fill:#6E9084;"
                    width="246.2" height="144.3"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000062158941718342248930000012415232248073960854_" d="M535.6,374c-0.8,1.2-1.7,2.1-2.5,3.3
						c-6.2,8.7-13.3,19.5-21.1,31.9c-2.1,3.3-4.1,6.6-6.2,9.9c0-0.4-0.4-0.4-0.4-0.8l-0.4-0.4c2.1-3.7,4.6-7,6.6-10.8
						c7.9-12.4,14.9-23.2,21.1-31.5c0.8-1.2,1.7-2.5,2.5-3.3c2.1-2.9,4.1-5.4,6.2-7.5c7.5-9.1,14.1-14.9,19.1-17.4
						c12-5.8,22.4-8.7,31.1-8.7s16.6,2.5,23.2,7.9c6.2,5,10.8,7.5,13.7,7.5c15.3,0,27.4-4.6,36.9-14.1c6.2-6.6,12.4-17,18.2-31.1
						c2.9-7.9,5.4-13.3,6.6-17c2.5-6.2,5.4-11.2,7.9-14.9c4.6-6.6,9.5-10.8,15.8-13.3c0.4,0.4,0.4,0.8,0.8,1.7
						c-5.8,2.1-11.2,6.2-15.3,12.4c-2.5,3.7-5,8.3-7.5,14.5c-1.7,3.7-3.7,9.1-6.6,17c-5.8,14.5-12.4,25.3-18.7,31.9
						c-9.5,9.9-22.4,14.5-38.1,14.5c-3.3,0-7.9-2.5-14.5-7.9c-6.2-5-13.7-7.5-22-7.5c-8.7,0-18.7,2.9-30.7,8.7
						c-5,2.5-11.6,8.3-19.1,17.8C539.7,368.6,538,371.1,535.6,374"/>
				</defs>
        <clipPath id="SVGID_00000058569928478262470100000013437015903196046220_">
					<use xlink:href="#SVGID_00000062158941718342248930000012415232248073960854_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000058569928478262470100000013437015903196046220_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000142869858998323167340000002289886372411842748_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000181802860784771799680000013793576931284312202_">
								<use xlink:href="#SVGID_00000142869858998323167340000002289886372411842748_" style="overflow:visible;"/>
							</clipPath>

              <rect x="502.8" y="260.8"
                    style="clip-path:url(#SVGID_00000181802860784771799680000013793576931284312202_);fill:#165748;"
                    width="214.3" height="160.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000018223035386343158680000017945939196584631999_" d="M781,281.5c-1.2,0.8-2.9,2.1-5,3.3
						c-4.6,2.9-7.9,4.1-9.1,4.1c-4.1,0-7.9-1.2-11.6-4.1l0,0c-2.1-1.7-5.4-4.6-9.5-8.7s-7.5-7-9.9-8.7c-3.3-2.1-6.6-3.3-9.9-3.7
						c0.4-0.4,0.4-1.2,0.4-1.7c3.3,0.4,7,1.7,10.4,4.1c2.5,1.7,5.8,4.6,9.9,9.1c4.1,4.1,7.5,7,9.5,8.7c3.7,2.5,7,3.7,10.8,3.7
						c1.2,0,3.7-1.2,8.3-3.7c1.7-1.2,3.3-2.1,4.6-2.9l0,0C780.1,281.1,780.6,281.5,781,281.5"/>
				</defs>
        <clipPath id="SVGID_00000034080709019720523020000002053285559094432391_">
					<use xlink:href="#SVGID_00000018223035386343158680000017945939196584631999_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000034080709019720523020000002053285559094432391_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000129889783351995216380000009569124017319550084_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000075155612000119250440000003759963659731861931_">
								<use xlink:href="#SVGID_00000129889783351995216380000009569124017319550084_" style="overflow:visible;"/>
							</clipPath>

              <rect x="723.4" y="259.2"
                    style="clip-path:url(#SVGID_00000075155612000119250440000003759963659731861931_);fill:#165748;"
                    width="59.7" height="31.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000078751838519570644830000004335178560829043606_" points="202.7,580 202.7,430 261.1,396 261.5,546.4
						202.7,580 					"/>
				</defs>
        <clipPath id="SVGID_00000023248483083644392140000000216901637664127414_">
					<use xlink:href="#SVGID_00000078751838519570644830000004335178560829043606_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000023248483083644392140000000216901637664127414_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000183953923018180601920000009644275808833402511_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000011709477963658041510000004107939466560229294_">
								<use xlink:href="#SVGID_00000183953923018180601920000009644275808833402511_" style="overflow:visible;"/>
							</clipPath>

              <rect x="200.6" y="393.9"
                    style="clip-path:url(#SVGID_00000011709477963658041510000004107939466560229294_);fill:#EBEAE6;"
                    width="63" height="188.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000152233688097616444220000003494441672564426670_" d="M275.2,538.6v-63.4c3.7,15.3,13.7,24,27.8,24
						c7,0,15.3-2.5,24-7c29-16.6,52.6-56.8,52.6-90c0-16.6-5.8-28.2-15.8-33.6c-3.7-2.1-8.3-3.3-13.3-3.3c-7,0-15.3,2.5-24,7
						c-24.5,14.1-45.2,44.4-51,73.4c0,0.8-0.4,1.7-0.4,2.9v-60.5l164.2-94.9v-29l0,0l-1.2,180.7L275.2,538.6"/>
				</defs>
        <clipPath id="SVGID_00000080173437192337030460000005049549053558399647_">
					<use xlink:href="#SVGID_00000152233688097616444220000003494441672564426670_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000080173437192337030460000005049549053558399647_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000130632398409007176760000017717754075338061207_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000116194037149653626440000005956103501988933033_">
								<use xlink:href="#SVGID_00000130632398409007176760000017717754075338061207_" style="overflow:visible;"/>
							</clipPath>

              <rect x="272.3" y="262.1"
                    style="clip-path:url(#SVGID_00000116194037149653626440000005956103501988933033_);fill:#DCDDD7;"
                    width="168.7" height="278.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000004506568501562660810000015921081231659248004_" d="M261.5,546.4l-0.4-150.1l13.7-7.9V449
						c-0.8,4.6-1.2,9.1-1.2,13.7c0,4.6,0.4,8.7,1.2,12.9V539L261.5,546.4"/>
				</defs>
        <clipPath id="SVGID_00000070837380721076069170000015589821876447469454_">
					<use xlink:href="#SVGID_00000004506568501562660810000015921081231659248004_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000070837380721076069170000015589821876447469454_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000119824184631712505700000007268010497446246806_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000090257577607202176370000010906656349583869873_">
								<use xlink:href="#SVGID_00000119824184631712505700000007268010497446246806_" style="overflow:visible;"/>
							</clipPath>

              <rect x="258.6" y="386"
                    style="clip-path:url(#SVGID_00000090257577607202176370000010906656349583869873_);fill:#868B89;"
                    width="18.7" height="162.5"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000039830377626654831350000017476898872300892063_" d="M288.9,442L288.9,442c-0.8,4.1-1.2,8.3-1.2,12
						c0,17,8.7,26.9,21.1,26.9c5.4,0,11.2-1.7,17.4-5.4c21.1-12,38.6-41.5,38.6-65.5c0-12-4.6-20.7-11.6-24.5l-12.4,21.1
						c3.7,2.1,6.2,6.6,6.2,13.3c0,12.9-9.5,29-20.7,35.7c-3.3,2.1-6.6,2.9-9.5,2.9c-6.6,0-11.6-5.4-11.6-14.5c0-2.1,0.4-4.1,0.8-6.6
						c2.5-11.6,10.4-23.6,20.3-29c3.3-2.1,6.6-2.9,9.5-2.9c2.1,0,3.7,0.4,5.4,1.2l12.4-21.1c-2.9-1.7-6.2-2.5-9.9-2.5
						c-5.4,0-11.2,1.7-17.4,5.4C308.4,398.9,293.5,420.8,288.9,442 M303.8,495.5c-16.2,0-27.4-12.9-27.4-34.4c0-5,0.4-10.4,1.7-15.8
						c5.8-27.4,25.3-56,48.1-69.2c8.3-4.6,15.8-6.6,22.4-6.6c4.6,0,9.1,1.2,12.4,2.9c9.1,5,14.9,15.8,14.9,31.5
						c0,31.1-22.4,69.2-49.7,85C318.3,493,310.5,495.5,303.8,495.5"/>
				</defs>
        <clipPath id="SVGID_00000181770588610065615230000012919818479126729407_">
					<use xlink:href="#SVGID_00000039830377626654831350000017476898872300892063_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000181770588610065615230000012919818479126729407_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000079464937682900049310000006613278373816854718_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000165931721659904429880000004974385046528028855_">
								<use xlink:href="#SVGID_00000079464937682900049310000006613278373816854718_" style="overflow:visible;"/>
							</clipPath>

              <rect x="274.4" y="366.9"
                    style="clip-path:url(#SVGID_00000165931721659904429880000004974385046528028855_);fill:#DCDDD7;"
                    width="104.1" height="130.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000139272065114772004700000017379729374850638504_" points="439,264.1 202.7,400.1 196,397.2
						430.3,264.1 439,264.1 					"/>
				</defs>
        <clipPath id="SVGID_00000157999046921917741740000010341375294710509756_">
					<use xlink:href="#SVGID_00000139272065114772004700000017379729374850638504_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000157999046921917741740000010341375294710509756_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000176731197348348204850000007733261061043532963_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000019670057550311336570000012823253744091806620_">
								<use xlink:href="#SVGID_00000176731197348348204850000007733261061043532963_" style="overflow:visible;"/>
							</clipPath>

              <rect x="193.6" y="262.1"
                    style="clip-path:url(#SVGID_00000019670057550311336570000012823253744091806620_);fill:#999C9A;"
                    width="247.5" height="140.1"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000080892730069886980840000013780538294884530605_" points="196,397.2 196.5,575.9 202.7,580
						202.7,400.1 196,397.2 					"/>
				</defs>
        <clipPath id="SVGID_00000148657592340822702360000002469675089243693751_">
					<use xlink:href="#SVGID_00000080892730069886980840000013780538294884530605_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000148657592340822702360000002469675089243693751_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000001658972685106213950000013627451510574418106_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000096053320278998922090000013127969834210304655_">
								<use xlink:href="#SVGID_00000001658972685106213950000013627451510574418106_" style="overflow:visible;"/>
							</clipPath>

              <rect x="193.6" y="395.1"
                    style="clip-path:url(#SVGID_00000096053320278998922090000013127969834210304655_);fill:#999C9A;"
                    width="11.2" height="187"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000151510734856704983110000005105209018372940438_" d="M349,369c-6.6,0-14.5,2.1-22.4,6.6
						c-23.2,13.3-42.3,41.9-48.1,69.2c-1.2,5.4-1.7,10.4-1.7,15.8c0,22,11.2,34.4,27.4,34.4c6.6,0,14.5-2.1,22.4-6.6
						c27.4-15.8,49.7-53.9,49.7-85c0-15.8-5.8-26.5-14.9-31.5C357.7,369.8,353.6,369,349,369 M302.6,499.2c-13.7,0-24-8.7-27.8-24
						v-26.5c0-0.8,0.4-1.7,0.4-2.9c6.2-29,26.5-59.3,51-73.4c8.7-5,16.6-7,24-7c5,0,9.5,1.2,13.3,3.3c9.5,5.4,15.8,17,15.8,33.6
						c0,32.8-23.6,73.4-52.6,90C317.9,496.7,309.6,499.2,302.6,499.2"/>
				</defs>
        <clipPath id="SVGID_00000088819991615423249270000005344523677570288552_">
					<use xlink:href="#SVGID_00000151510734856704983110000005105209018372940438_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000088819991615423249270000005344523677570288552_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000165194810921809814220000011884895784449364413_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000161612649104333714080000017559151301488360585_">
								<use xlink:href="#SVGID_00000165194810921809814220000011884895784449364413_" style="overflow:visible;"/>
							</clipPath>

              <rect x="272.7" y="363.2"
                    style="clip-path:url(#SVGID_00000161612649104333714080000017559151301488360585_);fill:#98CAB7;"
                    width="109" height="138"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000160157666996269310190000005261554650852239011_" d="M274.8,475.1c-0.8-3.7-1.2-7.9-1.2-12.9
						c0-4.6,0.4-9.1,1.2-13.7V475.1"/>
				</defs>
        <clipPath id="SVGID_00000144306938028332381130000006586209918458602889_">
					<use xlink:href="#SVGID_00000160157666996269310190000005261554650852239011_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000144306938028332381130000006586209918458602889_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000126283075825223585930000014287632675304378274_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000183216136283164639960000005499484504958448293_">
								<use xlink:href="#SVGID_00000126283075825223585930000014287632675304378274_" style="overflow:visible;"/>
							</clipPath>

              <rect x="271.5" y="446.5"
                    style="clip-path:url(#SVGID_00000183216136283164639960000005499484504958448293_);fill:#6E9A8A;"
                    width="5.8" height="31.1"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000179618715946837067170000000852630455832997281_" d="M326.2,408.4v-19.9c6.2-3.7,12-5.4,17.4-5.4
						c3.7,0,7,0.8,9.9,2.5l-12.4,21.1c-1.7-0.8-3.3-1.2-5.4-1.2C332.8,405.5,329.9,406.7,326.2,408.4"/>
				</defs>
        <use xlink:href="#SVGID_00000179618715946837067170000000852630455832997281_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000121243733250172885660000017025730517575424396_">
					<use xlink:href="#SVGID_00000179618715946837067170000000852630455832997281_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000121243733250172885660000017025730517575424396_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000008858578523465233160000014185107790800210848_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000008858578523465233160000014185107790800210848_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000067953372695956066010000005479071893422657975_">
								<use xlink:href="#SVGID_00000008858578523465233160000014185107790800210848_" style="overflow:visible;"/>
							</clipPath>

              <rect x="324.1" y="381"
                    style="clip-path:url(#SVGID_00000067953372695956066010000005479071893422657975_);fill:#6B59A6;"
                    width="31.5" height="29.8"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000008139724741277254160000017645976875228902534_" d="M308.8,480.9c-12.4,0-21.1-9.9-21.1-26.9
						c0-3.7,0.4-7.9,1.2-12l17-4.6c-0.4,2.1-0.8,4.6-0.8,6.6c0,9.1,4.6,14.5,11.6,14.5c2.9,0,6.2-0.8,9.5-2.9
						c11.6-6.6,20.7-22.4,20.7-35.7c0-6.6-2.5-11.2-6.2-13.3l12.4-21.1c7,3.7,11.6,12.4,11.6,24.5c0,24-17.4,53.5-38.6,65.5
						C320,479.3,314.2,480.9,308.8,480.9"/>
				</defs>
        <clipPath id="SVGID_00000150073739186204776040000011678769953974644399_">
					<use xlink:href="#SVGID_00000008139724741277254160000017645976875228902534_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000150073739186204776040000011678769953974644399_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000122719083088787834560000009917469461162446768_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000047745939844982837720000000036803106501098157_">
								<use xlink:href="#SVGID_00000122719083088787834560000009917469461162446768_" style="overflow:visible;"/>
							</clipPath>

              <rect x="285.6" y="383.5"
                    style="clip-path:url(#SVGID_00000047745939844982837720000000036803106501098157_);fill:#699085;"
                    width="81.7" height="99.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000164507818968114182050000015538871101366274987_" d="M288.9,442c4.6-21.1,19.5-43.5,37.3-53.5v19.9
						c-9.5,5.4-17.8,17.4-20.3,29L288.9,442"/>
				</defs>
        <clipPath id="SVGID_00000035528412876885815810000003130899136064700593_">
					<use xlink:href="#SVGID_00000164507818968114182050000015538871101366274987_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000035528412876885815810000003130899136064700593_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000096060818505712430110000006561964282472206481_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000061434768375707878380000010010657784764843956_">
								<use xlink:href="#SVGID_00000096060818505712430110000006561964282472206481_" style="overflow:visible;"/>
							</clipPath>

              <rect x="286.8" y="386.4"
                    style="clip-path:url(#SVGID_00000061434768375707878380000010010657784764843956_);fill:#98CAB7;"
                    width="41.9" height="58"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000031914495318211743300000009654092997983077778_" points="439,264.1 438.6,264.1 439,264.1 439,264.1
											"/>
				</defs>
        <clipPath id="SVGID_00000180350787409687727010000014392799696175154308_">
					<use xlink:href="#SVGID_00000031914495318211743300000009654092997983077778_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000180350787409687727010000014392799696175154308_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000132090374097539792030000006116451711611282355_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000003068358880231526390000004514213950274736285_">
								<use xlink:href="#SVGID_00000132090374097539792030000006116451711611282355_" style="overflow:visible;"/>
							</clipPath>

              <rect x="436.5" y="261.6"
                    style="clip-path:url(#SVGID_00000003068358880231526390000004514213950274736285_);fill:#679384;"
                    width="4.6" height="4.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000029023042326868223320000012817556840232133016_" points="202.7,430 202.7,400.1 260.7,366.5
						261.1,396 202.7,430 					"/>
				</defs>
        <use xlink:href="#SVGID_00000029023042326868223320000012817556840232133016_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000076592184312367429150000014751859946229329283_">
					<use xlink:href="#SVGID_00000029023042326868223320000012817556840232133016_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000076592184312367429150000014751859946229329283_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000116199265573110171080000014711185200092554371_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000116199265573110171080000014711185200092554371_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000069388639243306391610000005853215057778253709_">
								<use xlink:href="#SVGID_00000116199265573110171080000014711185200092554371_" style="overflow:visible;"/>
							</clipPath>

              <rect x="200.6" y="364"
                    style="clip-path:url(#SVGID_00000069388639243306391610000005853215057778253709_);fill:#6B59A6;"
                    width="62.6" height="68"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000093867290137893052960000006394034727944617879_" d="M422.4,286.5c-0.4,0-1.2,0-1.7,0.4
						c-1.7,0.8-3.3,2.9-3.7,5c0,0.4,0,0.8,0,1.2c0,1.7,0.8,2.5,2.1,2.5c0.4,0,1.2,0,1.7-0.4c2.1-1.2,3.7-4.1,3.7-6.2
						c0-1.2-0.4-2.1-1.2-2.5C423.2,286.5,422.8,286.5,422.4,286.5 M410.4,294c-0.4,0-1.2,0-1.7,0.4c-1.7,0.8-3.3,2.9-3.7,5
						c0,0.4,0,0.8,0,1.2c0,1.7,0.8,2.5,2.1,2.5c0.4,0,1.2,0,1.7-0.4c2.1-1.2,3.7-4.1,3.7-6.2c0-1.2-0.4-2.1-1.2-2.5
						C410.8,294,410.8,294,410.4,294 M397.9,300.6c-0.4,0-1.2,0-1.7,0.4c-1.7,0.8-3.3,2.9-3.7,5c0,0.4,0,0.8,0,1.2
						c0,1.7,0.8,2.5,2.1,2.5c0.4,0,1.2,0,1.7-0.4c2.1-1.2,3.7-4.1,3.7-6.2c0-1.2-0.4-2.1-1.2-2.5C398.8,301,398.3,300.6,397.9,300.6
						 M274.8,388.1v-29.4L439,264.1v29L274.8,388.1"/>
				</defs>
        <use xlink:href="#SVGID_00000093867290137893052960000006394034727944617879_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000106131068923640604390000010066173164507729057_">
					<use xlink:href="#SVGID_00000093867290137893052960000006394034727944617879_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000106131068923640604390000010066173164507729057_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000126293427681734372270000008476206811927398316_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000126293427681734372270000008476206811927398316_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000083076704797862738820000015315314717241399703_">
								<use xlink:href="#SVGID_00000126293427681734372270000008476206811927398316_" style="overflow:visible;"/>
							</clipPath>

              <rect x="272.3" y="262.1"
                    style="clip-path:url(#SVGID_00000083076704797862738820000015315314717241399703_);fill:#6B59A6;"
                    width="168.7" height="128.5"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000168117172633423768290000002064462403724051903_" points="261.1,396 260.7,366.5 274.8,358.7
						274.8,388.1 261.1,396 					"/>
				</defs>
        <use xlink:href="#SVGID_00000168117172633423768290000002064462403724051903_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000063622882353304542240000004891461213570232207_">
					<use xlink:href="#SVGID_00000168117172633423768290000002064462403724051903_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000063622882353304542240000004891461213570232207_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000136373876572204971780000013423186926672964005_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000136373876572204971780000013423186926672964005_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000172439532012124161330000010594496373781665948_">
								<use xlink:href="#SVGID_00000136373876572204971780000013423186926672964005_" style="overflow:visible;"/>
							</clipPath>

              <rect x="258.6" y="356.2"
                    style="clip-path:url(#SVGID_00000172439532012124161330000010594496373781665948_);fill:#6B59A6;"
                    width="18.2" height="41.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000142157872381145514220000015168420635927858100_" points="202.7,400.1 438.6,264.1 439,264.1
						439,264.1 274.8,358.7 202.7,400.1 					"/>
				</defs>
        <use xlink:href="#SVGID_00000142157872381145514220000015168420635927858100_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000164479181717679499140000015646621966350878894_">
					<use xlink:href="#SVGID_00000142157872381145514220000015168420635927858100_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000164479181717679499140000015646621966350878894_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000065764707226197292850000006961815403550630305_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000065764707226197292850000006961815403550630305_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000093866979543991608360000013818157505841092244_">
								<use xlink:href="#SVGID_00000065764707226197292850000006961815403550630305_" style="overflow:visible;"/>
							</clipPath>

              <rect x="200.6" y="262.1"
                    style="clip-path:url(#SVGID_00000093866979543991608360000013818157505841092244_);fill:#6B59A6;"
                    width="240.4" height="140.1"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000049934575317258193970000014628137848536939947_"
                    points="202.7,430 202.7,400.1 202.7,430 					"/>
				</defs>
        <clipPath id="SVGID_00000119110019735887522050000011039107021343714732_">
					<use xlink:href="#SVGID_00000049934575317258193970000014628137848536939947_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000119110019735887522050000011039107021343714732_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000017505916698987425490000004946460766483044492_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000018959472083500824510000002809921651561275022_">
								<use xlink:href="#SVGID_00000017505916698987425490000004946460766483044492_" style="overflow:visible;"/>
							</clipPath>

              <rect x="200.6" y="397.6"
                    style="clip-path:url(#SVGID_00000018959472083500824510000002809921651561275022_);fill:#547E6F;"
                    width="4.6" height="34.4"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000005971841401159973750000015108946679503146926_" d="M394.6,310.1c-1.2,0-2.1-0.8-2.1-2.5
						c0-0.4,0-0.8,0-1.2c0.4-2.1,1.7-4.1,3.7-5c0.4-0.4,1.2-0.4,1.7-0.4s0.8,0,0.8,0.4c0.8,0.4,1.2,1.2,1.2,2.5c0,2.5-1.7,5-3.7,6.2
						C395.9,310.1,395,310.1,394.6,310.1"/>
				</defs>
        <clipPath id="SVGID_00000135679378266348399230000017502304064064964541_">
					<use xlink:href="#SVGID_00000005971841401159973750000015108946679503146926_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000135679378266348399230000017502304064064964541_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000170244223932169619650000000276114478356695184_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000117665761999473991480000001872136630261518257_">
								<use xlink:href="#SVGID_00000170244223932169619650000000276114478356695184_" style="overflow:visible;"/>
							</clipPath>

              <rect x="390.5" y="298.5"
                    style="clip-path:url(#SVGID_00000117665761999473991480000001872136630261518257_);fill:#C7D9D0;"
                    width="12" height="13.7"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000108297702033995022750000008979257188965378691_" d="M407,303.1c-1.2,0-2.1-0.8-2.1-2.5c0-0.4,0-0.8,0-1.2
						c0.4-2.1,1.7-4.1,3.7-5c0.4-0.4,1.2-0.4,1.7-0.4c0.4,0,0.8,0,0.8,0.4c0.8,0.4,1.2,1.2,1.2,2.5c0,2.5-1.7,5-3.7,6.2
						C407.9,303.1,407.5,303.1,407,303.1"/>
				</defs>
        <clipPath id="SVGID_00000021798303509108601130000003387066030808592787_">
					<use xlink:href="#SVGID_00000108297702033995022750000008979257188965378691_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000021798303509108601130000003387066030808592787_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000149355167033619477320000017218231262990229929_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000032620727272923868780000015275277124551437712_">
								<use xlink:href="#SVGID_00000149355167033619477320000017218231262990229929_" style="overflow:visible;"/>
							</clipPath>

              <rect x="402.9" y="291.5"
                    style="clip-path:url(#SVGID_00000032620727272923868780000015275277124551437712_);fill:#C7D9D0;"
                    width="12" height="13.7"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000026882075436892174230000000359044974464036025_" d="M419.1,295.6c-1.2,0-2.1-0.8-2.1-2.5
						c0-0.4,0-0.8,0-1.2c0.4-2.1,1.7-4.1,3.7-5c0.4-0.4,1.2-0.4,1.7-0.4s0.8,0,0.8,0.4c0.8,0.4,1.2,1.2,1.2,2.5c0,2.5-1.7,5-3.7,6.2
						C420.3,295.6,419.9,295.6,419.1,295.6"/>
				</defs>
        <clipPath id="SVGID_00000044141259766939925420000001389350310272942470_">
					<use xlink:href="#SVGID_00000026882075436892174230000000359044974464036025_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000044141259766939925420000001389350310272942470_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000004542853745659110360000017470500499818801061_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000119101550351970665770000012877829066238438548_">
								<use xlink:href="#SVGID_00000004542853745659110360000017470500499818801061_" style="overflow:visible;"/>
							</clipPath>

              <rect x="414.9" y="284"
                    style="clip-path:url(#SVGID_00000119101550351970665770000012877829066238438548_);fill:#C7D9D0;"
                    width="12" height="13.7"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<polyline id="SVGID_00000142176159544854457620000015998730332086088609_" class="st384" points="924,456.1 744.5,484.7
					778.5,511.6 924,456.1 				"/>
			</g>
      <g>
				<defs>
					<polyline id="SVGID_00000034082096434183204070000017398280735925921679_" points="924,456.1 744.5,484.7 778.5,511.6
						924,456.1 					"/>
				</defs>
        <clipPath id="SVGID_00000032624531452150024020000010763164677660471685_">
					<use xlink:href="#SVGID_00000034082096434183204070000017398280735925921679_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000032624531452150024020000010763164677660471685_);">
					<g>
						<g>

								<rect id="SVGID_00000008125393495697715560000012279838439139711626_" x="-192" y="-84.9" class="st384"
                      width="1504" height="1002.4"/>
						</g>
            <g>
							<defs>
								<rect id="SVGID_00000118363905146170129080000011887626745406999940_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000172428099567573890530000011337267432212063123_">
								<use xlink:href="#SVGID_00000118363905146170129080000011887626745406999940_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000172428099567573890530000011337267432212063123_);enable-background:new    ;">
								<g>
									<g>
										<g>

												<rect id="SVGID_00000142163830900530317530000000237817051279786882_" x="743.7" y="454.4"
                              class="st384" width="180.3" height="58"/>
										</g>
                    <g>
											<defs>
												<rect id="SVGID_00000149382421183521546060000007950830824672042681_" x="743.7" y="454.4"
                              width="180.3" height="58"/>
											</defs>
                      <clipPath id="SVGID_00000009555282761498011700000013705771873865004705_">
												<use xlink:href="#SVGID_00000149382421183521546060000007950830824672042681_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000009555282761498011700000013705771873865004705_);">
												<g>
													<g>
														<polyline id="SVGID_00000129181412510765456210000012678195285080284860_" class="st384"
                                      points="924,456.1
															744.5,484.7 778.5,511.6 924,456.1 														"/>
													</g>
                          <g>
														<defs>
															<polyline id="SVGID_00000171711184799810646850000003167318850391483552_" points="924,456.1 744.5,484.7
																778.5,511.6 924,456.1 															"/>
														</defs>
                            <clipPath id="SVGID_00000121967599211434147270000008727069636991809415_">
															<use xlink:href="#SVGID_00000171711184799810646850000003167318850391483552_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000121967599211434147270000008727069636991809415_);">
															<g>
																<g>

																		<rect id="SVGID_00000017510640417144942500000011424373037606578329_" x="743.7"
                                          y="454.4" class="st384" width="180.3" height="58"/>
																</g>
                                <g>
																	<defs>

																			<rect id="SVGID_00000057831927644446107850000014882814685112810890_" x="743.7"
                                            y="454.4" width="180.3" height="58"/>
																	</defs>
                                  <clipPath id="SVGID_00000150103284923011827760000000611921648703036842_">
																		<use xlink:href="#SVGID_00000057831927644446107850000014882814685112810890_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="opacity:0;clip-path:url(#SVGID_00000150103284923011827760000000611921648703036842_);">
																		<g class="st5">
																			<g>
																				<g>
																					<g>

																							<rect id="SVGID_00000160164306497874667150000013493538564937950877_"
                                                    x="743.7" y="454.4" class="st384" width="180.3" height="58"/>
																					</g>
                                          <g>
																						<defs>

																								<rect id="SVGID_00000132048914454535645970000003114974601177169564_"
                                                      x="743.7" y="454.4" width="180.3" height="58"/>
																						</defs>
                                            <clipPath id="SVGID_00000170254971041810284010000014395445545563531455_">
																							<use
                                                  xlink:href="#SVGID_00000132048914454535645970000003114974601177169564_"
                                                  style="overflow:visible;"/>
																						</clipPath>
																					</g>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
                              <g>
																<g>

																		<rect id="SVGID_00000045589096344999788750000017181908699698993052_" x="743.7"
                                          y="454.4" class="st384" width="180.3" height="58"/>
																</g>
                                <g>
																	<defs>

																			<rect id="SVGID_00000057832724217213307120000004694791769932812457_" x="743.7"
                                            y="454.4" width="180.3" height="58"/>
																	</defs>
                                  <clipPath id="SVGID_00000113313384664168718040000011803766505998666158_">
																		<use xlink:href="#SVGID_00000057832724217213307120000004694791769932812457_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="clip-path:url(#SVGID_00000113313384664168718040000011803766505998666158_);">
																		<g>
																			<g>
																				<g>

																						<rect id="SVGID_00000114766312178093344440000011652322252873859757_"
                                                  x="743.7" y="454.4" class="st384" width="180.3" height="58"/>
																				</g>
                                        <g>
																					<defs>

																							<rect id="SVGID_00000154406058524606592660000013395783620037104769_"
                                                    x="743.7" y="454.4" width="180.3" height="58"/>
																					</defs>
                                          <clipPath id="SVGID_00000089556952912372820230000015691731146153408703_">
																						<use xlink:href="#SVGID_00000154406058524606592660000013395783620037104769_"
                                                 style="overflow:visible;"/>
																					</clipPath>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000168818008316031312350000017916105627422754688_" points="778.5,511.6 770.6,546.4 818.3,519.9
						924,456.1 778.5,511.6 					"/>
				</defs>
        <use xlink:href="#SVGID_00000168818008316031312350000017916105627422754688_"
             style="overflow:visible;fill:#6B59A6;"/>
        <clipPath id="SVGID_00000147214249367383338250000010130001030558811837_">
					<use xlink:href="#SVGID_00000168818008316031312350000017916105627422754688_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000147214249367383338250000010130001030558811837_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000112617958892775257660000007626483349160773253_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000112617958892775257660000007626483349160773253_"
                   style="overflow:visible;fill:#6B59A6;"/>
              <clipPath id="SVGID_00000012474407118856662560000006633074171986596525_">
								<use xlink:href="#SVGID_00000112617958892775257660000007626483349160773253_" style="overflow:visible;"/>
							</clipPath>

              <rect x="768.1" y="453.6"
                    style="clip-path:url(#SVGID_00000012474407118856662560000006633074171986596525_);fill:#6B59A6;"
                    width="157.9" height="94.9"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<polyline id="SVGID_00000069393821771442327770000003258679590575020177_" class="st384" points="924,456.1 833.2,559.7
					796.7,529 924,456.1 				"/>
			</g>
      <g>
				<defs>
					<polyline id="SVGID_00000087407819624859169860000012782787858591305355_" points="924,456.1 833.2,559.7 796.7,529 924,456.1
											"/>
				</defs>
        <clipPath id="SVGID_00000142891805432498598560000012147801904659706520_">
					<use xlink:href="#SVGID_00000087407819624859169860000012782787858591305355_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000142891805432498598560000012147801904659706520_);">
					<g>
						<g>

								<rect id="SVGID_00000057857180248773200100000018408175993939612544_" x="-192" y="-84.9" class="st384"
                      width="1504" height="1002.4"/>
						</g>
            <g>
							<defs>
								<rect id="SVGID_00000032646847983799127060000007249286370327191983_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <clipPath id="SVGID_00000049934957594855459300000013842527131383816862_">
								<use xlink:href="#SVGID_00000032646847983799127060000007249286370327191983_" style="overflow:visible;"/>
							</clipPath>
              <g style="clip-path:url(#SVGID_00000049934957594855459300000013842527131383816862_);enable-background:new    ;">
								<g>
									<g>
										<g>

												<rect id="SVGID_00000000217022061478546630000001835811148248326278_" x="795.1" y="454.4"
                              class="st384" width="129.3" height="107"/>
										</g>
                    <g>
											<defs>

													<rect id="SVGID_00000096742619154139353970000015638058717250925748_" x="795.1" y="454.4"
                                width="129.3" height="107"/>
											</defs>
                      <clipPath id="SVGID_00000016754910195042658720000010308068192898294165_">
												<use xlink:href="#SVGID_00000096742619154139353970000015638058717250925748_"
                             style="overflow:visible;"/>
											</clipPath>
                      <g style="clip-path:url(#SVGID_00000016754910195042658720000010308068192898294165_);">
												<g>
													<g>
														<polyline id="SVGID_00000152256585964372466310000009917874816932860049_" class="st384"
                                      points="924,456.1
															833.2,559.7 796.7,529 924,456.1 														"/>
													</g>
                          <g>
														<defs>
															<polyline id="SVGID_00000096031531848048535140000005898631057902538414_" points="924,456.1 833.2,559.7 796.7,529
																924,456.1 															"/>
														</defs>
                            <clipPath id="SVGID_00000131366525454984980850000016407217265259567749_">
															<use xlink:href="#SVGID_00000096031531848048535140000005898631057902538414_"
                                   style="overflow:visible;"/>
														</clipPath>
                            <g style="clip-path:url(#SVGID_00000131366525454984980850000016407217265259567749_);">
															<g>
																<g>

																		<rect id="SVGID_00000124148234631638589600000007858087448972204989_" x="795.1"
                                          y="454.4" class="st384" width="129.3" height="107"/>
																</g>
                                <g>
																	<defs>

																			<rect id="SVGID_00000049187345954867056060000018299494958608079008_" x="795.1"
                                            y="454.4" width="129.3" height="107"/>
																	</defs>
                                  <clipPath id="SVGID_00000098920483824125129410000013491953193195983508_">
																		<use xlink:href="#SVGID_00000049187345954867056060000018299494958608079008_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="opacity:0;clip-path:url(#SVGID_00000098920483824125129410000013491953193195983508_);">
																		<g class="st5">
																			<g>
																				<g>
																					<g>

																							<rect id="SVGID_00000163072171126544687700000016477296701677117367_"
                                                    x="795.1" y="454.4" class="st384" width="129.3" height="107"/>
																					</g>
                                          <g>
																						<defs>

																								<rect id="SVGID_00000111178633888302601630000003164004084836958111_"
                                                      x="795.1" y="454.4" width="129.3" height="107"/>
																						</defs>
                                            <clipPath id="SVGID_00000075869967200823558730000007786617793501269415_">
																							<use
                                                  xlink:href="#SVGID_00000111178633888302601630000003164004084836958111_"
                                                  style="overflow:visible;"/>
																						</clipPath>
																					</g>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
                              <g>
																<g>

																		<rect id="SVGID_00000048473048654299726330000013899457721278679446_" x="795.1"
                                          y="454.4" class="st384" width="129.3" height="107"/>
																</g>
                                <g>
																	<defs>

																			<rect id="SVGID_00000111191956292850663040000016374143144783120034_" x="795.1"
                                            y="454.4" width="129.3" height="107"/>
																	</defs>
                                  <clipPath id="SVGID_00000078748278474642268430000016106764989909531305_">
																		<use xlink:href="#SVGID_00000111191956292850663040000016374143144783120034_"
                                         style="overflow:visible;"/>
																	</clipPath>
                                  <g style="clip-path:url(#SVGID_00000078748278474642268430000016106764989909531305_);">
																		<g>
																			<g>
																				<g>

																						<rect id="SVGID_00000095303764804588160470000014310932135060778912_"
                                                  x="795.1" y="454.4" class="st384" width="129.3" height="107"/>
																				</g>
                                        <g>
																					<defs>

																							<rect id="SVGID_00000110453014639143247890000010355500650179816092_"
                                                    x="795.1" y="454.4" width="129.3" height="107"/>
																					</defs>
                                          <clipPath id="SVGID_00000072260336868496262550000012013054656288586113_">
																						<use xlink:href="#SVGID_00000110453014639143247890000010355500650179816092_"
                                                 style="overflow:visible;"/>
																					</clipPath>
																				</g>
																			</g>
																		</g>
																	</g>
																</g>
															</g>
														</g>
													</g>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
            <g>
		<g>
			<g>
				<defs>
					<polyline id="SVGID_00000095339285269997066690000000834976300487590314_" points="802.5,534 770.6,546.4 796.7,529 802.5,534
											"/>
				</defs>
        <use xlink:href="#SVGID_00000095339285269997066690000000834976300487590314_"
             style="overflow:visible;fill:#3E3F6F;"/>
        <clipPath id="SVGID_00000136399397812545105120000014469409525791642780_">
					<use xlink:href="#SVGID_00000095339285269997066690000000834976300487590314_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000136399397812545105120000014469409525791642780_);">
					<g>
						<g>
							<defs>
								<rect id="SVGID_00000117636044647762437960000018010178366965110676_" x="-192" y="-84.9" width="1504"
                      height="1002.4"/>
							</defs>
              <use xlink:href="#SVGID_00000117636044647762437960000018010178366965110676_"
                   style="overflow:visible;fill:#3E3F6F;"/>
              <clipPath id="SVGID_00000182527090034120524730000017785344736762518423_">
								<use xlink:href="#SVGID_00000117636044647762437960000018010178366965110676_" style="overflow:visible;"/>
							</clipPath>

              <rect x="768.1" y="527"
                    style="clip-path:url(#SVGID_00000182527090034120524730000017785344736762518423_);fill:#3E3F6F;"
                    width="36.5" height="21.6"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
            <g>
	<path class="st404" d="M206.6,962c5.8,0.6,11.2,1.2,15.8,4.9c2.9,2.2,8,8.1,8,18.3c0,1.3-0.1,4.2-1,7.5c-0.9,3.5-3.8,11.7-12.2,17
		c-3,1.8-7.1,3.4-10.5,4.6l19.6,39.5h-22.2c-2.1-5.5-4.2-10.9-6.7-16.2c-2.4-5.4-5-10.8-7.5-16.1c-3.1-6.5-6.2-12.8-9.2-19.2
		c3,0.3,6,0.6,9,0.6c2.4,0,12.7-0.1,17.9-7.4c2.4-3.4,2.6-6.9,2.6-8.5c0-1.5-0.3-5.5-3.4-8c-1.9-1.6-3.7-2.1-9-2.4l-19.7,0.1
		c-1.2,18-2.2,36-2.8,54c-0.3,7.8-0.4,15.3-0.6,23h-20.2c0.9-9.9,1.6-19.7,2.1-29.7c0.4-7.7,0.6-15.3,0.9-23
		c0.4-8.1,0.8-16.2,0.9-24.3c0.1-4.9,0.1-9.7,0.1-14.6H206.6L206.6,962z"/>
              <path class="st404" d="M485.9,961.9c-1,15.6-2.1,31.3-2.9,46.9c-0.8,15-1.3,29.9-1.9,45h-20.2c1.3-15.8,2.5-31.5,3.3-47.3
		c0.6-14.9,0.9-29.7,1.3-44.7L485.9,961.9z"/>
              <path class="st693" d="M260.1,983.6c-1,11.9-2,23.8-2.8,35.7c-0.8,11.4-1.2,22.8-1.9,34.2H236c1.2-12,2.4-24,3.2-36
		c0.6-11.3,0.9-22.6,1.2-34L260.1,983.6z"/>
              <path class="st693" d="M322.5,996.6c-7.2-1.5-14.7-3.2-22.3-3.2c-6.6,0-9.3,1.3-11.1,3.3c-0.4,0.4-1.4,1.7-1.4,3.2
		c0,2.7,2.8,4.7,5.2,6.4c4.7,3,9.3,6,14.1,9.2c3.7,2.5,7.2,5.1,10.8,7.7c2.1,1.9,7.5,5.9,7.5,13c0,2.7-0.9,8.3-7.7,12.9
		c-5.8,3.9-12.3,4.7-19.8,5.5c-14.6,0.2-18.1-0.3-31.8-3.4l-0.9-13.5c2,0.8,3.9,1.5,6.1,2.2c9.1,3,17.5,3.4,21.3,3.4
		c2.4,0,5.6-0.1,7.7-0.8c1.2-0.3,5.8-1.8,5.8-5.4c0-2.8-2.8-4.8-5.7-6.9c-2.9-2-5.8-4-8.7-5.9c-2.9-1.9-5.8-3.7-8.6-5.7
		c-1.9-1.3-3.8-2.8-5.7-4.2c-2.3-1.9-8.5-6.7-8.5-14.6c0-5.3,3-10.6,8.9-13.7c1.4-0.7,3.2-1.5,6.6-2.3c8.5-2.1,13.4-1.8,17.6-1.8
		c6,0.2,9,0.2,19.4,2L322.5,996.6z"/>
              <path class="st693" d="M355.8,983.6c-0.6,4.5-1.2,9.1-1.6,13.7c-0.8,7-1,13.9-1.5,21c-0.4,7.9-0.9,15.8-1.2,23.8
		c0,3.8-0.1,7.6-0.1,11.4h-19.9c0.6-5.5,1.2-11,1.8-16.4c0.4-5.4,0.6-10.7,0.9-16.2c0.6-9,1.2-18.1,1.5-27c0.1-3.5,0.1-6.9,0.3-10.4
		L355.8,983.6z M417.1,983.6c-6.6,5.4-13.2,10.9-19.9,16.3c-4.7,3.9-9.5,7.6-14.2,11.5c-2.3,2-4.5,4-6.6,6l39.2,36.1h-26
		c-5.4-5.9-10.9-11.7-16.5-17.3c-6.3-6.4-12.9-12.5-19.4-18.6c4.7-4.2,9.5-8.3,14.3-12.4c0.1-0.1,0.3-0.3,0.4-0.4
		c4.7-3.9,9.3-7.7,13.7-11.7c3.4-3.2,6.6-6.4,9.8-9.6L417.1,983.6z"/>
              <path class="st693" d="M530.4,983.5c3.3,6.1,6.7,12.3,10.2,18.3c4.2,6.9,8.7,13.8,12.9,20.7c3.9,6.4,7.8,12.8,11.7,19.2
		c0.6-8.1,1.2-16.2,1.9-24.2c0.6-6.9,1.2-13.8,1.5-20.7c0.3-4.4,0.4-8.9,0.5-13.4l17.9,0.1c-1.4,12.9-2.8,25.8-3.8,38.8
		c-0.8,10.4-1.2,20.9-1.5,31.4l-29.6-0.1c-3.6-6.3-7.1-12.7-10.9-19c-3.9-6.3-8.1-12.5-11.9-18.8c-4.2-6.9-8.2-13.9-12.3-20.8
		c-0.8,10.3-1.5,20.6-2.4,30.8c-0.4,6.2-0.9,12.3-1.2,18.5v9.4l-17.4-0.1c1-9.6,2.1-19.3,2.8-29.1c0.4-5.7,0.6-11.4,0.9-17.1
		c0.4-5.3,0.9-10.5,1-15.8v-8.2L530.4,983.5z"/>
              <path class="st693" d="M648.4,996.6c-7.2-1.5-14.7-3.2-22.3-3.2c-6.6,0-9.3,1.3-11.1,3.3c-0.4,0.4-1.4,1.7-1.4,3.2
		c0,2.7,2.8,4.7,5.2,6.4c4.7,3,9.3,6,14.1,9.2c3.7,2.5,7.2,5.1,10.8,7.7c2.1,1.9,7.5,5.9,7.5,13c0,2.7-0.9,8.3-7.7,12.9
		c-5.8,3.9-12.3,4.7-19.8,5.5c-14.6,0.2-18.1-0.3-31.8-3.4l-0.9-13.5c2,0.8,3.9,1.5,6.1,2.2c9.1,3,17.5,3.4,21.3,3.4
		c2.4,0,5.6-0.1,7.7-0.8c1.2-0.3,5.8-1.8,5.8-5.4c0-2.8-2.8-4.8-5.7-6.9c-2.9-2-5.8-4-8.7-5.9c-2.9-1.9-5.8-3.7-8.6-5.7
		c-1.9-1.3-3.8-2.8-5.7-4.2c-2.3-1.9-8.5-6.7-8.5-14.6c0-5.3,3-10.6,8.9-13.7c1.4-0.7,3.2-1.5,6.6-2.3c8.5-2.1,13.4-1.8,17.6-1.8
		c6,0.2,9,0.2,19.4,2L648.4,996.6z"/>
              <path class="st693" d="M680.9,983.6c-1,11.9-2,23.8-2.8,35.7c-0.8,11.4-1.2,22.8-1.9,34.2h-19.5c1.2-12,2.4-24,3.2-36
		c0.6-11.3,0.9-22.6,1.2-34L680.9,983.6z"/>
              <path class="st693" d="M709.4,983.4c5.6-0.1,11.1-0.3,16.6-0.3c5.7,0,11.3,0.2,16.8,0.4c8.1,1,13.5,1.9,19.5,6.5
		c3.9,3,6.1,6.5,6.9,7.8c3.9,7,3.8,13.5,3.6,21.2c-0.8,6.9-1.2,8.4-3.7,15c-0.4,0.8-0.8,1.6-1.2,2.4c-1.5,2.7-5.2,9.1-14.3,13.2
		c-3.8,1.7-6.9,2.4-15,3.3c-6.9,0.3-13.5,0.6-20.6,0.6c-3.8,0-7.7-0.1-11.5-0.1c-5.8,0-11.7,0-17.5,0.1c0.6-6,1.4-12,1.8-18
		c0.3-4.9,0.4-9.8,0.8-14.7c0.4-6.9,0.9-13.9,1.2-20.9c0.3-5.5,0.3-11,0.4-16.5L709.4,983.4L709.4,983.4z M708.4,1041.5
		c5.8,0,11.8,0.1,17.5-0.2l6.5-0.3c0.4-0.1,4.1-0.5,6.3-1.2c2.1-0.6,6.9-2.2,10.2-6.4c3.9-4.8,6.1-12.4,6.1-18
		c0-3-0.4-14.9-14.1-18.8c-3.2-0.9-5.8-1-9.1-1.2H711L708.4,1041.5z"/>
              <path class="st693" d="M848.6,983.4l-0.5,12.5c-7.8-0.4-15.7-0.7-23.7-0.7c-7.7,0-15.5,0.2-23.2,0.4l-0.8,15.9l41-0.3l-0.8,12.7
		c-7.2-0.2-14.6-0.5-21.8-0.5c-6.5,0-12.8,0.1-19.1,0.3l-1,17.8c8.9,0.1,17.9,0.3,26.7,0.1c6.9-0.2,13.5-0.5,20.4-0.9v12.7h-67.1
		c0.5-3.9,1-7.7,1.4-11.6c0.5-5.8,0.8-11.6,1-17.3c0.5-7.9,1-15.9,1.2-23.8c0.3-5.8,0.3-11.5,0.4-17.3L848.6,983.4L848.6,983.4z"/>
              <path class="st693" d="M902.4,983.7c5.6,0.4,10.8,0.9,15.2,3.7c2.8,1.7,7.7,6.2,7.7,13.9c0,1-0.1,3.2-1,5.7
		c-0.9,2.7-3.7,8.9-11.8,12.9c-2.9,1.4-6.9,2.6-10.2,3.5l18.9,30.1H900c-2-4.2-4.1-8.3-6.5-12.4c-2.3-4.1-4.8-8.2-7.2-12.2
		c-3-4.9-6-9.8-8.9-14.6c2.9,0.2,5.8,0.4,8.7,0.4c2.3,0,12.3-0.1,17.3-5.6c2.3-2.6,2.5-5.3,2.5-6.5c0-1.1-0.3-4.2-3.3-6.1
		c-1.9-1.2-3.6-1.6-8.6-1.8l-19,0.1c-1.2,13.7-2.1,27.4-2.7,41.1c-0.3,5.9-0.4,11.7-0.5,17.5h-19.5c0.9-7.5,1.5-15,2-22.6
		c0.4-5.8,0.6-11.7,0.9-17.5c0.4-6.2,0.8-12.3,0.9-18.5c0.1-3.7,0.1-7.4,0.1-11.1H902.4L902.4,983.7z"/>
</g>
</svg>
        </div>
      </template>
      <span>Risk Insider</span>
    </v-tooltip>
  </div>
</template>

<script>
/**
 * @component RiskInsiderButton
 * Home button component that redirects to Risk Insider page
 */
export default {
  name: 'RiskInsiderButton',
  props: {
    isMobileOrTablet: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    goToRiskInsiderPage() {
      this.$router.push('/analytics');
    }
  }
}
</script>

<style lang="scss" scoped>
.main-light {
  .home-button {
    background-color: rgba(0, 0, 0, 0.15);
    border: 4px solid #5c9485;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.7);

    &:hover {
      background-color: rgb(255, 255, 255);
      border: 4px solid #4ABD96 !important;
      box-shadow: 5px 5px 14px rgba(0, 0, 0, 0.7);
      cursor: pointer;
      z-index: 99999;
      transform: scale(1.1);
    }
  }
}
</style>

<style scoped>
.st0 {
  clip-path: url(#SVGID_00000023960823273213888270000001154971737469410718_);
}

.st1 {
  clip-path: url(#SVGID_00000065066941608979478220000018395142525294539430_);
  enable-background: new;
}

.st2 {
  clip-path: url(#SVGID_00000115511295756884180730000008349426005868978611_);
}

.st3 {
  clip-path: url(#SVGID_00000177483357472511864730000007846408534071739808_);
}

.st4 {
  opacity: 0;
  clip-path: url(#SVGID_00000076572350329842180180000001012093076435631768_);
}

.st5 {
  opacity: 0;
}

.st6 {
  clip-path: url(#SVGID_00000006682014132089688340000018281828901630489785_);
}

.st7 {
  clip-path: url(#SVGID_00000079483514126333542080000000178005317662456243_);
}

.st8 {
  clip-path: url(#SVGID_00000145765926680020754250000000471394311352551577_);
  fill: #3FB994;
}

.st9 {
  clip-path: url(#SVGID_00000036247650165861291370000014147336909434949773_);
}

.st10 {
  clip-path: url(#SVGID_00000103961258719332205700000013837810653380650368_);
  enable-background: new;
}

.st11 {
  clip-path: url(#SVGID_00000004543030037525160060000008747052960045765284_);
}

.st12 {
  clip-path: url(#SVGID_00000003094334136715616390000014532208605084373378_);
}

.st13 {
  clip-path: url(#SVGID_00000071548358019375001430000012778875083860589475_);
  fill: #3FB994;
}

.st14 {
  clip-path: url(#SVGID_00000177475923696459840460000009953415209712177833_);
}

.st15 {
  clip-path: url(#SVGID_00000008119200335489126670000012900103114264839083_);
}

.st16 {
  clip-path: url(#SVGID_00000044173325165288232230000011395975146066100365_);
  fill: #3FB994;
}

.st17 {
  clip-path: url(#SVGID_00000018924275746485703700000007754116364649897396_);
}

.st18 {
  clip-path: url(#SVGID_00000068677734899153551040000004917133571929500066_);
}

.st19 {
  clip-path: url(#SVGID_00000124877307293550609530000015764606447159736211_);
  fill: #3FB994;
}

.st20 {
  clip-path: url(#SVGID_00000093873592713331449880000016986830128008615058_);
}

.st21 {
  clip-path: url(#SVGID_00000085224675494023357890000007037033369768112011_);
}

.st22 {
  clip-path: url(#SVGID_00000122713791355881445390000002099497724042334367_);
  fill: #3FB994;
}

.st23 {
  clip-path: url(#SVGID_00000037670359305580965070000003143890322038717825_);
}

.st24 {
  clip-path: url(#SVGID_00000169525056783686893940000005202500499287548305_);
}

.st25 {
  clip-path: url(#SVGID_00000073685562647192310740000018169286532993779587_);
  fill: #3FB994;
}

.st26 {
  clip-path: url(#SVGID_00000057834017654999726340000017645547412957787558_);
}

.st27 {
  clip-path: url(#SVGID_00000095300653486595606860000002386663343974349744_);
}

.st28 {
  clip-path: url(#SVGID_00000123420457230868150410000009809637709723857796_);
  fill: #3FB994;
}

.st29 {
  clip-path: url(#SVGID_00000053518994705106654430000004039559434251029682_);
}

.st30 {
  clip-path: url(#SVGID_00000142142985657536677720000011900246200986389438_);
}

.st31 {
  clip-path: url(#SVGID_00000002364493900996772460000018274257303617160876_);
  fill: #3FB994;
}

.st32 {
  clip-path: url(#SVGID_00000146498672776251228330000015386979302319743879_);
}

.st33 {
  clip-path: url(#SVGID_00000176760112876901471310000017744871156141563308_);
}

.st34 {
  clip-path: url(#SVGID_00000127735531953108031300000005789916302059041175_);
  fill: #3FB994;
}

.st35 {
  clip-path: url(#SVGID_00000103984492842063184230000008980123737134369972_);
}

.st36 {
  clip-path: url(#SVGID_00000099646595944907750110000017867725775657552780_);
}

.st37 {
  clip-path: url(#SVGID_00000134936018856228936680000008920393103907640194_);
  fill: #3FB994;
}

.st38 {
  clip-path: url(#SVGID_00000163779285462840294590000008458641814855419563_);
}

.st39 {
  clip-path: url(#SVGID_00000157277459608858495490000015782829643396397489_);
}

.st40 {
  clip-path: url(#SVGID_00000089541591096271451220000008143207163481462145_);
  fill: #3FB994;
}

.st41 {
  clip-path: url(#SVGID_00000132808684645202331520000015843716454644958348_);
}

.st42 {
  clip-path: url(#SVGID_00000108298467933972370510000005547906978870094522_);
}

.st43 {
  clip-path: url(#SVGID_00000095331843391718121790000012233923344527432074_);
  fill: #3FB994;
}

.st44 {
  clip-path: url(#SVGID_00000057124384690595910690000012680020199346725305_);
}

.st45 {
  clip-path: url(#SVGID_00000046336798483589589040000010305910477134119574_);
}

.st46 {
  clip-path: url(#SVGID_00000006671742721996417080000001069004200729122729_);
  fill: #3FB994;
}

.st47 {
  clip-path: url(#SVGID_00000087408797390924708280000006290820288960699542_);
}

.st48 {
  clip-path: url(#SVGID_00000167374558535407433750000013838832062687029894_);
}

.st49 {
  clip-path: url(#SVGID_00000119834293764015331150000015390999530644041354_);
  fill: #3FB994;
}

.st50 {
  clip-path: url(#SVGID_00000111180330888064098580000002984893662107124149_);
}

.st51 {
  clip-path: url(#SVGID_00000105403013534893273360000002689633442560708767_);
  enable-background: new;
}

.st52 {
  clip-path: url(#SVGID_00000035512786460561590410000010815016585330324922_);
}

.st53 {
  clip-path: url(#SVGID_00000096747945659526879640000007969167919877048704_);
}

.st54 {
  clip-path: url(#SVGID_00000137828861494661457170000005842057340248243331_);
  fill: #306175;
}

.st55 {
  clip-path: url(#SVGID_00000182519666659272537050000003122036184270971572_);
}

.st56 {
  clip-path: url(#SVGID_00000181807189871146773320000001373463000070173824_);
}

.st57 {
  clip-path: url(#SVGID_00000047738964418143563460000001614672937529729206_);
  fill: #32657A;
}

.st58 {
  clip-path: url(#SVGID_00000096774879175010917680000014188276418851894443_);
}

.st59 {
  clip-path: url(#SVGID_00000065787421033170349640000017636146526602977982_);
}

.st60 {
  clip-path: url(#SVGID_00000065032217751127513160000013695061647101739911_);
  fill: #34697F;
}

.st61 {
  clip-path: url(#SVGID_00000175322821536974761580000000042062752811181188_);
}

.st62 {
  clip-path: url(#SVGID_00000145754276140347754560000013995596590387164063_);
}

.st63 {
  clip-path: url(#SVGID_00000012474113639196668240000004436057045167848857_);
  fill: #366C82;
}

.st64 {
  clip-path: url(#SVGID_00000002369831040212975380000002578238975231031483_);
}

.st65 {
  clip-path: url(#SVGID_00000145030730314795259890000017927640425009470849_);
  enable-background: new;
}

.st66 {
  clip-path: url(#SVGID_00000125574866199079439150000000120473468030649017_);
}

.st67 {
  clip-path: url(#SVGID_00000129176422064660681320000015276207671478713475_);
}

.st68 {
  opacity: 0;
  clip-path: url(#SVGID_00000076590613957717735620000007859106538327347373_);
}

.st69 {
  clip-path: url(#SVGID_00000129199878537346286610000018131973297535272861_);
}

.st70 {
  clip-path: url(#SVGID_00000013891568497938792370000017869954800442513076_);
}

.st71 {
  clip-path: url(#SVGID_00000029760176425429042070000007647163199386408378_);
  fill: #3FB994;
}

.st72 {
  clip-path: url(#SVGID_00000023259750650997716010000008062134378904668839_);
}

.st73 {
  clip-path: url(#SVGID_00000149344839617360630380000006395282769130406541_);
  enable-background: new;
}

.st74 {
  clip-path: url(#SVGID_00000133495791662931684090000002215914288913011357_);
}

.st75 {
  clip-path: url(#SVGID_00000166646282443536767750000018126301619128060332_);
}

.st76 {
  clip-path: url(#SVGID_00000062914268749057414520000000148982325098882988_);
  fill: #3FB994;
}

.st77 {
  clip-path: url(#SVGID_00000004517515464096116840000011773291403594247072_);
}

.st78 {
  clip-path: url(#SVGID_00000098920617183520699810000018001131779823671195_);
}

.st79 {
  clip-path: url(#SVGID_00000054240202972186032460000013665639049703408008_);
  fill: #3FB994;
}

.st80 {
  clip-path: url(#SVGID_00000093167766080089053070000005897408156144903094_);
}

.st81 {
  clip-path: url(#SVGID_00000174586726021561225590000002693870811079198640_);
}

.st82 {
  clip-path: url(#SVGID_00000169515782577540946260000018036327945878312373_);
  fill: #3FB994;
}

.st83 {
  clip-path: url(#SVGID_00000147194072633628152420000009159819449089102984_);
}

.st84 {
  clip-path: url(#SVGID_00000147210704975594108210000016491141060150019497_);
}

.st85 {
  clip-path: url(#SVGID_00000044164707726077080340000013422540924166041223_);
  fill: #3FB994;
}

.st86 {
  clip-path: url(#SVGID_00000124844408099532816140000009338464671527709619_);
}

.st87 {
  clip-path: url(#SVGID_00000180351802792648638470000002707751779826417324_);
}

.st88 {
  clip-path: url(#SVGID_00000100366653292703675490000012911104395590671537_);
  fill: #3FB994;
}

.st89 {
  clip-path: url(#SVGID_00000028283707995439267750000005600846501871830667_);
}

.st90 {
  clip-path: url(#SVGID_00000151520429874680748070000015665860253116632963_);
}

.st91 {
  clip-path: url(#SVGID_00000178905785339535210820000016484212828467121285_);
  fill: #3FB994;
}

.st92 {
  clip-path: url(#SVGID_00000127035309974018217970000013427318643803337125_);
}

.st93 {
  clip-path: url(#SVGID_00000119115702530614473240000009064896111791446688_);
}

.st94 {
  clip-path: url(#SVGID_00000155844970999155427470000007888098315369858214_);
  fill: #3FB994;
}

.st95 {
  clip-path: url(#SVGID_00000165920109687918917940000007153646271490338946_);
}

.st96 {
  clip-path: url(#SVGID_00000098922930115938308800000007232802168812672946_);
}

.st97 {
  clip-path: url(#SVGID_00000092426773759199615130000012759663493568380082_);
  fill: #3FB994;
}

.st98 {
  clip-path: url(#SVGID_00000075157520169821761130000010710437408433626759_);
}

.st99 {
  clip-path: url(#SVGID_00000048467037298424938260000008647154495341868730_);
}

.st100 {
  clip-path: url(#SVGID_00000052805721488849997920000002555314930049874870_);
  fill: #3FB994;
}

.st101 {
  clip-path: url(#SVGID_00000059995632207980656360000015480542906501166247_);
}

.st102 {
  clip-path: url(#SVGID_00000016753439067907525620000009144625008310254763_);
}

.st103 {
  clip-path: url(#SVGID_00000046305012699231427910000000393410211616146606_);
  fill: #3FB994;
}

.st104 {
  clip-path: url(#SVGID_00000097502802897090803420000015270153597644521358_);
}

.st105 {
  clip-path: url(#SVGID_00000098930920791358898910000011047615366132196530_);
}

.st106 {
  clip-path: url(#SVGID_00000183947647933428514190000006750767691553256331_);
  fill: #3FB994;
}

.st107 {
  clip-path: url(#SVGID_00000093866698094372625930000004639193127596485013_);
}

.st108 {
  clip-path: url(#SVGID_00000062872820110727364270000016255131662325094045_);
}

.st109 {
  clip-path: url(#SVGID_00000039831753373116755900000001222477054349408392_);
  fill: #3FB994;
}

.st110 {
  clip-path: url(#SVGID_00000044898515588293146330000008420565591250946455_);
}

.st111 {
  clip-path: url(#SVGID_00000117659188595786449660000001926276862523172789_);
}

.st112 {
  clip-path: url(#SVGID_00000024723195685613216210000004396898120437718408_);
  fill: #3FB994;
}

.st113 {
  clip-path: url(#SVGID_00000033339171422262911030000014069909519565787013_);
}

.st114 {
  clip-path: url(#SVGID_00000143612947001231352410000008948066615699380866_);
}

.st115 {
  clip-path: url(#SVGID_00000135653697371639178870000017629939851732789891_);
  fill: #3FB994;
}

.st116 {
  clip-path: url(#SVGID_00000060714953173302835410000009987404869450911891_);
}

.st117 {
  clip-path: url(#SVGID_00000026878536341059975630000010714021299394022062_);
}

.st118 {
  clip-path: url(#SVGID_00000029008286782330971340000011775799515564605848_);
  fill: #3FB994;
}

.st119 {
  clip-path: url(#SVGID_00000108301111920061595400000003011996053848870064_);
}

.st120 {
  clip-path: url(#SVGID_00000180351394120709267140000012894601794204178098_);
}

.st121 {
  clip-path: url(#SVGID_00000165947250629139289780000005186554670955873464_);
  fill: #3FB994;
}

.st122 {
  clip-path: url(#SVGID_00000084504261833362930690000006478075241890870940_);
}

.st123 {
  clip-path: url(#SVGID_00000128461565246313965120000011148115255311793293_);
}

.st124 {
  clip-path: url(#SVGID_00000039132108601586673690000001869608627044486314_);
  fill: #3FB994;
}

.st125 {
  clip-path: url(#SVGID_00000119821868976467308530000000590221327867509659_);
}

.st126 {
  clip-path: url(#SVGID_00000168090792103819377250000017722236182544895402_);
}

.st127 {
  clip-path: url(#SVGID_00000176734676393431448940000009108088771879624608_);
  fill: #3FB994;
}

.st128 {
  clip-path: url(#SVGID_00000132789089319003762020000007908382876987975357_);
}

.st129 {
  clip-path: url(#SVGID_00000077292330456019610000000016484783058785596583_);
  fill: #154C3D;
}

.st130 {
  clip-path: url(#SVGID_00000089549461282783307370000004691197924462820762_);
}

.st131 {
  clip-path: url(#SVGID_00000069386316940036362710000005863952048235813273_);
  fill: #226A57;
}

.st132 {
  clip-path: url(#SVGID_00000110429229265337663590000007824374108926601883_);
}

.st133 {
  clip-path: url(#SVGID_00000036242929503560264000000009705027761867313038_);
  fill: #226A57;
}

.st134 {
  clip-path: url(#SVGID_00000038374038902735030790000003491980981149396882_);
}

.st135 {
  clip-path: url(#SVGID_00000028288861921937405880000014836334490869991827_);
  fill: #3FB994;
}

.st136 {
  clip-path: url(#SVGID_00000095300368804889055720000005107588603075940009_);
}

.st137 {
  clip-path: url(#SVGID_00000074430193287400835780000004790966392597597825_);
  fill: #3FB994;
}

.st138 {
  clip-path: url(#SVGID_00000068657525882582429830000015671563795743019944_);
}

.st139 {
  clip-path: url(#SVGID_00000018222916813103743800000001513695377570737319_);
  fill: #25292A;
}

.st140 {
  clip-path: url(#SVGID_00000102509693706040442800000014474785053887132607_);
}

.st141 {
  clip-path: url(#SVGID_00000132806470544072161570000009217445000933357753_);
  fill: #3FB994;
}

.st142 {
  clip-path: url(#SVGID_00000133515123854961777910000005827109084315881904_);
}

.st143 {
  clip-path: url(#SVGID_00000067198076230862599060000007362837703849589169_);
  fill: #42B994;
}

.st144 {
  clip-path: url(#SVGID_00000117648494686900634770000008169716999406537899_);
}

.st145 {
  clip-path: url(#SVGID_00000141442231757480753890000000966199623861275303_);
  fill: #25292A;
}

.st146 {
  clip-path: url(#SVGID_00000173147073074978532620000016586160432965456563_);
}

.st147 {
  clip-path: url(#SVGID_00000060725610690974104950000009264400937365917319_);
  fill: #42B994;
}

.st148 {
  clip-path: url(#SVGID_00000099639878975780923670000001770129753370216119_);
}

.st149 {
  clip-path: url(#SVGID_00000013880241394378119220000011844966409245043098_);
  fill: #25292A;
}

.st150 {
  clip-path: url(#SVGID_00000165210216444661754400000016511104951187940999_);
}

.st151 {
  clip-path: url(#SVGID_00000114758216947036689590000009670971120861817761_);
  fill: #42B994;
}

.st152 {
  clip-path: url(#SVGID_00000146480729463066618700000013497563626738344091_);
}

.st153 {
  clip-path: url(#SVGID_00000066494603529303902700000002684407210622385302_);
  fill: #25292A;
}

.st154 {
  clip-path: url(#SVGID_00000046310114308857969020000002159476656224061056_);
}

.st155 {
  clip-path: url(#SVGID_00000036960726596498193460000017724178697650125478_);
  enable-background: new;
}

.st156 {
  clip-path: url(#SVGID_00000035494210866656084770000002066694147438647741_);
}

.st157 {
  clip-path: url(#SVGID_00000094608441127291396170000018437583284583901879_);
}

.st158 {
  clip-path: url(#SVGID_00000183219245488612458000000006879781851527094438_);
  fill: #25292A;
}

.st159 {
  clip-path: url(#SVGID_00000119078675199467703730000004650877858215862666_);
}

.st160 {
  clip-path: url(#SVGID_00000022537649313286217030000014205834648547515318_);
}

.st161 {
  clip-path: url(#SVGID_00000016074013922055628000000005091507493159462565_);
  fill: #25292A;
}

.st162 {
  clip-path: url(#SVGID_00000064314153501836200930000005582343135368301985_);
}

.st163 {
  clip-path: url(#SVGID_00000031199833679906313650000009610980611282546605_);
  enable-background: new;
}

.st164 {
  clip-path: url(#SVGID_00000114046413658202666570000016007795309265099137_);
}

.st165 {
  clip-path: url(#SVGID_00000134210362601357027280000018313669095723417222_);
}

.st166 {
  clip-path: url(#SVGID_00000088130839860171607530000012965753591816652945_);
  fill: #3FB994;
}

.st167 {
  clip-path: url(#SVGID_00000052806292229269161630000002804553935506803635_);
}

.st168 {
  clip-path: url(#SVGID_00000120529704903549439810000015386534540309513398_);
}

.st169 {
  clip-path: url(#SVGID_00000145741992048154445690000005627536910203114940_);
  fill: #001820;
}

.st170 {
  clip-path: url(#SVGID_00000058584211669218473650000012310242096329686459_);
}

.st171 {
  clip-path: url(#SVGID_00000051378009381160646790000000815376624508231084_);
  fill: #25292A;
}

.st172 {
  clip-path: url(#SVGID_00000032630080031755782650000017745618704230639003_);
}

.st173 {
  clip-path: url(#SVGID_00000060018464480074727940000015410123982803261572_);
  fill: #25292A;
}

.st174 {
  clip-path: url(#SVGID_00000034768006422984778770000013162875047385420975_);
}

.st175 {
  clip-path: url(#SVGID_00000132802759250699604040000015626183222185821578_);
  fill: #A4A6A5;
}

.st176 {
  clip-path: url(#SVGID_00000139256434803752803630000000235396333610231743_);
}

.st177 {
  clip-path: url(#SVGID_00000084487886595353363660000009687881855364201407_);
  fill: #9CB3C6;
}

.st178 {
  clip-path: url(#SVGID_00000087405622603832408560000007821631509011883704_);
}

.st179 {
  clip-path: url(#SVGID_00000133491584455498923690000001020484968033581461_);
  fill: #9CB3C6;
}

.st180 {
  clip-path: url(#SVGID_00000109729425261739818440000007449652425370590893_);
}

.st181 {
  clip-path: url(#SVGID_00000159431454811066054190000017806255508910075525_);
  fill: #25292A;
}

.st182 {
  clip-path: url(#SVGID_00000134218099762405337710000011278588475886196398_);
}

.st183 {
  clip-path: url(#SVGID_00000135672289390218846680000008857403304048953225_);
  fill: #E0E1DB;
}

.st184 {
  clip-path: url(#SVGID_00000016061253992449152040000009940421295109646990_);
}

.st185 {
  clip-path: url(#SVGID_00000062194015809884607710000007584625702556206241_);
  fill: #25292A;
}

.st186 {
  clip-path: url(#SVGID_00000140699141865155273820000017526974750425672870_);
}

.st187 {
  clip-path: url(#SVGID_00000064320300051333051310000014173791616040704156_);
  fill: #25292A;
}

.st188 {
  clip-path: url(#SVGID_00000042713840017080888320000013846435199833286556_);
}

.st189 {
  clip-path: url(#SVGID_00000174587604404667574780000015645946588578603947_);
  fill: #25292A;
}

.st190 {
  clip-path: url(#SVGID_00000029034635881914558690000000378301185271444126_);
}

.st191 {
  clip-path: url(#SVGID_00000173844023886621145630000005341040801658982321_);
  fill: #A4A6A5;
}

.st192 {
  clip-path: url(#SVGID_00000088102666125424980360000001040684416553288597_);
}

.st193 {
  clip-path: url(#SVGID_00000031170434244193985740000008921914389048778628_);
  enable-background: new;
}

.st194 {
  clip-path: url(#SVGID_00000119801979606138888540000016553672323230689982_);
}

.st195 {
  clip-path: url(#SVGID_00000173880967293388535250000013322567930840384394_);
}

.st196 {
  opacity: 0;
  clip-path: url(#SVGID_00000081618400847538829660000006606464240491005849_);
}

.st197 {
  clip-path: url(#SVGID_00000031924441509239737360000005927704251948263053_);
}

.st198 {
  clip-path: url(#SVGID_00000176722298837040152120000011717408525431295165_);
}

.st199 {
  clip-path: url(#SVGID_00000158025663232686373710000002315406000639920556_);
  enable-background: new;
}

.st200 {
  clip-path: url(#SVGID_00000022527178781763246720000006628582451255304870_);
}

.st201 {
  clip-path: url(#SVGID_00000044882890270172092450000016311706569687446710_);
}

.st202 {
  opacity: 0;
  clip-path: url(#SVGID_00000017496266249610401960000011808228656882834564_);
}

.st203 {
  clip-path: url(#SVGID_00000175283377544997365250000012020265107108240049_);
}

.st204 {
  clip-path: url(#SVGID_00000044177197090449569560000005716739513677123513_);
}

.st205 {
  clip-path: url(#SVGID_00000170979556744087603140000003051463873519215242_);
  enable-background: new;
}

.st206 {
  clip-path: url(#SVGID_00000121259159009858795070000013859661164957833395_);
}

.st207 {
  clip-path: url(#SVGID_00000041977274733718942170000018446259449612657594_);
}

.st208 {
  opacity: 0;
  clip-path: url(#SVGID_00000157280807449413600730000002216877142626136985_);
}

.st209 {
  clip-path: url(#SVGID_00000110447533490890418810000012987818735607779997_);
}

.st210 {
  clip-path: url(#SVGID_00000158022209133038950390000014873541404332647353_);
}

.st211 {
  clip-path: url(#SVGID_00000082327782622822465450000015398463493437246896_);
  fill: #4EBD99;
}

.st212 {
  clip-path: url(#SVGID_00000003067389233473893700000003955387459671894955_);
}

.st213 {
  clip-path: url(#SVGID_00000048472512234653109790000004130906842025729157_);
  fill: #42B994;
}

.st214 {
  clip-path: url(#SVGID_00000101083705610863196010000004102242183825253542_);
}

.st215 {
  clip-path: url(#SVGID_00000093855061081901318590000013651476483535722139_);
  fill: #226A57;
}

.st216 {
  clip-path: url(#SVGID_00000016046213738556248010000018240978000800228256_);
}

.st217 {
  clip-path: url(#SVGID_00000029743119988060936640000016313640174369145217_);
  fill: #165748;
}

.st218 {
  clip-path: url(#SVGID_00000044863386078342161900000007436220979022454935_);
}

.st219 {
  clip-path: url(#SVGID_00000039100992486771753320000007147064803394253212_);
  fill: #42B994;
}

.st220 {
  clip-path: url(#SVGID_00000121265878964894400840000016916384945370426257_);
}

.st221 {
  clip-path: url(#SVGID_00000099636444273036584640000002748674409333701510_);
  fill: #226A57;
}

.st222 {
  clip-path: url(#SVGID_00000132770253503585899600000006483235889507896970_);
}

.st223 {
  clip-path: url(#SVGID_00000084508116285067352530000010674930243388629433_);
  fill: #165748;
}

.st224 {
  clip-path: url(#SVGID_00000029030737898078744970000000610516039942867348_);
}

.st225 {
  clip-path: url(#SVGID_00000109747481925221383030000002242228660823294875_);
  fill: #42B994;
}

.st226 {
  clip-path: url(#SVGID_00000060741381939497736530000008892893888757332100_);
}

.st227 {
  clip-path: url(#SVGID_00000119817817565575108180000014055537304352097430_);
  fill: #226A57;
}

.st228 {
  clip-path: url(#SVGID_00000095314646946380291650000002231242498526213504_);
}

.st229 {
  clip-path: url(#SVGID_00000074422861456878274510000013202095389281183885_);
  fill: #165748;
}

.st230 {
  clip-path: url(#SVGID_00000078028056741465586090000004951202516845863572_);
}

.st231 {
  clip-path: url(#SVGID_00000113318313708692219840000016631526121560366258_);
  fill: #42B994;
}

.st232 {
  clip-path: url(#SVGID_00000062900736440898517620000006079603357031815046_);
}

.st233 {
  clip-path: url(#SVGID_00000051385492855750444850000005362894208648661680_);
  fill: #226A57;
}

.st234 {
  clip-path: url(#SVGID_00000159471099573834154840000016219444120846514841_);
}

.st235 {
  clip-path: url(#SVGID_00000116936536198403460630000007476887131492689833_);
  fill: #165748;
}

.st236 {
  clip-path: url(#SVGID_00000176756778440072987310000004763439144149066376_);
}

.st237 {
  clip-path: url(#SVGID_00000070840258321662062700000011261019111293792432_);
  fill: #42B994;
}

.st238 {
  clip-path: url(#SVGID_00000173127751791470290390000001342093983544444289_);
}

.st239 {
  clip-path: url(#SVGID_00000135649805159204378180000003684753719080826798_);
  fill: #226A57;
}

.st240 {
  clip-path: url(#SVGID_00000078039465720914979230000006828031833502597806_);
}

.st241 {
  clip-path: url(#SVGID_00000039133827609583725540000006735725988927071929_);
  fill: #165748;
}

.st242 {
  clip-path: url(#SVGID_00000018218993596278440840000004668675277155619755_);
}

.st243 {
  clip-path: url(#SVGID_00000111151441025575296070000016178011375419573407_);
  fill: #226A57;
}

.st244 {
  clip-path: url(#SVGID_00000065789865089271335710000000591898554122224824_);
}

.st245 {
  clip-path: url(#SVGID_00000004547974491241071360000007270346614527708034_);
  fill: #FFFFFF;
}

.st246 {
  clip-path: url(#SVGID_00000109008303897863146780000012519342309985500076_);
}

.st247 {
  clip-path: url(#SVGID_00000175312482140207767390000012968146105736409002_);
  fill: #226A57;
}

.st248 {
  clip-path: url(#SVGID_00000178193462809347320120000017133819283007386501_);
}

.st249 {
  clip-path: url(#SVGID_00000093170450882532776210000017352272614767682224_);
  fill: #42B994;
}

.st250 {
  clip-path: url(#SVGID_00000093864346213735713370000005141751631400164797_);
}

.st251 {
  clip-path: url(#SVGID_00000006679660268769326480000011402504976530548667_);
  fill: #226A57;
}

.st252 {
  clip-path: url(#SVGID_00000110450461722834213800000009866738718880891315_);
}

.st253 {
  clip-path: url(#SVGID_00000098184119974880611410000014668237913728217528_);
  fill: #42B994;
}

.st254 {
  clip-path: url(#SVGID_00000160164062732494200530000017111141893200288150_);
}

.st255 {
  clip-path: url(#SVGID_00000072260993749014588150000002871832134885563067_);
  fill: #226A57;
}

.st256 {
  clip-path: url(#SVGID_00000030447909313189455100000014778392462720469142_);
}

.st257 {
  clip-path: url(#SVGID_00000069372713355456312370000014393767884723458745_);
  fill: #42B994;
}

.st258 {
  clip-path: url(#SVGID_00000074417307979413141230000005524573937497744001_);
}

.st259 {
  clip-path: url(#SVGID_00000165212460929399531320000006984496793975670441_);
  fill: #EBEAE6;
}

.st260 {
  clip-path: url(#SVGID_00000063610051079531339460000004215846176634699396_);
}

.st261 {
  clip-path: url(#SVGID_00000076591679239172030070000012299951550755367595_);
  fill: #DCDDD7;
}

.st262 {
  clip-path: url(#SVGID_00000005982360867996503960000018370831352622808192_);
}

.st263 {
  clip-path: url(#SVGID_00000097489025856083443740000006431648334272535691_);
  fill: #868B89;
}

.st264 {
  clip-path: url(#SVGID_00000051348242055768593080000013353654385253668284_);
}

.st265 {
  clip-path: url(#SVGID_00000086650230945175826850000014429517335089252524_);
  fill: #95CCB9;
}

.st266 {
  clip-path: url(#SVGID_00000179622645324972078380000005987009837140242330_);
}

.st267 {
  clip-path: url(#SVGID_00000168107079147531569570000003037987474867220412_);
  fill: #82A79C;
}

.st268 {
  clip-path: url(#SVGID_00000038380569042399681060000013762626890637355431_);
}

.st269 {
  clip-path: url(#SVGID_00000101066085269728720780000006985695049351421098_);
  fill: #7FA096;
}

.st270 {
  clip-path: url(#SVGID_00000067957875183329957760000007129899234831489193_);
}

.st271 {
  clip-path: url(#SVGID_00000083067045171047537100000011777895524055060612_);
  fill: #95CCB9;
}

.st272 {
  clip-path: url(#SVGID_00000112634633721741958670000008342159981817960606_);
}

.st273 {
  clip-path: url(#SVGID_00000121997965097363154860000007496863957838811041_);
  fill: #82A79C;
}

.st274 {
  clip-path: url(#SVGID_00000152963779032720015980000012258562950200167084_);
}

.st275 {
  clip-path: url(#SVGID_00000093873455890339224030000005485545915974154370_);
  fill: #7FA096;
}

.st276 {
  clip-path: url(#SVGID_00000084503176021841208860000016748099283321819321_);
}

.st277 {
  clip-path: url(#SVGID_00000071541080079604282400000014485727328849683077_);
  fill: #95CCB9;
}

.st278 {
  clip-path: url(#SVGID_00000003814819253475112340000008580781593129233319_);
}

.st279 {
  clip-path: url(#SVGID_00000075862664389569380960000001764637586880688542_);
  fill: #82A79C;
}

.st280 {
  clip-path: url(#SVGID_00000134243762633855986130000008762857094548801195_);
}

.st281 {
  clip-path: url(#SVGID_00000039117440333768473740000005646096818047753367_);
  fill: #95CCB9;
}

.st282 {
  clip-path: url(#SVGID_00000034087067510737306880000007903246640996651908_);
}

.st283 {
  clip-path: url(#SVGID_00000144299830145595130550000018288543287762687392_);
  fill: #82A79C;
}

.st284 {
  clip-path: url(#SVGID_00000029761780899231072080000012352107347423363501_);
}

.st285 {
  clip-path: url(#SVGID_00000164482171847529738410000001777653425647046821_);
  fill: #7FA096;
}

.st286 {
  clip-path: url(#SVGID_00000048470345620362626380000011954515030799892153_);
}

.st287 {
  clip-path: url(#SVGID_00000176037223350658106910000015291265388482473879_);
  fill: #95CCB9;
}

.st288 {
  clip-path: url(#SVGID_00000007419629608006248700000005571525844058153902_);
}

.st289 {
  clip-path: url(#SVGID_00000153699240199471380360000014196581447075842714_);
  fill: #7FA096;
}

.st290 {
  clip-path: url(#SVGID_00000109001610652103609120000015644400533611505302_);
}

.st291 {
  clip-path: url(#SVGID_00000143607118840431307920000004169778344431882160_);
  fill: #82A79C;
}

.st292 {
  clip-path: url(#SVGID_00000014636565301345156360000007871267165701096361_);
}

.st293 {
  clip-path: url(#SVGID_00000156583367112621112890000009105522577449299612_);
  fill: #EBEBE7;
}

.st294 {
  clip-path: url(#SVGID_00000099647515258031412670000005327272431818845834_);
}

.st295 {
  clip-path: url(#SVGID_00000049220509420105774470000010833818408125332915_);
  fill: #999A98;
}

.st296 {
  clip-path: url(#SVGID_00000132783571490782550410000001094088948008983731_);
}

.st297 {
  clip-path: url(#SVGID_00000057107392520054063250000004339389683537724831_);
  fill: #999A98;
}

.st298 {
  clip-path: url(#SVGID_00000085237527994397212560000009887374968680212411_);
}

.st299 {
  clip-path: url(#SVGID_00000127026004532237443460000011321140982145238690_);
  fill: #6B59A6;
}

.st300 {
  clip-path: url(#SVGID_00000043421174461017668700000011288880296811257768_);
}

.st301 {
  clip-path: url(#SVGID_00000168097676709884870080000010281576210936388282_);
  fill: #6B59A6;
}

.st302 {
  clip-path: url(#SVGID_00000134959010922235220640000000269014618951724700_);
}

.st303 {
  clip-path: url(#SVGID_00000018949410703756065930000003735067250079888015_);
  fill: #548D7A;
}

.st304 {
  clip-path: url(#SVGID_00000176755997055753820020000005191995034503438496_);
}

.st305 {
  clip-path: url(#SVGID_00000182498840377627923540000010987782171971110591_);
  fill: #4D8271;
}

.st306 {
  clip-path: url(#SVGID_00000164487389363249920510000004108720365734064318_);
}

.st307 {
  clip-path: url(#SVGID_00000138552537313338121060000007218018264722863799_);
  fill: #4A7F6F;
}

.st308 {
  clip-path: url(#SVGID_00000093878110327256628330000010536558248806038150_);
}

.st309 {
  clip-path: url(#SVGID_00000119081694104473010130000005858284846672937644_);
  fill: #4D8271;
}

.st310 {
  clip-path: url(#SVGID_00000080166527473983904930000001932227533926547596_);
}

.st311 {
  clip-path: url(#SVGID_00000109010123624235826750000000646702922800440250_);
  fill: #699687;
}

.st312 {
  clip-path: url(#SVGID_00000092416564097283405930000015260609833823325882_);
}

.st313 {
  clip-path: url(#SVGID_00000067935285164320526730000007036844807969983634_);
  fill: #C9DAD1;
}

.st314 {
  clip-path: url(#SVGID_00000068677249836637869800000010954499875570381480_);
}

.st315 {
  clip-path: url(#SVGID_00000151539768989066455080000007556032213011642023_);
  fill: #C9DAD1;
}

.st316 {
  clip-path: url(#SVGID_00000075871538481042577170000014097686195863750837_);
}

.st317 {
  clip-path: url(#SVGID_00000069357039545071273170000018017377262154037913_);
  fill: #C9DAD1;
}

.st318 {
  clip-path: url(#SVGID_00000013916059796674645280000015167149982895030663_);
}

.st319 {
  clip-path: url(#SVGID_00000085961301883317395120000008425837929595897473_);
  fill: #165748;
}

.st320 {
  clip-path: url(#SVGID_00000073717840975201662010000012584488591244122264_);
}

.st321 {
  clip-path: url(#SVGID_00000075164049897194473500000005936017787949223058_);
  fill: #165748;
}

.st322 {
  clip-path: url(#SVGID_00000065772843478619647720000017034814497341164426_);
}

.st323 {
  clip-path: url(#SVGID_00000140722715501264014550000009673578565845807272_);
  fill: #165748;
}

.st324 {
  clip-path: url(#SVGID_00000003070876742538619480000011387101583259824571_);
}

.st325 {
  clip-path: url(#SVGID_00000071556246190412911600000016767047275871829134_);
  fill: #165748;
}

.st326 {
  clip-path: url(#SVGID_00000148643991998359022810000015841293260729740438_);
}

.st327 {
  clip-path: url(#SVGID_00000101070800301186590110000007656602422370658206_);
  fill: #A4B6AD;
}

.st328 {
  clip-path: url(#SVGID_00000052067120321559736170000007109204405211554717_);
}

.st329 {
  clip-path: url(#SVGID_00000053513072770446543060000009022389088098138274_);
  fill: #A2B3AB;
}

.st330 {
  clip-path: url(#SVGID_00000150808622784915680770000016390980281631073168_);
}

.st331 {
  clip-path: url(#SVGID_00000010310022826660801110000015083309328415548812_);
  fill: #91B1A5;
}

.st332 {
  clip-path: url(#SVGID_00000126325256358319543490000011606763626948861345_);
}

.st333 {
  clip-path: url(#SVGID_00000139268417640477237620000014120796427020293033_);
  fill: #8BA79D;
}

.st334 {
  clip-path: url(#SVGID_00000023970406786744834990000002011749004457219761_);
}

.st335 {
  clip-path: url(#SVGID_00000149378049055306278940000016840497268361699497_);
  fill: #91B1A5;
}

.st336 {
  clip-path: url(#SVGID_00000159437641302137376750000008460379106140656062_);
}

.st337 {
  clip-path: url(#SVGID_00000031925736799972989170000014943098867300588208_);
  fill: #8BA79D;
}

.st338 {
  clip-path: url(#SVGID_00000159448549928575717380000018428333351490045332_);
}

.st339 {
  clip-path: url(#SVGID_00000001644746239878079240000008728025423447891367_);
  fill: #6E9084;
}

.st340 {
  clip-path: url(#SVGID_00000137127768488378301710000014355937937023190462_);
}

.st341 {
  clip-path: url(#SVGID_00000108998766709331759110000005315087927330154395_);
  fill: #165748;
}

.st342 {
  clip-path: url(#SVGID_00000087376028638546885670000008116999322147764910_);
}

.st343 {
  clip-path: url(#SVGID_00000034791075417241391010000008733306139653483185_);
  fill: #165748;
}

.st344 {
  clip-path: url(#SVGID_00000139993437845813756100000015608231668583115192_);
}

.st345 {
  clip-path: url(#SVGID_00000092437360545472893590000000238571673851790224_);
  fill: #EBEAE6;
}

.st346 {
  clip-path: url(#SVGID_00000003823313467108843720000005029934849748292764_);
}

.st347 {
  clip-path: url(#SVGID_00000127027008529309749550000012327010636449735099_);
  fill: #DCDDD7;
}

.st348 {
  clip-path: url(#SVGID_00000182494702364374937770000002898122926232059578_);
}

.st349 {
  clip-path: url(#SVGID_00000034088405162265797770000009084756046252843179_);
  fill: #868B89;
}

.st350 {
  clip-path: url(#SVGID_00000129892642185396542790000007476651499864293309_);
}

.st351 {
  clip-path: url(#SVGID_00000091005901897987565450000006667518929968813751_);
  fill: #DCDDD7;
}

.st352 {
  clip-path: url(#SVGID_00000016072609837860798870000003384094152101369761_);
}

.st353 {
  clip-path: url(#SVGID_00000039107498058737075010000008442137238204027276_);
  fill: #999C9A;
}

.st354 {
  clip-path: url(#SVGID_00000170986029154115183870000003233131767118927780_);
}

.st355 {
  clip-path: url(#SVGID_00000096060078285941457940000009559068590039686784_);
  fill: #999C9A;
}

.st356 {
  clip-path: url(#SVGID_00000041985717439503715010000005034415242146592663_);
}

.st357 {
  clip-path: url(#SVGID_00000129203759056785988460000015939766501281200032_);
  fill: #98CAB7;
}

.st358 {
  clip-path: url(#SVGID_00000072269519096312992430000011215706288431861928_);
}

.st359 {
  clip-path: url(#SVGID_00000059295667241287607560000013136131380549486003_);
  fill: #6E9A8A;
}

.st360 {
  clip-path: url(#SVGID_00000106114835121799431700000006880947816120158376_);
}

.st361 {
  clip-path: url(#SVGID_00000072271450347710312920000016630975237116401826_);
  fill: #6B59A6;
}

.st362 {
  clip-path: url(#SVGID_00000043454795015567556590000017632857762827741115_);
}

.st363 {
  clip-path: url(#SVGID_00000155106559122738460530000016579626059990223281_);
  fill: #699085;
}

.st364 {
  clip-path: url(#SVGID_00000039136272364430565970000009075919898879453601_);
}

.st365 {
  clip-path: url(#SVGID_00000134244271766830226740000010046391184502298277_);
  fill: #98CAB7;
}

.st366 {
  clip-path: url(#SVGID_00000057138734196348557990000002464555879451846018_);
}

.st367 {
  clip-path: url(#SVGID_00000034810550800816101860000003268080440672733102_);
  fill: #679384;
}

.st368 {
  clip-path: url(#SVGID_00000089545187856908168230000017833702342298448792_);
}

.st369 {
  clip-path: url(#SVGID_00000036968655762703291850000002402359538054143873_);
  fill: #6B59A6;
}

.st370 {
  clip-path: url(#SVGID_00000134943000613157042870000008681338543016986045_);
}

.st371 {
  clip-path: url(#SVGID_00000128466021136822468390000015670872497193855415_);
  fill: #6B59A6;
}

.st372 {
  clip-path: url(#SVGID_00000104685172774979644130000011716487011272804520_);
}

.st373 {
  clip-path: url(#SVGID_00000127748587254914691740000007604781005769131923_);
  fill: #6B59A6;
}

.st374 {
  clip-path: url(#SVGID_00000148656678782138995340000013229085041245023381_);
}

.st375 {
  clip-path: url(#SVGID_00000029763633175836600230000010860459703756643729_);
  fill: #6B59A6;
}

.st376 {
  clip-path: url(#SVGID_00000161624550345841361380000002914330070357386394_);
}

.st377 {
  clip-path: url(#SVGID_00000142859355405223653230000005886953936187808920_);
  fill: #547E6F;
}

.st378 {
  clip-path: url(#SVGID_00000063591752779965789920000012326998771484246168_);
}

.st379 {
  clip-path: url(#SVGID_00000179617281271670247390000004167665339361090198_);
  fill: #C7D9D0;
}

.st380 {
  clip-path: url(#SVGID_00000008110159947119751730000008092798668393570992_);
}

.st381 {
  clip-path: url(#SVGID_00000105411582505275610120000011891750376045389441_);
  fill: #C7D9D0;
}

.st382 {
  clip-path: url(#SVGID_00000120555640527584845520000015593150470263135668_);
}

.st383 {
  clip-path: url(#SVGID_00000053543184398093159860000008008100688159457201_);
  fill: #C7D9D0;
}

.st384 {
  fill: #E0E1DB;
}

.st385 {
  clip-path: url(#SVGID_00000141422180955831885840000013424505878078155198_);
}

.st386 {
  clip-path: url(#SVGID_00000013913316367166665000000011608602127421209771_);
  enable-background: new;
}

.st387 {
  clip-path: url(#SVGID_00000051342647059776620270000002338627203139072407_);
}

.st388 {
  clip-path: url(#SVGID_00000052084090605967969170000006436170324929610143_);
}

.st389 {
  opacity: 0;
  clip-path: url(#SVGID_00000126295327434411869070000008379541903479959169_);
}

.st390 {
  clip-path: url(#SVGID_00000136403138455800578240000004148234169799512478_);
}

.st391 {
  clip-path: url(#SVGID_00000158001159988975991690000009272947583151440294_);
}

.st392 {
  clip-path: url(#SVGID_00000047765073197977974640000004776298526069472700_);
  fill: #6B59A6;
}

.st393 {
  clip-path: url(#SVGID_00000155117589862620740920000015615453580677597107_);
}

.st394 {
  clip-path: url(#SVGID_00000150796511231379731210000016429595561551742877_);
  enable-background: new;
}

.st395 {
  clip-path: url(#SVGID_00000068656033039697903180000002472025278583697312_);
}

.st396 {
  clip-path: url(#SVGID_00000052079367164053915000000002894847336964315777_);
}

.st397 {
  opacity: 0;
  clip-path: url(#SVGID_00000007409391352755488970000006603867453857186958_);
}

.st398 {
  clip-path: url(#SVGID_00000176754409100027280600000016804711123372433801_);
}

.st399 {
  clip-path: url(#SVGID_00000106861365056507483450000011111977728916426895_);
}

.st400 {
  clip-path: url(#SVGID_00000016762406943175161780000002614253493062781885_);
  fill: #3E3F6F;
}

.st401 {
  opacity: 0.1;
}

.st402 {
  fill: #1F715C;
}

.st403 {
  fill: #A5B5BB;
}

.st404 {
  fill: #49BD99;
}

.st405 {
  fill: #2A2C2F;
}

.st406 {
  fill: #FFFFFF;
}

.st407 {
  fill: #434648;
}

.st408 {
  fill: #231F20;
}

.st409 {
  fill: #14604E;
}

.st410 {
  opacity: 0.8;
  fill: #2A2C2F;
}

.st411 {
  fill: #79AA9D;
}

.st412 {
  fill: url(#SVGID_00000115494911501734142890000000736335224822884763_);
}

.st413 {
  fill: #AFB4C4;
}

.st414 {
  fill: url(#SVGID_00000151539841513684026040000000648389908434505116_);
}

.st415 {
  fill: #EEF0F5;
}

.st416 {
  fill: #C8CEDB;
}

.st417 {
  enable-background: new;
}

.st418 {
  clip-path: url(#SVGID_00000000224278067068503870000005421451737891927953_);
  enable-background: new;
}

.st419 {
  fill: #0D3F33;
}

.st420 {
  clip-path: url(#SVGID_00000036211135396859614490000010146033138692192649_);
  enable-background: new;
}

.st421 {
  fill: #0A3229;
}

.st422 {
  fill: #115444;
}

.st423 {
  fill: #0A3027;
}

.st424 {
  clip-path: url(#SVGID_00000090984326494630152180000001508682246351920547_);
  enable-background: new;
}

.st425 {
  fill: #0C3A2F;
}

.st426 {
  fill: #0C3C30;
}

.st427 {
  fill: #0D3D32;
}

.st428 {
  fill: #0C382D;
}

.st429 {
  fill: #0B362C;
}

.st430 {
  fill: #0B342A;
}

.st431 {
  opacity: 0.7;
}

.st432 {
  clip-path: url(#SVGID_00000076570055454999546050000005880195720219305346_);
  enable-background: new;
}

.st433 {
  fill: #608E80;
}

.st434 {
  clip-path: url(#SVGID_00000181774906999934830620000009471674131729693337_);
  enable-background: new;
}

.st435 {
  fill: #588174;
}

.st436 {
  fill: #5B8578;
}

.st437 {
  fill: #5D8A7C;
}

.st438 {
  clip-path: url(#SVGID_00000044177824521901507920000017983071969354778025_);
  enable-background: new;
}

.st439 {
  fill: #557D71;
}

.st440 {
  fill: #52786D;
}

.st441 {
  fill: #4F7469;
}

.st442 {
  fill: #4C7065;
}

.st443 {
  clip-path: url(#SVGID_00000005248710751450335220000011506561819911226501_);
  enable-background: new;
}

.st444 {
  clip-path: url(#SVGID_00000130605098741222965950000018115088884558734474_);
  enable-background: new;
}

.st445 {
  clip-path: url(#SVGID_00000067947885607038430760000018186940052663861669_);
  enable-background: new;
}

.st446 {
  clip-path: url(#SVGID_00000005978728857573685370000005751362051552986041_);
  enable-background: new;
}

.st447 {
  clip-path: url(#SVGID_00000008865349134226582540000003994573021782718882_);
  enable-background: new;
}

.st448 {
  clip-path: url(#SVGID_00000153696974285409796450000000290659375117711792_);
  enable-background: new;
}

.st449 {
  clip-path: url(#SVGID_00000079462920506517213900000013355077829695315868_);
  enable-background: new;
}

.st450 {
  fill: #7FBCA9;
}

.st451 {
  clip-path: url(#SVGID_00000133516500022201527540000006597079231373134485_);
  enable-background: new;
}

.st452 {
  fill: #496C61;
}

.st453 {
  fill: #255F4D;
}

.st454 {
  clip-path: url(#SVGID_00000010313179905297231230000010808680838715738548_);
  enable-background: new;
}

.st455 {
  fill: #307D65;
}

.st456 {
  fill: #2F7962;
}

.st457 {
  fill: #2D755F;
}

.st458 {
  clip-path: url(#SVGID_00000088132880652224658380000000665921168065657263_);
  enable-background: new;
}

.st459 {
  fill: #266250;
}

.st460 {
  fill: #276653;
}

.st461 {
  fill: #296A56;
}

.st462 {
  fill: #2A6E59;
}

.st463 {
  fill: #2C715C;
}

.st464 {
  fill: #40A586;
}

.st465 {
  clip-path: url(#SVGID_00000007406696986830078990000011894943326026514562_);
  enable-background: new;
}

.st466 {
  clip-path: url(#SVGID_00000121258315303781655970000001688937112081941161_);
  enable-background: new;
}

.st467 {
  clip-path: url(#SVGID_00000171684472691019948000000009596343415579839368_);
  enable-background: new;
}

.st468 {
  clip-path: url(#SVGID_00000091003607131874605830000005362113684694029218_);
  enable-background: new;
}

.st469 {
  clip-path: url(#SVGID_00000040567365068894789100000011986185951101247419_);
  enable-background: new;
}

.st470 {
  clip-path: url(#SVGID_00000001652744375251154850000010286616445970199480_);
  enable-background: new;
}

.st471 {
  clip-path: url(#SVGID_00000124875841728415178590000006804671683793216948_);
  enable-background: new;
}

.st472 {
  clip-path: url(#SVGID_00000006690674701059577530000010768235741002460045_);
  enable-background: new;
}

.st473 {
  clip-path: url(#SVGID_00000103986202830833263240000015567985339142634929_);
  enable-background: new;
}

.st474 {
  clip-path: url(#SVGID_00000017486044597088071230000017172433690558379455_);
  enable-background: new;
}

.st475 {
  fill: #33836A;
}

.st476 {
  fill: url(#SVGID_00000154410900144868770960000009018040724749167756_);
}

.st477 {
  fill: url(#SVGID_00000182497272714985001080000016267050925014583473_);
}

.st478 {
  fill: url(#SVGID_00000114050793891771520640000005924043316238963133_);
}

.st479 {
  fill: url(#SVGID_00000119078253828604597770000010039683867166924938_);
}

.st480 {
  fill: url(#SVGID_00000022559955371421287580000003924808149517155737_);
}

.st481 {
  fill: url(#SVGID_00000075148914104299873690000017024376243195159983_);
}

.st482 {
  fill: url(#SVGID_00000140004304097353146390000000392327042406924933_);
}

.st483 {
  fill: url(#SVGID_00000014599779024947629380000011568184358347664569_);
}

.st484 {
  fill: url(#SVGID_00000006696965513332277850000014568581711123886778_);
}

.st485 {
  fill: url(#SVGID_00000066485970853341252140000011697480361217708446_);
}

.st486 {
  fill: url(#SVGID_00000183944222022430212540000002575033421928193717_);
}

.st487 {
  fill: url(#SVGID_00000047062554899173165830000000161559474442426242_);
}

.st488 {
  fill: url(#SVGID_00000122716179261327085050000012571263843636717213_);
}

.st489 {
  fill: url(#SVGID_00000069368740048134277730000008287998584677657736_);
}

.st490 {
  fill: url(#SVGID_00000019656234248963274060000017562406372816175750_);
}

.st491 {
  fill: url(#SVGID_00000176726848466465430070000016631419875928421536_);
}

.st492 {
  fill: url(#SVGID_00000006680427133468964490000010411150808314464677_);
}

.st493 {
  fill: url(#SVGID_00000092432844500509404460000012492392743989504932_);
}

.st494 {
  fill: url(#SVGID_00000146481395145400670140000004338951242799457412_);
}

.st495 {
  fill: url(#SVGID_00000076563888144054114010000017631211457489261484_);
}

.st496 {
  fill: url(#SVGID_00000147183612656798406560000005956645958759673529_);
}

.st497 {
  fill: url(#SVGID_00000020389183840107385190000002741933438877408672_);
}

.st498 {
  fill: url(#SVGID_00000130640775309750788260000014000929146247969963_);
}

.st499 {
  fill: url(#SVGID_00000012461546692399582110000005839231171458742704_);
}

.st500 {
  fill: url(#SVGID_00000016788502609386515890000014514961496797013168_);
}

.st501 {
  fill: url(#SVGID_00000014595361850876807030000002977642530660637324_);
}

.st502 {
  fill: url(#SVGID_00000162322283185522147040000011870787220808792491_);
}

.st503 {
  fill: url(#SVGID_00000072958505149523133940000004213235113759264151_);
}

.st504 {
  fill: url(#SVGID_00000093874567651959149500000007737357903974385580_);
}

.st505 {
  fill: url(#SVGID_00000106139392083936129830000001746910522390772908_);
}

.st506 {
  fill: url(#SVGID_00000038388758125556512750000012799698400017577863_);
}

.st507 {
  fill: url(#SVGID_00000007400456808447346010000005074289366572478112_);
}

.st508 {
  fill: url(#SVGID_00000030450665801528421450000012293577203177977519_);
}

.st509 {
  fill: url(#SVGID_00000132077728175537906090000000119958113662817156_);
}

.st510 {
  fill: url(#SVGID_00000092451929994738368690000006437416784991242417_);
}

.st511 {
  fill: url(#SVGID_00000015314527767938056840000015357834392082157743_);
}

.st512 {
  fill: url(#SVGID_00000125579357518598908620000014441464398184913592_);
}

.st513 {
  fill: url(#SVGID_00000179648095704201071480000017796347219151151272_);
}

.st514 {
  fill: url(#SVGID_00000022532066094106681130000007918251111086384817_);
}

.st515 {
  fill: url(#SVGID_00000083800607956311573380000007256154490999600829_);
}

.st516 {
  fill: url(#SVGID_00000021100267421515383010000017879210737928798348_);
}

.st517 {
  fill: url(#SVGID_00000104678140736294509770000018416989789296744585_);
}

.st518 {
  fill: url(#SVGID_00000098214626527533686960000016249431380548298667_);
}

.st519 {
  fill: url(#SVGID_00000150069572729535634730000003914156259816316559_);
}

.st520 {
  fill: url(#SVGID_00000171710768814358666060000018370513689688581016_);
}

.st521 {
  fill: url(#SVGID_00000142173121233222358510000001709065834720452014_);
}

.st522 {
  fill: url(#SVGID_00000024712293050655780380000016558453859026548635_);
}

.st523 {
  fill: url(#SVGID_00000109709724701732978640000007339217144707350456_);
}

.st524 {
  fill: url(#SVGID_00000159442314234529554790000011322515227214494593_);
}

.st525 {
  fill: url(#SVGID_00000133530657277788529300000017660556898839667590_);
}

.st526 {
  fill: url(#SVGID_00000007405983532042648320000016764100457806215101_);
}

.st527 {
  fill: url(#SVGID_00000006710261468619668300000017774579713128473754_);
}

.st528 {
  fill: url(#SVGID_00000046326483435478593870000013838620726889382287_);
}

.st529 {
  fill: url(#SVGID_00000104678427848514128420000012384807184427848630_);
}

.st530 {
  fill: url(#SVGID_00000036236390806506068690000001853012568639043504_);
}

.st531 {
  fill: url(#SVGID_00000138533056554773705320000000138870893997580930_);
}

.st532 {
  fill: url(#SVGID_00000096048615296235900090000006807235824065144217_);
}

.st533 {
  fill: url(#SVGID_00000067238356250470003710000007246696333442899130_);
}

.st534 {
  fill: url(#SVGID_00000023981816759234916190000013100270897950100390_);
}

.st535 {
  fill: url(#SVGID_00000090264207427287552570000004083218746180638903_);
}

.st536 {
  fill: url(#SVGID_00000066503626001569865130000001607411823993156224_);
}

.st537 {
  fill: url(#SVGID_00000174590026901511885790000011981539314233231236_);
}

.st538 {
  fill: url(#SVGID_00000167356107164246888300000011770058897925808009_);
}

.st539 {
  fill: url(#SVGID_00000026165173617383805570000004900883702324887987_);
}

.st540 {
  fill: url(#SVGID_00000172441289768304535310000005620279988679845302_);
}

.st541 {
  fill: url(#SVGID_00000039126105597243489290000014412548627239775637_);
}

.st542 {
  fill: url(#SVGID_00000162320997714114894790000008458151060104608923_);
}

.st543 {
  fill: url(#SVGID_00000083052994775784107840000005962056693628247479_);
}

.st544 {
  fill: url(#SVGID_00000031196643998837290440000005234987948461262474_);
}

.st545 {
  fill: url(#SVGID_00000096045725269645559590000009918438834234348942_);
}

.st546 {
  fill: url(#SVGID_00000026883814475093824290000002657732600091268270_);
}

.st547 {
  fill: url(#SVGID_00000000223677009326431710000017491041986052766876_);
}

.st548 {
  fill: url(#SVGID_00000162326629374688667460000001459361255957748657_);
}

.st549 {
  fill: url(#SVGID_00000065064807953229784850000002196557940466098056_);
}

.st550 {
  fill: url(#SVGID_00000072993812635625964800000016172890593718060215_);
}

.st551 {
  fill: url(#SVGID_00000088117435001658766130000017269711805500891047_);
}

.st552 {
  fill: url(#SVGID_00000080892720283936139900000017423398769931384730_);
}

.st553 {
  fill: url(#SVGID_00000070082115892280072520000013102075511839354286_);
}

.st554 {
  fill: url(#SVGID_00000150803706678141513910000005943083591120382365_);
}

.st555 {
  fill: url(#SVGID_00000167359749216918874900000013065428604303349139_);
}

.st556 {
  fill: url(#SVGID_00000173881681855407498010000010783982410312787364_);
}

.st557 {
  fill: url(#SVGID_00000157277001378677317170000001131225783105763224_);
}

.st558 {
  fill: url(#SVGID_00000050632419973411738710000001938055867824183231_);
}

.st559 {
  opacity: 0.2;
}

.st560 {
  opacity: 9.090909e-02;
}

.st561 {
  opacity: 0.1818;
}

.st562 {
  opacity: 0.2727;
}

.st563 {
  opacity: 0.3636;
}

.st564 {
  opacity: 0.4545;
}

.st565 {
  opacity: 0.5455;
}

.st566 {
  opacity: 0.6364;
}

.st567 {
  opacity: 0.7273;
}

.st568 {
  opacity: 0.8182;
}

.st569 {
  opacity: 0.9091;
}

.st570 {
  fill: url(#SVGID_00000103260106827680858510000013255117868472028858_);
}

.st571 {
  fill: url(#SVGID_00000133528699485554260630000011569607625446393271_);
}

.st572 {
  fill: url(#SVGID_00000042006800659892931250000016579322583130016188_);
}

.st573 {
  fill: url(#SVGID_00000176039132918066396590000011603918344822656932_);
}

.st574 {
  fill: url(#SVGID_00000088844158828064254790000011901772520158289081_);
}

.st575 {
  fill: #619788;
}

.st576 {
  fill: url(#SVGID_00000177466053609617089400000002873250897321331855_);
}

.st577 {
  fill: url(#SVGID_00000088835150456008818070000017574306500686795425_);
}

.st578 {
  fill: url(#SVGID_00000110454264145556606720000004354265477286335143_);
}

.st579 {
  fill: url(#SVGID_00000139267850297494326720000006144599872756877486_);
}

.st580 {
  fill: url(#SVGID_00000023247569868019853950000002662697705947243934_);
}

.st581 {
  fill: url(#SVGID_00000085930835665228942980000013142551157074189467_);
}

.st582 {
  fill: url(#SVGID_00000091695162477642435890000005076065169448886145_);
}

.st583 {
  fill: url(#SVGID_00000119088618037991573380000014890270570763943859_);
}

.st584 {
  fill: url(#SVGID_00000007406852292407515340000005627791272410341049_);
}

.st585 {
  fill: url(#SVGID_00000114776356285752465150000001028352527631643524_);
}

.st586 {
  opacity: 0.6;
  fill: #6B59A6;
}

.st587 {
  fill: url(#SVGID_00000044141123824645323690000017014181073027742109_);
}

.st588 {
  opacity: 0;
  fill: url(#SVGID_00000036968968280374084110000013690593653402140058_);
}

.st589 {
  opacity: 9.090909e-02;
  fill: url(#SVGID_00000030452067403505690490000006519479952584376223_);
}

.st590 {
  opacity: 0.1818;
  fill: url(#SVGID_00000055665931375641561300000001569703951015304322_);
}

.st591 {
  opacity: 0.2727;
  fill: url(#SVGID_00000042706163111322491460000011945068978100620431_);
}

.st592 {
  opacity: 0.3636;
  fill: url(#SVGID_00000106113714218729212690000013423671244783809163_);
}

.st593 {
  opacity: 0.4545;
  fill: url(#SVGID_00000042738717416540054820000010204875602939581849_);
}

.st594 {
  opacity: 0.5455;
  fill: url(#SVGID_00000046321331264461355450000011117787259156294810_);
}

.st595 {
  opacity: 0.6364;
  fill: url(#SVGID_00000091727978214742509960000017512293254649212059_);
}

.st596 {
  opacity: 0.7273;
  fill: url(#SVGID_00000054965280364803921020000003175871692972818873_);
}

.st597 {
  opacity: 0.8182;
  fill: url(#SVGID_00000131327370198386689350000008002435066910315696_);
}

.st598 {
  opacity: 0.9091;
  fill: url(#SVGID_00000120519674426382028370000015382330777140346278_);
}

.st599 {
  fill: url(#SVGID_00000136399588592978724400000009989839272264865721_);
}

.st600 {
  opacity: 0.7;
  fill: url(#SVGID_00000161606677819372120230000002117281861892671361_);
}

.st601 {
  opacity: 0.1;
  fill: url(#SVGID_00000090252371561543782580000001950538610494505097_);
}

.st602 {
  fill: url(#SVGID_00000110466820897122736230000006874312691343139239_);
}

.st603 {
  opacity: 0.5;
  fill: #2A2C2F;
}

.st604 {
  fill: url(#SVGID_00000140723491417841471640000002306996237194251954_);
}

.st605 {
  fill: #45494B;
}

.st606 {
  fill: #363B3D;
}

.st607 {
  fill: #5A5F60;
}

.st608 {
  fill: #35896F;
}

.st609 {
  clip-path: url(#SVGID_00000008832169954295496240000014163776475482138251_);
  enable-background: new;
}

.st610 {
  fill: #328168;
}

.st611 {
  fill: #33846B;
}

.st612 {
  fill: #35886E;
}

.st613 {
  fill: #368C71;
}

.st614 {
  fill: #379074;
}

.st615 {
  fill: #399377;
}

.st616 {
  fill: #3A977A;
}

.st617 {
  fill: #3C9B7D;
}

.st618 {
  fill: #3D9F81;
}

.st619 {
  fill: #3FA384;
}

.st620 {
  fill: #40A687;
}

.st621 {
  fill: #42AA8A;
}

.st622 {
  fill: #43AE8D;
}

.st623 {
  fill: #45B290;
}

.st624 {
  fill: #46B593;
}

.st625 {
  fill: #48B996;
}

.st626 {
  clip-path: url(#SVGID_00000153700373279248202080000017207185148032031638_);
  enable-background: new;
}

.st627 {
  clip-path: url(#SVGID_00000076599519800768382850000014535958999462977950_);
  enable-background: new;
}

.st628 {
  clip-path: url(#SVGID_00000024692642219715965800000012565243861145008574_);
  enable-background: new;
}

.st629 {
  clip-path: url(#SVGID_00000102519034757463861030000004214259532935655338_);
  enable-background: new;
}

.st630 {
  fill: #3EA081;
}

.st631 {
  clip-path: url(#SVGID_00000137816622407042205400000007586326383928707253_);
  enable-background: new;
}

.st632 {
  clip-path: url(#SVGID_00000071557772477925605310000013108034112841157022_);
  enable-background: new;
}

.st633 {
  clip-path: url(#SVGID_00000147898984777175700690000011608667619785480108_);
  enable-background: new;
}

.st634 {
  clip-path: url(#SVGID_00000114782305276481452320000005670037667320785595_);
  enable-background: new;
}

.st635 {
  clip-path: url(#SVGID_00000122684559465149386800000006211102275617522353_);
  enable-background: new;
}

.st636 {
  clip-path: url(#SVGID_00000028305492222069033510000009564720612012533177_);
  enable-background: new;
}

.st637 {
  clip-path: url(#SVGID_00000156557938276867992640000002680168316580965763_);
  enable-background: new;
}

.st638 {
  clip-path: url(#SVGID_00000061463761981180134780000001285544123925590199_);
  enable-background: new;
}

.st639 {
  fill: #3E9F81;
}

.st640 {
  fill: #2B715B;
}

.st641 {
  fill: #3D9E80;
}

.st642 {
  fill: #44B08E;
}

.st643 {
  clip-path: url(#SVGID_00000111158860456040309550000011178570609819066281_);
  enable-background: new;
}

.st644 {
  fill: #858585;
}

.st645 {
  fill: #8A8A8A;
}

.st646 {
  fill: #8F8F8F;
}

.st647 {
  fill: #949494;
}

.st648 {
  fill: #999999;
}

.st649 {
  fill: #9E9E9E;
}

.st650 {
  fill: #A3A3A3;
}

.st651 {
  fill: #A8A8A8;
}

.st652 {
  fill: #ADADAD;
}

.st653 {
  fill: #B3B3B3;
}

.st654 {
  fill: #B8B8B8;
}

.st655 {
  fill: #BDBDBD;
}

.st656 {
  fill: #C2C2C2;
}

.st657 {
  fill: #C7C7C7;
}

.st658 {
  fill: #CCCCCC;
}

.st659 {
  fill: #D1D1D1;
}

.st660 {
  fill: #D6D6D6;
}

.st661 {
  fill: #DBDBDB;
}

.st662 {
  fill: #E0E0E0;
}

.st663 {
  fill: #E6E6E6;
}

.st664 {
  fill: #EBEBEB;
}

.st665 {
  fill: #F0F0F0;
}

.st666 {
  fill: #F5F5F5;
}

.st667 {
  fill: #FAFAFA;
}

.st668 {
  clip-path: url(#SVGID_00000132068255984696347600000017870057139372170925_);
  enable-background: new;
}

.st669 {
  clip-path: url(#SVGID_00000091736246969936048320000009202792775114618542_);
  enable-background: new;
}

.st670 {
  clip-path: url(#SVGID_00000011001415857935831530000009693985506314504878_);
  enable-background: new;
}

.st671 {
  fill: #989898;
}

.st672 {
  clip-path: url(#SVGID_00000092451457197092439190000011577358493980719252_);
  enable-background: new;
}

.st673 {
  clip-path: url(#SVGID_00000105404522732138236700000005863997279743638158_);
  enable-background: new;
}

.st674 {
  fill: #D8D8D8;
}

.st675 {
  clip-path: url(#SVGID_00000132082329682498058540000011714762602063581320_);
  enable-background: new;
}

.st676 {
  clip-path: url(#SVGID_00000012450203777973101860000008726689948492932517_);
  enable-background: new;
}

.st677 {
  clip-path: url(#SVGID_00000016789306682380919170000006813529911115258552_);
  enable-background: new;
}

.st678 {
  clip-path: url(#SVGID_00000127754979471154749560000008515238841241588412_);
  enable-background: new;
}

.st679 {
  clip-path: url(#SVGID_00000133523123425011323230000004047261477259611788_);
  enable-background: new;
}

.st680 {
  clip-path: url(#SVGID_00000119820579717415183360000000405973686747528349_);
  enable-background: new;
}

.st681 {
  clip-path: url(#SVGID_00000126293735250002808250000000204018961162567818_);
  enable-background: new;
}

.st682 {
  clip-path: url(#SVGID_00000002362779903011921950000000778898698292562097_);
  enable-background: new;
}

.st683 {
  clip-path: url(#SVGID_00000071560444604150169180000016386583852204652712_);
  enable-background: new;
}

.st684 {
  clip-path: url(#SVGID_00000001653739318463654720000008314389775251829653_);
  enable-background: new;
}

.st685 {
  clip-path: url(#SVGID_00000098905501415797791950000010252265254036428966_);
  enable-background: new;
}

.st686 {
  clip-path: url(#SVGID_00000080886173480888422990000010442479402995591610_);
  enable-background: new;
}

.st687 {
  clip-path: url(#SVGID_00000054241641310555347040000017210966460137550742_);
  enable-background: new;
}

.st688 {
  clip-path: url(#SVGID_00000101099155086755747800000011001074953877141144_);
  enable-background: new;
}

.st689 {
  clip-path: url(#SVGID_00000011713321097150715170000017587900350776975528_);
  enable-background: new;
}

.st690 {
  clip-path: url(#SVGID_00000017514877654348882800000006380496788673463454_);
  enable-background: new;
}

.st691 {
  clip-path: url(#SVGID_00000056390338779722804260000001742092417713160069_);
  enable-background: new;
}

.st692 {
  clip-path: url(#SVGID_00000116915469847333903120000013907591719650500754_);
  enable-background: new;
}

.st693 {
  fill: #685AA1;
}
</style>
